var _metadata, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFuturaCyrillicLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by FontForge 20190801 at Wed Dec 29 15:14:30 2021\n By www-data\nCopyright (c) 1995 ParaGraph Intl., (c) 1998 ParaType Inc., ParaType Ltd. All rights reserved.\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "FuturaCyrillicLight",
    horizAdvX: 500
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "FuturaCyrillicLight",
    fontWeight: 300,
    fontStretch: "normal",
    unitsPerEm: 1000,
    panose1: "2 11 4 2 2 2 4 2 3 3",
    ascent: 763,
    descent: -237,
    xHeight: 408,
    capHeight: 667,
    bbox: "-298 -250 970 867",
    underlineThickness: 50,
    underlinePosition: -100,
    unicodeRange: "U+0020-FB02"
  }), /*#__PURE__*/React.createElement("missingGlyph", {
    horizAdvX: 233
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10017.var.accented",
    unicode: "\u0410`",
    horizAdvX: 586,
    d: "M524 0l-89 219h-284l-89 -219h-48l281 687l277 -687h-48zM167 259h252l-125 316zM359 854l50 -25l-134 -126l-32 18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10022.var.accented",
    unicode: "\u0415`",
    horizAdvX: 464,
    d: "M410 667v-40h-276v-242h270v-40h-270v-305h276v-40h-320v667h320zM298 854l50 -25l-134 -126l-32 18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10026.var.accented",
    unicode: "\u0418`",
    horizAdvX: 700,
    d: "M566 0v556l-476 -573v684h44v-566l476 573v-674h-44zM416 854l50 -25l-134 -126l-32 18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10032.var.accented",
    unicode: "\u041E`",
    horizAdvX: 800,
    d: "M400 676q146 0 246 -100t100 -244t-100 -243.5t-246 -99.5t-246 99.5t-100 243.5t100 244t246 100zM400 29q128 0 214 87.5t86 215.5q0 129 -86 216.5t-214 87.5t-214 -87.5t-86 -216.5q0 -128 86 -215.5t214 -87.5zM466 854l50 -25l-134 -126l-32 18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10037.var.accented",
    unicode: "\u0423`",
    horizAdvX: 550,
    d: "M14 667h50l231 -432l195 432h46l-305 -667h-46l85 186zM341 854l50 -25l-134 -126l-32 18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10045.var.accented",
    unicode: "\u042B`",
    horizAdvX: 690,
    d: "M90 0v667h44v-287h116q230 0 230 -183q0 -83 -53.5 -140t-162.5 -57h-174zM134 340v-300h112q101 0 146 44q42 40 42 113q0 87 -69 123q-39 20 -127 20h-104zM556 667h44v-667h-44v667zM411 854l50 -25l-134 -126l-32 18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10047.var.accented",
    unicode: "\u042D`",
    horizAdvX: 678,
    d: "M54 72v58q48 -52 108 -76.5t116 -24.5q114 0 205 81t95 214h-444v40h442q-11 118 -96.5 195t-200.5 77q-65 0 -123.5 -27.5t-101.5 -77.5v58q92 87 224 87q144 0 245 -100t101 -244q0 -141 -100 -242t-248 -101q-128 0 -222 83zM365 854l50 -25l-134 -126l-32 18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10048.var.accented",
    unicode: "\u042E`",
    horizAdvX: 960,
    d: "M134 372h102q15 132 110 218t224 86q142 0 239 -100t97 -244t-97 -243.5t-239 -99.5t-238 100t-98 243h-100v-332h-44v667h44v-295zM570 29q125 0 207.5 87.5t82.5 215.5t-83 216t-207 88t-207 -88t-83 -216t82.5 -215.5t207.5 -87.5zM546 854l50 -25l-134 -126l-32 18z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10049.var.accented",
    unicode: "\u042F`",
    horizAdvX: 470,
    d: "M34 0l202 299q-38 1 -75 15q-13 5 -26.5 13.5t-34 27t-33.5 52t-13 76.5q0 59 26 98.5t61 59.5q44 26 125 26h114v-667h-44v299h-50l-200 -299h-52zM336 627h-70q-58 0 -91 -16q-35 -16 -55 -50t-20 -78q0 -70 44 -109q39 -35 116 -35h76v288zM301 854l50 -25l-134 -126 l-32 18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10023.var.accented",
    unicode: "\u0401`",
    horizAdvX: 464,
    d: "M410 667v-40h-276v-242h270v-40h-270v-305h276v-40h-320v667h320zM103 780q0 16 11 27t27 11t27 -11t11 -27t-11 -27t-27 -11t-27 11t-11 27zM319 780q0 16 11 27t27 11t27 -11t11 -27t-11 -27t-27 -11t-27 11t-11 27zM282 854l44 -25l-134 -126l-26 18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10065.var.accented",
    unicode: "\u0430`",
    horizAdvX: 516,
    d: "M404 337v71h40v-408h-40v73q-55 -84 -159 -84q-83 0 -141 59t-58 156q0 95 55 154t144 59q102 0 159 -80zM247 379q-65 0 -112 -46.5t-47 -125.5q0 -73 43 -126.5t117 -53.5q73 0 115.5 52.5t42.5 127.5q0 83 -49 127.5t-110 44.5zM313 620l43 -25l-105 -128l-30 16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10070.var.accented",
    unicode: "\u0435`",
    horizAdvX: 483,
    d: "M437 199h-349q0 -76 47.5 -124t114.5 -48q48 0 85 25.5t57 67.5l34 -20q-23 -44 -67 -77.5t-112 -33.5q-93 0 -147 60.5t-54 152.5q0 101 58.5 158t139.5 57q83 0 138 -61t55 -157zM91 237h304q-8 62 -49.5 102t-101.5 40q-61 0 -103 -40.5t-50 -101.5zM296 620l43 -25 l-105 -128l-30 16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10074.var.accented",
    unicode: "\u0438`",
    horizAdvX: 474,
    d: "M72 408h40v-327l290 350v-431h-40v325l-290 -350v433zM292 620l43 -25l-105 -128l-30 16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10080.var.accented",
    unicode: "\u043E`",
    horizAdvX: 520,
    d: "M260 417q91 0 152.5 -61.5t61.5 -152.5t-61.5 -152.5t-152.5 -61.5t-152.5 61.5t-61.5 152.5t61.5 152.5t152.5 61.5zM260 27q73 0 122.5 51t49.5 125t-49.5 125t-122.5 51t-122.5 -51t-49.5 -125t49.5 -125t122.5 -51zM315 620l43 -25l-105 -128l-30 16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10085.var.accented",
    unicode: "\u0443`",
    horizAdvX: 428,
    d: "M106 -230l96 223l-194 415h46l171 -363l149 363h46l-268 -638h-46zM269 620l43 -25l-105 -128l-30 16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10093.var.accented",
    unicode: "\u044B`",
    d: "M72 408h40v-170h97q70 0 104 -38q29 -32 29 -81q0 -55 -36 -88q-33 -31 -98 -31h-136v408zM112 38h96q42 0 64 19q28 23 28 62q0 41 -29 63q-24 18 -65 18h-94v-162zM388 408h40v-408h-40v408zM305 620l43 -25l-105 -128l-30 16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10095.var.accented",
    unicode: "\u044D`",
    horizAdvX: 412,
    d: "M38 10v42q45 -25 110 -25q83 0 132 53q41 43 44 110h-239v38h239q-8 74 -67 118q-46 33 -112 33q-63 0 -103 -21v40q50 19 103 19q95 0 153 -51q68 -59 68 -161q0 -99 -61 -158q-60 -58 -157 -58q-67 0 -110 21zM231 620l43 -25l-105 -128l-30 16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10096.var.accented",
    unicode: "\u044E`",
    horizAdvX: 640,
    d: "M112 228h70q9 82 66.5 135.5t139.5 53.5q88 0 147 -61.5t59 -152.5t-59 -152.5t-147 -61.5q-82 0 -142 55.5t-64 145.5h-70v-190h-40v408h40v-180zM388 27q70 0 117 50.5t47 125.5t-47 125.5t-117 50.5t-117 -50.5t-47 -125.5t47 -125.5t117 -50.5zM375 620l43 -25 l-105 -128l-30 16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10097.var.accented",
    unicode: "\u044F`",
    horizAdvX: 386,
    d: "M28 0l130 178q-47 2 -80 30q-34 30 -34 81q0 59 37 90q33 29 97 29h136v-408h-40v176h-70l-128 -176h-48zM274 214v156h-96q-42 0 -65 -18q-27 -23 -27 -62q0 -38 26 -58q24 -18 66 -18h96zM248 620l43 -25l-105 -128l-30 16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10071.var.accented",
    unicode: "\u0451`",
    horizAdvX: 483,
    d: "M437 199h-349q-3 -73 47 -125q45 -47 115 -47q48 0 86 26q36 26 56 67l34 -20q-28 -50 -70 -79q-46 -32 -109 -32q-85 0 -142 55q-59 57 -59 158t61 160q56 55 137 55q80 0 133 -53q62 -62 60 -165zM91 237h304q-8 61 -46 99q-43 43 -105 43q-60 0 -106 -44 q-40 -40 -47 -98zM115 526q0 15 10.5 25.5t25.5 10.5t25.5 -10.5t10.5 -25.5t-10.5 -25.5t-25.5 -10.5t-25.5 10.5t-10.5 25.5zM301 526q0 15 10.5 25.5t25.5 10.5t25.5 -10.5t10.5 -25.5t-10.5 -25.5t-25.5 -10.5t-25.5 10.5t-10.5 25.5zM280 620l37 -25l-105 -128l-24 16z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fi",
    unicode: "fi",
    horizAdvX: 442,
    d: "M214 370h-102v-370h-40v370h-46v38h46v163q0 75 22 109q42 61 127 61t127 -61q22 -34 22 -109v-17h-40v17q0 60 -17 88q-26 44 -92 44q-65 0 -92 -44q-17 -28 -17 -88v-163h102v-38zM330 408h40v-408h-40v408z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fl",
    unicode: "fl",
    horizAdvX: 442,
    d: "M214 370h-102v-370h-40v370h-46v38h46v163q0 75 22 109q42 61 127 61t127 -61q22 -34 22 -109v-571h-40v571q0 60 -17 88q-27 44 -92 44t-92 -44q-17 -27 -17 -88v-163h102v-38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".notdef",
    horizAdvX: 233
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".null",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nonmarkingreturn",
    horizAdvX: 333
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "space",
    unicode: " ",
    horizAdvX: 233
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclam",
    unicode: "!",
    horizAdvX: 260,
    d: "M152 119h-44v548h44v-548zM93 30q0 16 10.5 26.5t26.5 10.5t26.5 -10.5t10.5 -26.5t-10.5 -26.5t-26.5 -10.5t-26.5 10.5t-10.5 26.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedbl",
    unicode: "\"",
    horizAdvX: 280,
    d: "M104 667l-7 -269h-30l-7 269h44zM220 667l-7 -269h-30l-7 269h44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "numbersign",
    unicode: "#",
    horizAdvX: 600,
    d: "M375 0h-40l33 221h-164l-33 -221h-40l33 221h-118l6 38h118l24 161h-118l6 38h118l32 209h40l-32 -209h164l32 209h40l-32 -209h118l-6 -38h-118l-24 -161h118l-6 -38h-118zM374 259l24 161h-164l-24 -161h164z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dollar",
    unicode: "$",
    horizAdvX: 548,
    d: "M443 581l-32 -27q-5 12 -13.5 25t-34 32.5t-56.5 24.5v-270q70 -32 99 -53q71 -49 71 -129q0 -68 -47 -124t-123 -68v-99h-40v96q-93 0 -153 70q-29 34 -43 73l38 18q12 -36 36 -64q44 -55 122 -57v310l-25 12q-48 23 -72 40.5t-39 42.5q-21 35 -21 76q0 68 44 115.5 t113 50.5v89h40v-89q93 -11 136 -95zM307 319v-287q56 12 90 55t34 96q0 65 -65 105q-2 1 -8 4.5t-19 10.5t-32 16zM267 386v250q-51 -3 -81 -40t-30 -84q0 -44 27 -73.5t84 -52.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "percent",
    unicode: "%",
    horizAdvX: 608,
    d: "M169 673q61 0 98 -37t37 -94t-37 -94t-98 -37t-98 37t-37 94t37 94t98 37zM169 447q45 0 70 29t25 66t-25 66t-70 29t-70 -29t-25 -66t25 -66t70 -29zM92 1l394 681l30 -16l-394 -681zM439 256q61 0 98 -37t37 -94t-37 -94t-98 -37t-98 37t-37 94t37 94t98 37zM439 30 q45 0 70 29t25 66t-25 66t-70 29t-70 -29t-25 -66t25 -66t70 -29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ampersand",
    unicode: "&",
    horizAdvX: 628,
    d: "M567 259l32 -27q-39 -53 -85 -97l100 -135h-56l-77 105q-76 -63 -118 -85q-65 -33 -124 -33q-73 0 -121 46q-52 50 -52 126q0 73 44 126q27 33 84 71l71 46q-39 61 -53 89.5t-14 58.5q0 54 38 92q36 37 92 37q49 0 85 -33q37 -34 37 -91q0 -58 -49 -107q-24 -24 -75 -58 l163 -220q34 34 78 89zM456 140l-167 228l-63 -41q-59 -38 -85 -73q-29 -40 -29 -92q0 -60 35 -97q36 -38 93 -38q55 0 117 36q49 27 99 77zM301 424q50 32 74 57q31 33 31 73q0 37 -23 60t-58 23q-32 0 -55 -22q-28 -26 -28 -67q0 -16 7 -34.5t13.5 -29.5t20.5 -32.5 t18 -27.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesingle",
    unicode: "'",
    horizAdvX: 164,
    d: "M104 667l-7 -269h-30l-7 269h44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenleft",
    unicode: "(",
    horizAdvX: 282,
    d: "M146 290q0 -106 21 -232q16 -103 45 -195l-38 -23q-27 76 -48 183q-26 134 -26 267q0 134 26 267q21 107 48 183l38 -23q-28 -86 -45 -195q-21 -130 -21 -232z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenright",
    unicode: ")",
    horizAdvX: 282,
    d: "M108 -160l-38 23q29 92 45 195q21 126 21 232q0 102 -21 232q-17 109 -45 195l38 23q27 -76 48 -183q26 -133 26 -267q0 -133 -26 -267q-21 -107 -48 -183z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asterisk",
    unicode: "*",
    horizAdvX: 548,
    d: "M130 640l125 -44l-3 133h44l-3 -133l125 44l14 -41l-128 -38l81 -106l-35 -25l-76 110l-76 -110l-35 25l81 106l-128 38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plus",
    unicode: "+",
    d: "M33 310v38h197v182h40v-182h197v-38h-197v-182h-40v182h-197z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "comma",
    unicode: ",",
    horizAdvX: 228,
    d: "M38 -137l60 202l40 -12l-74 -200z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hyphen",
    unicode: "-",
    horizAdvX: 300,
    d: "M50 184v46h200v-46h-200z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "period",
    unicode: ".",
    horizAdvX: 202,
    d: "M64 30q0 16 10.5 26.5t26.5 10.5t26.5 -10.5t10.5 -26.5t-10.5 -26.5t-26.5 -10.5t-26.5 10.5t-10.5 26.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "slash",
    unicode: "/",
    horizAdvX: 576,
    d: "M20 -158l504 901l32 -16l-504 -901z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero",
    unicode: 0,
    horizAdvX: 548,
    d: "M274 676q90 0 157 -81q85 -101 85 -262t-85 -262q-69 -82 -157 -82t-157 82q-85 101 -85 262t85 262q67 81 157 81zM274 29q69 0 124 68q72 89 72 236t-72 236q-54 67 -124 67t-124 -67q-72 -89 -72 -236t72 -236q55 -68 124 -68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one",
    unicode: 1,
    horizAdvX: 548,
    d: "M272 0v627h-104l20 40h128v-667h-44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two",
    unicode: 2,
    horizAdvX: 548,
    d: "M471 0h-411l256 282q53 60 73 90q39 60 39 114q0 64 -43.5 107t-111.5 43q-72 0 -115 -49q-39 -43 -39 -109h-44q0 85 53 140q56 58 148 58q86 0 142 -54.5t56 -135.5q0 -71 -48 -137q-23 -32 -59 -72l-214 -237h318v-40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three",
    unicode: 3,
    horizAdvX: 548,
    d: "M76 162h44q2 -39 22 -71q19 -27 52 -44.5t66 -17.5q61 0 105.5 46t44.5 109q0 82 -63 122q-31 20 -85 20v40q54 0 90 31q49 41 49 109q0 56 -34 93t-94 37q-62 0 -96 -39q-32 -35 -34 -89h-42q1 71 49 120q47 48 123 48q80 0 127 -48t47 -119q0 -50 -25 -94.5t-80 -66.5 q53 -17 83.5 -61t30.5 -102q0 -83 -57 -139.5t-139 -56.5q-47 0 -91 23t-69 64q-24 39 -24 86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four",
    unicode: 4,
    horizAdvX: 548,
    d: "M415 689v-522h93v-40h-93v-127h-44v127h-359zM90 167h281v392z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five",
    unicode: 5,
    horizAdvX: 548,
    d: "M470 667v-40h-224l-56 -180q24 6 45 6q105 0 168.5 -65t63.5 -166q0 -105 -68.5 -169t-168.5 -64q-136 0 -200 110l39 16q58 -86 162 -86q83 0 136.5 54t53.5 138q0 85 -52.5 138.5t-135.5 53.5q-57 0 -104 -29l86 283h255z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six",
    unicode: 6,
    horizAdvX: 548,
    d: "M301 676l34 -26l-148 -210q43 18 91 18q100 0 166 -66t66 -167t-67 -168.5t-171 -67.5q-102 0 -169 66.5t-67 170.5q0 73 43 136zM273 29q82 0 136.5 56t54.5 139q0 85 -54 139.5t-137 54.5t-137 -55t-54 -139t54.5 -139.5t136.5 -55.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven",
    unicode: 7,
    horizAdvX: 548,
    d: "M22 14l432 613h-405v40h483l-477 -678z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight",
    unicode: 8,
    horizAdvX: 548,
    d: "M358 346q52 -20 80.5 -66t28.5 -103q0 -85 -56 -136.5t-137 -51.5t-137 51.5t-56 136.5q0 57 28.5 103t80.5 66q-93 49 -93 154q0 75 51 125.5t126 50.5t126 -50.5t51 -125.5q0 -105 -93 -154zM274 365q54 0 92.5 38.5t38.5 96.5q0 59 -38 97.5t-93 38.5t-93 -38.5 t-38 -97.5q0 -58 38.5 -96.5t92.5 -38.5zM274 29q66 0 106.5 42.5t40.5 105.5q0 66 -41 108t-106 42t-106 -42t-41 -108q0 -63 40.5 -105.5t106.5 -42.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine",
    unicode: 9,
    horizAdvX: 548,
    d: "M247 -11l-34 26l148 211q-43 -18 -91 -18q-100 0 -166 66t-66 167t67 168t171 67q102 0 169 -67t67 -169q0 -73 -43 -136zM275 636q-82 0 -136.5 -56t-54.5 -138q0 -85 54.5 -139.5t136.5 -54.5q83 0 137 55t54 139q0 83 -54.5 138.5t-136.5 55.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "colon",
    unicode: ":",
    horizAdvX: 202,
    d: "M64 380q0 16 10.5 26.5t26.5 10.5t26.5 -10.5t10.5 -26.5t-10.5 -26.5t-26.5 -10.5t-26.5 10.5t-10.5 26.5zM64 26q0 16 10.5 26.5t26.5 10.5t26.5 -10.5t10.5 -26.5t-10.5 -26.5t-26.5 -10.5t-26.5 10.5t-10.5 26.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "semicolon",
    unicode: ";",
    horizAdvX: 228,
    d: "M66 380q0 16 10.5 26.5t26.5 10.5t26.5 -10.5t10.5 -26.5t-10.5 -26.5t-26.5 -10.5t-26.5 10.5t-10.5 26.5zM38 -137l60 202l40 -12l-74 -200z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "less",
    unicode: "<",
    d: "M33 347l434 192v-41l-390 -170l390 -170v-41l-434 192v38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "equal",
    unicode: "=",
    d: "M33 381v38h434v-38h-434zM33 239v38h434v-38h-434z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greater",
    unicode: ">",
    d: "M467 309l-434 -192v41l390 170l-390 170v41l434 -192v-38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "question",
    unicode: "?",
    horizAdvX: 466,
    d: "M330 260h40q0 -53 -21 -88q-34 -58 -114 -58q-62 0 -101 36q-40 37 -40 101q0 62 44 99q10 8 22.5 14t20.5 9t26 8t23 7q4 1 16 4.5t17.5 5.5t15.5 5.5t16 7t13 8.5t13 11q25 29 25 82q0 57 -30 90q-31 34 -85 34t-85 -34q-28 -30 -28 -90q0 -20 7 -40h-44q-7 22 -7 46 q0 74 44 116q46 42 116 42q74 0 117 -45q41 -42 41 -117q0 -65 -36 -106q-32 -35 -89 -51q-8 -2 -25.5 -6.5t-27 -7.5t-22 -8t-20.5 -12q-34 -27 -34 -74q0 -41 25 -68q27 -29 71 -29q54 0 79 36q17 24 17 72zM197 26q0 16 10.5 26.5t26.5 10.5t26.5 -10.5t10.5 -26.5 t-10.5 -26.5t-26.5 -10.5t-26.5 10.5t-10.5 26.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "at",
    unicode: "@",
    horizAdvX: 732,
    d: "M489 413l15 78h32q-50 -257 -50 -271q0 -21 12 -37t35 -16q52 0 90.5 63t38.5 148q0 119 -82 192.5t-203 73.5q-132 0 -221.5 -90t-89.5 -221q0 -96 50.5 -177t137.5 -115q61 -24 139 -24q106 0 185 38l37 18l12 -29q-58 -30 -119 -44q-59 -13 -116 -13q-157 0 -258.5 97 t-101.5 247q0 145 100 244t245 99q131 0 223 -82.5t92 -213.5q0 -101 -49.5 -170t-110.5 -69q-32 0 -51.5 19t-19.5 54q-20 -36 -54 -55.5t-72 -19.5q-63 0 -101 46.5t-38 114.5q0 85 49.5 145.5t125.5 60.5q11 0 22 -2t32.5 -9t38.5 -27.5t25 -52.5zM340 169 q54 0 92.5 51.5t38.5 135.5q0 15 -2.5 29.5t-11 37t-30 36t-53.5 13.5q-65 0 -104 -51.5t-39 -121.5q0 -61 32.5 -95.5t76.5 -34.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A",
    unicode: "A",
    horizAdvX: 586,
    d: "M524 0l-89 219h-284l-89 -219h-48l281 687l277 -687h-48zM167 259h252l-125 316z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B",
    unicode: "B",
    horizAdvX: 534,
    d: "M90 0v667h146q86 0 135 -45.5t49 -121.5q0 -98 -78 -146q64 -10 101 -56t37 -111q0 -86 -57.5 -136.5t-149.5 -50.5h-183zM134 627v-262h106q57 0 91 28q44 36 44 102q0 67 -45 104q-36 28 -111 28h-85zM134 325v-285h112q31 0 49 1.5t46.5 10.5t49.5 28q43 38 43 102 q0 91 -71 124q-43 19 -125 19h-104z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "C",
    unicode: "C",
    horizAdvX: 678,
    d: "M624 589v-58q-43 50 -101.5 77.5t-123.5 27.5q-127 0 -213 -89t-86 -217q0 -71 27.5 -130t72 -95.5t96.5 -56t104 -19.5q56 0 116 24.5t108 76.5v-58q-94 -83 -222 -83q-148 0 -248 101t-100 242q0 144 101 244t245 100q132 0 224 -87z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "D",
    unicode: "D",
    horizAdvX: 618,
    d: "M222 0h-132v667h132q153 0 246 -93q49 -49 72.5 -114t23.5 -127q0 -61 -23 -125.5t-73 -114.5q-93 -93 -246 -93zM134 627v-587h87q132 0 214.5 81.5t82.5 211.5q0 129 -83 211.5t-214 82.5h-87z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E",
    unicode: "E",
    horizAdvX: 464,
    d: "M410 667v-40h-276v-242h270v-40h-270v-305h276v-40h-320v667h320z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "F",
    unicode: "F",
    horizAdvX: 406,
    d: "M360 667v-40h-226v-242h220v-40h-220v-345h-44v667h270z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G",
    unicode: "G",
    horizAdvX: 772,
    d: "M438 280v40h280q0 -132 -68 -219q-88 -112 -251 -112q-148 0 -246.5 97t-98.5 246q0 147 100.5 245.5t247.5 98.5q115 0 209 -72q46 -36 80 -84l-35 -28q-24 41 -64 74q-84 70 -191 70q-128 0 -214.5 -89t-86.5 -217q0 -126 85 -213.5t213 -87.5q79 0 140.5 33.5 t91.5 79.5q40 62 44 138h-236z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H",
    unicode: "H",
    horizAdvX: 672,
    d: "M134 667v-283h404v283h44v-667h-44v344h-404v-344h-44v667h44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I",
    unicode: "I",
    horizAdvX: 224,
    d: "M90 667h44v-667h-44v667z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "J",
    unicode: "J",
    horizAdvX: 263,
    d: "M129 667h44v-537q0 -76 -33 -110q-31 -31 -83 -31q-42 0 -73 25q-22 18 -39 45l31 26q13 -25 31 -38q24 -18 52 -18q29 0 48 19q22 22 22 75v544z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K",
    unicode: "K",
    horizAdvX: 540,
    d: "M134 667v-314l315 314h58l-323 -319l342 -348h-60l-314 318l-18 -17v-301h-44v667h44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "L",
    unicode: "L",
    horizAdvX: 334,
    d: "M90 667h44v-627h186v-40h-230v667z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M",
    unicode: "M",
    horizAdvX: 896,
    d: "M127 0h-44l76 690l289 -617l289 617l76 -690h-44l-59 536q-261 -560 -262 -560l-262 560z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "N",
    unicode: "N",
    horizAdvX: 784,
    d: "M134 0h-44v674l560 -586v579h44v-684l-560 586v-569z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O",
    unicode: "O",
    horizAdvX: 800,
    d: "M400 676q146 0 246 -100t100 -244t-100 -243.5t-246 -99.5q-147 0 -246.5 99.5t-99.5 243.5t100 244t246 100zM400 29q128 0 214 87.5t86 215.5q0 129 -86 216.5t-214 87.5t-214 -87.5t-86 -216.5q0 -128 86 -215.5t214 -87.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P",
    unicode: "P",
    horizAdvX: 446,
    d: "M220 317h-86v-317h-44v667h129q85 0 140 -45.5t55 -128.5q0 -82 -53 -129t-141 -47zM134 627v-270h88q66 0 106 36.5t40 98.5q0 63 -40.5 99t-112.5 36h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Q",
    unicode: "Q",
    horizAdvX: 800,
    d: "M736 0h-58l-59 64q-95 -75 -219 -75q-146 0 -246 99.5t-100 243.5t100 244t246 100q145 0 245.5 -100t100.5 -244q0 -139 -96 -240zM400 29q108 0 191 65l-167 179h58l139 -150q79 86 79 209q0 128 -86 216t-214 88t-214 -87.5t-86 -216.5q0 -128 86 -215.5t214 -87.5z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "R",
    unicode: "R",
    horizAdvX: 468,
    d: "M420 0h-50l-216 315h-20v-315h-44v667h96q91 0 141 -34q69 -48 69 -143q0 -55 -27 -98.5t-85 -63.5q-38 -13 -82 -13zM134 627v-272h64q71 0 111.5 36t40.5 100q0 84 -59 116q-35 20 -102 20h-55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "S",
    unicode: "S",
    horizAdvX: 514,
    d: "M426 581l-32 -27q-42 82 -131 82q-57 0 -90.5 -36t-33.5 -88q0 -26 7.5 -45t27 -35t34.5 -24.5t48 -24.5q108 -52 133 -70q71 -49 71 -129q0 -83 -61 -139t-147 -56q-95 0 -155 70q-29 34 -43 73l38 18q12 -36 36 -64q45 -57 125 -57q68 0 114.5 44t46.5 110 q0 65 -65 105q-29 17 -113 58q-55 27 -80.5 44t-41.5 44q-21 35 -21 76q0 65 44 115.5t127 50.5q51 0 94 -24.5t68 -70.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T",
    unicode: "T",
    horizAdvX: 418,
    d: "M404 627h-173v-627h-44v627h-173v40h390v-40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "U",
    unicode: "U",
    horizAdvX: 634,
    d: "M90 667h44v-417q0 -53 5.5 -84.5t22.5 -59.5q26 -42 69.5 -59.5t85.5 -17.5t85.5 17.5t69.5 59.5q17 28 22.5 59.5t5.5 84.5v417h44v-417q0 -62 -7 -99t-31 -72q-62 -90 -189 -90t-189 90q-24 35 -31 72t-7 99v417z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "V",
    unicode: "V",
    horizAdvX: 510,
    d: "M14 667h48l196 -568l190 568h48l-238 -694z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W",
    unicode: "W",
    horizAdvX: 984,
    d: "M14 667h48l184 -566l241 602l226 -602l209 566h48l-257 -692l-226 606l-248 -606z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X",
    unicode: "X",
    horizAdvX: 470,
    d: "M23 0l183 340l-175 327h48l151 -285l152 285h48l-174 -327l183 -340h-48l-161 300l-159 -300h-48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y",
    unicode: "Y",
    horizAdvX: 516,
    d: "M233 0v285l-219 382h50l192 -337l196 337h50l-225 -382v-285h-44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Z",
    unicode: "Z",
    horizAdvX: 554,
    d: "M517 667l-406 -627h395v-40h-469l406 627h-367v40h441z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketleft",
    unicode: "[",
    horizAdvX: 278,
    d: "M238 689h-106v-809h106v-40h-150v889h150v-40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "backslash",
    unicode: "\\\\\\\\",
    horizAdvX: 576,
    d: "M556 -158l-32 -16l-504 901l32 16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketright",
    unicode: "]",
    horizAdvX: 278,
    d: "M40 -120h106v809h-106v40h150v-889h-150v40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciicircum",
    unicode: "^",
    d: "M250 636l-167 -254h-46l186 285h54l186 -285h-46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "underscore",
    unicode: "_",
    d: "M0 -116v38h500v-38h-500z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "grave",
    unicode: "`",
    d: "M248 467l-105 128l43 25l92 -137z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a",
    unicode: "a",
    horizAdvX: 516,
    d: "M404 337v71h40v-408h-40v73q-55 -84 -159 -84q-83 0 -141 59t-58 156q0 95 55 154t144 59q102 0 159 -80zM247 379q-65 0 -112 -46.5t-47 -125.5q0 -73 43 -126.5t117 -53.5q73 0 115.5 52.5t42.5 127.5q0 83 -49 127.5t-110 44.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "b",
    unicode: "b",
    horizAdvX: 516,
    d: "M72 729h40v-392q59 80 160 80q90 0 144 -59.5t54 -150.5q0 -93 -54.5 -155.5t-145.5 -62.5q-46 0 -83 18.5t-51 34t-24 31.5v-73h-40v729zM269 27q75 0 117 51t42 129q0 81 -46 126.5t-112 45.5q-65 0 -112.5 -45t-47.5 -125q0 -79 42 -130.5t117 -51.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "c",
    unicode: "c",
    horizAdvX: 442,
    d: "M399 365v-53q-58 67 -141 67q-74 0 -122 -50.5t-48 -126.5q0 -82 51 -128.5t117 -46.5q81 0 148 73v-54q-64 -57 -149 -57q-92 0 -150.5 60.5t-58.5 151.5q0 93 58 154.5t154 61.5q79 0 141 -52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "d",
    unicode: "d",
    horizAdvX: 516,
    d: "M404 337v392h40v-729h-40v73q-55 -84 -158 -84q-83 0 -141.5 57.5t-58.5 159.5q0 104 59 157.5t141 53.5q102 0 158 -80zM246 379q-67 0 -112.5 -45t-45.5 -127q0 -85 47 -132.5t113 -47.5q65 0 111.5 47.5t46.5 132.5q0 74 -43 123t-117 49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "e",
    unicode: "e",
    horizAdvX: 483,
    d: "M437 199h-349q0 -76 47.5 -124t114.5 -48q48 0 85 25.5t57 67.5l34 -20q-23 -44 -67 -77.5t-112 -33.5q-93 0 -147 60.5t-54 152.5q0 101 58.5 158t139.5 57q83 0 138 -61t55 -157zM91 237h304q-8 62 -49.5 102t-101.5 40q-61 0 -103 -40.5t-50 -101.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f",
    unicode: "f",
    horizAdvX: 214,
    d: "M214 370h-102v-370h-40v370h-46v38h46v194q0 78 31 108.5t76 30.5q14 0 35 -6v-37q-12 5 -31 5q-32 0 -51.5 -22.5t-19.5 -86.5v-186h102v-38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "g",
    unicode: "g",
    horizAdvX: 520,
    d: "M408 408h40v-396q0 -115 -54.5 -178.5t-150.5 -63.5q-83 0 -139.5 46.5t-60.5 128.5h42q5 -63 48.5 -100t109.5 -37q45 0 78.5 18t49.5 41t25 56t10.5 51t1.5 38v58q-58 -81 -161 -81q-81 0 -141 57t-60 158q0 91 56 152t150 61q100 0 156 -80v71zM248 379 q-73 0 -116.5 -51.5t-43.5 -125.5q0 -75 43.5 -125t114.5 -50q74 0 119 51t45 128q0 73 -44.5 123t-117.5 50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "h",
    unicode: "h",
    horizAdvX: 442,
    d: "M72 0v729h40v-385q41 73 125 73q76 0 113 -57q20 -32 20 -103v-257h-40v257q0 57 -16 82q-24 40 -80 40q-68 0 -100 -57q-22 -39 -22 -110v-212h-40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "i",
    unicode: "i",
    horizAdvX: 184,
    d: "M72 408h40v-408h-40v408zM92 507q-15 0 -25.5 10.5t-10.5 26.5t10.5 26.5t25.5 10.5t25.5 -10.5t10.5 -26.5t-10.5 -26.5t-25.5 -10.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "j",
    unicode: "j",
    horizAdvX: 184,
    d: "M72 408h40v-638h-40v638zM92 507q-15 0 -25.5 10.5t-10.5 26.5t10.5 26.5t25.5 10.5t25.5 -10.5t10.5 -26.5t-10.5 -26.5t-25.5 -10.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "k",
    unicode: "k",
    horizAdvX: 396,
    d: "M72 729h40v-496l168 175h52l-172 -177l228 -231h-54l-201 202l-21 -21v-181h-40v729z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "l",
    unicode: "l",
    horizAdvX: 184,
    d: "M72 729h40v-729h-40v729z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "m",
    unicode: "m",
    horizAdvX: 652,
    d: "M72 0v408h40v-51q35 60 106 60q86 0 114 -74q35 74 121 74q58 0 92 -34q35 -35 35 -111v-272h-40v272q0 59 -24 84q-22 23 -61 23q-30 0 -52.5 -12t-33 -27t-16 -37t-6.5 -33t-1 -24v-246h-40v262q0 117 -90 117q-51 0 -77.5 -39.5t-26.5 -103.5v-236h-40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "n",
    unicode: "n",
    horizAdvX: 442,
    d: "M72 0v408h40v-64q41 73 125 73q76 0 113 -57q20 -32 20 -103v-257h-40v257q0 57 -16 82q-24 40 -80 40q-68 0 -100 -57q-22 -39 -22 -110v-212h-40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "o",
    unicode: "o",
    horizAdvX: 520,
    d: "M260 417q91 0 152.5 -61.5t61.5 -152.5t-61.5 -152.5t-152.5 -61.5t-152.5 61.5t-61.5 152.5t61.5 152.5t152.5 61.5zM260 27q73 0 122.5 51t49.5 125t-49.5 125t-122.5 51t-122.5 -51t-49.5 -125t49.5 -125t122.5 -51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "p",
    unicode: "p",
    horizAdvX: 516,
    d: "M112 73v-303h-40v638h40v-71q59 80 160 80q90 0 144 -59.5t54 -150.5q0 -93 -54.5 -155.5t-145.5 -62.5q-46 0 -83 18.5t-51 34t-24 31.5zM269 27q75 0 117 51t42 129q0 81 -46 126.5t-112 45.5q-65 0 -112.5 -45t-47.5 -125q0 -79 42 -130.5t117 -51.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "q",
    unicode: "q",
    horizAdvX: 516,
    d: "M444 -230h-40v303q-55 -84 -158 -84q-83 0 -141.5 57.5t-58.5 159.5q0 104 59 157.5t141 53.5q102 0 158 -80v71h40v-638zM246 379q-67 0 -112.5 -45t-45.5 -127q0 -85 47 -132.5t113 -47.5q65 0 111.5 47.5t46.5 132.5q0 74 -43 123t-117 49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "r",
    unicode: "r",
    horizAdvX: 260,
    d: "M72 0v408h40v-53q27 62 90 62q24 0 43 -10l-20 -36q-11 8 -30 8q-29 0 -47.5 -16.5t-25 -46t-8.5 -49.5t-2 -48v-219h-40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "s",
    unicode: "s",
    horizAdvX: 334,
    d: "M280 351l-34 -18q-20 46 -71 46q-32 0 -50.5 -20t-18.5 -45q0 -19 11 -32.5t23 -20t38 -16.5q4 -1 19.5 -7.5t20.5 -8.5t17.5 -7.5t18.5 -10t14.5 -11.5t14.5 -15q21 -26 21 -66q0 -65 -39.5 -97.5t-93.5 -32.5q-52 0 -90 29t-51 79l39 12q10 -39 38.5 -60.5t63.5 -21.5 q39 0 65 25.5t26 64.5q0 32 -20 49.5t-71 38.5q-70 29 -89 54q-18 24 -18 53q0 46 31 75.5t78 29.5q79 0 107 -66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "t",
    unicode: "t",
    horizAdvX: 194,
    d: "M186 370h-71v-370h-40v370h-45v38h45v146h40v-146h71v-38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "u",
    unicode: "u",
    horizAdvX: 438,
    d: "M72 408h40v-246q0 -71 26 -102q28 -33 81 -33t81 33q26 31 26 102v246h40v-257q0 -72 -31 -112q-39 -50 -116 -50t-116 50q-31 40 -31 112v257z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "v",
    unicode: "v",
    horizAdvX: 390,
    d: "M8 408h44l144 -339l142 339h44l-186 -433z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "w",
    unicode: "w",
    horizAdvX: 672,
    d: "M8 408h44l141 -337l141 362l141 -362l145 337h44l-189 -433l-141 362l-141 -362z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "x",
    unicode: "x",
    horizAdvX: 400,
    d: "M8 0l165 214l-151 194h49l129 -168l127 168h49l-148 -194l164 -214h-49l-143 188l-143 -188h-49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "y",
    unicode: "y",
    horizAdvX: 428,
    d: "M106 -230l96 223l-194 415h46l171 -363l149 363h46l-268 -638h-46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "z",
    unicode: "z",
    horizAdvX: 452,
    d: "M434 408l-330 -370h328v-38h-414l334 370h-282v38h364z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceleft",
    unicode: "{",
    horizAdvX: 278,
    d: "M40 270v29q26 7 39.5 24t16.5 33.5t3 42.5v194q0 73 31 104q32 32 98 32h12v-40q-57 0 -78 -24q-19 -21 -19 -75v-194q0 -48 -13.5 -73.5t-50.5 -38.5q64 -23 64 -116v-182q0 -62 19 -83q20 -23 78 -23v-40h-9q-71 0 -102 34q-30 33 -30 120v176q0 17 -1.5 29t-6.5 28.5 t-18 27t-33 15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bar",
    unicode: "|",
    d: "M230 -250v1000h40v-1000h-40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceright",
    unicode: "}",
    horizAdvX: 278,
    d: "M238 299v-29q-20 -5 -33 -15.5t-18 -27t-6.5 -28.5t-1.5 -29v-176q0 -87 -30 -120q-31 -34 -102 -34h-9v40q58 0 78 23q19 21 19 83v182q0 93 64 116q-37 13 -50.5 38.5t-13.5 73.5v194q0 54 -19 75q-21 24 -78 24v40h12q66 0 98 -32q31 -31 31 -104v-194q0 -26 3 -42.5 t16.5 -33.5t39.5 -24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciitilde",
    unicode: "~",
    d: "M39 195l-27 16q18 38 47 67q37 35 85 35q37 0 113 -40q72 -37 103 -37q38 0 65 27q19 19 36 51l27 -16q-18 -36 -39 -58q-40 -42 -95 -42q-44 0 -138 52q-46 25 -75 25q-37 0 -64 -26q-22 -21 -38 -54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10023",
    unicode: "\u0401",
    horizAdvX: 464,
    d: "M410 667v-40h-276v-242h270v-40h-270v-305h276v-40h-320v667h320zM121 780q0 16 11 27t27 11t27 -11t11 -27t-11 -27t-27 -11t-27 11t-11 27zM307 780q0 16 11 27t27 11t27 -11t11 -27t-11 -27t-27 -11t-27 11t-11 27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10051",
    unicode: "\u0402",
    horizAdvX: 616,
    d: "M424 627h-200v-262q69 23 137 23q115 0 167 -61q42 -49 42 -133q0 -110 -67 -163q-47 -37 -127 -37q-30 0 -68 6v40q28 -6 63 -6q70 0 107 33q46 41 46 125q0 65 -33 107q-41 49 -127 49q-71 0 -140 -23v-325h-44v627h-166v40h410v-40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10052",
    unicode: "\u0403",
    horizAdvX: 400,
    d: "M90 0v667h296v-40h-252v-627h-44zM316 854l50 -25l-134 -126l-32 18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10053",
    unicode: "\u0404",
    horizAdvX: 678,
    d: "M624 589v-58q-43 50 -101.5 77.5t-123.5 27.5q-115 0 -200.5 -77t-96.5 -195h442v-40h-444q3 -133 94.5 -214t205.5 -81q56 0 116 24.5t108 76.5v-58q-94 -83 -222 -83q-148 0 -248 101t-100 242q0 144 101 244t245 100q132 0 224 -87z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10054",
    unicode: "\u0405",
    horizAdvX: 514,
    d: "M426 581l-32 -27q-42 82 -131 82q-57 0 -90.5 -36t-33.5 -88q0 -26 7.5 -45t27 -35t34.5 -24.5t48 -24.5q108 -52 133 -70q71 -49 71 -129q0 -83 -61 -139t-147 -56q-95 0 -155 70q-29 34 -43 73l38 18q12 -36 36 -64q45 -57 125 -57q68 0 114.5 44t46.5 110 q0 65 -65 105q-29 17 -113 58q-5 2 -22 10.5t-23.5 12t-20.5 12t-22 15t-17.5 17t-16.5 21.5q-21 35 -21 76q0 65 44 115.5t127 50.5q51 0 94 -24.5t68 -70.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10055",
    unicode: "\u0406",
    horizAdvX: 224,
    d: "M90 667h44v-667h-44v667z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10056",
    unicode: "\u0407",
    horizAdvX: 224,
    d: "M90 667h44v-667h-44v667zM10 780q0 16 11 27t27 11t27 -11t11 -27t-11 -27t-27 -11t-27 11t-11 27zM138 780q0 16 11 27t27 11t27 -11t11 -27t-11 -27t-27 -11t-27 11t-11 27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10057",
    unicode: "\u0408",
    horizAdvX: 263,
    d: "M129 667h44v-537q0 -76 -33 -110q-31 -31 -83 -31q-38 0 -73 25q-18 13 -38 45l30 26q13 -25 31 -38q24 -18 52 -18q32 0 48 19q22 24 22 82v537z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10058",
    unicode: "\u0409",
    horizAdvX: 922,
    d: "M154 667h376v-287h116q230 0 230 -183q0 -83 -53.5 -140t-162.5 -57h-174v627h-288v-388q0 -50 -1.5 -77.5t-12.5 -65.5t-33 -62q-36 -40 -97 -40q-16 0 -40 6v40q20 -6 37 -6q39 0 65 26q18 18 26.5 51t10 57.5t1.5 70.5v428zM530 340v-300h112q101 0 146 44 q42 40 42 113q0 87 -69 123q-39 20 -127 20h-104z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10059",
    unicode: "\u040A",
    horizAdvX: 974,
    d: "M134 667v-287h404v287h44v-287h116q230 0 230 -183q0 -83 -53.5 -140t-162.5 -57h-174v340h-404v-340h-44v667h44zM582 340v-300h112q101 0 146 44q42 40 42 113q0 87 -69 123q-39 20 -127 20h-104z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10060",
    unicode: "\u040B",
    horizAdvX: 670,
    d: "M424 627h-200v-243h170q91 0 136 -22q44 -21 57 -55.5t13 -93.5v-213h-44v213q0 19 -1 31t-6 30t-16.5 32t-30.5 23q-31 15 -122 15h-156v-344h-44v627h-166v40h410v-40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10061",
    unicode: "\u040C",
    horizAdvX: 540,
    d: "M134 667v-314l315 314h58l-323 -319l342 -348h-60l-314 318l-18 -17v-301h-44v667h44zM336 854l50 -25l-134 -126l-32 18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10062",
    unicode: "\u040E",
    horizAdvX: 550,
    d: "M14 667h50l231 -432l195 432h46l-305 -667h-46l85 186zM145 803l35 19q29 -64 105 -64t105 64l35 -19q-21 -46 -60.5 -65.5t-79.5 -19.5t-79.5 19.5t-60.5 65.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10145",
    unicode: "\u040F",
    horizAdvX: 666,
    d: "M90 0v667h44v-627h398v627h44v-667h-221v-150h-44v150h-221z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10017",
    unicode: "\u0410",
    horizAdvX: 586,
    d: "M524 0l-89 219h-284l-89 -219h-48l281 687l277 -687h-48zM167 259h252l-125 316z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10018",
    unicode: "\u0411",
    horizAdvX: 534,
    d: "M90 0v667h321v-40h-277v-247h116q230 0 230 -183q0 -83 -53.5 -140t-162.5 -57h-174zM134 340v-300h112q101 0 146 44q42 40 42 113q0 87 -69 123q-40 20 -127 20h-104z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10019",
    unicode: "\u0412",
    horizAdvX: 534,
    d: "M90 0v667h146q86 0 135 -45.5t49 -121.5q0 -98 -78 -146q64 -10 101 -56t37 -111q0 -86 -57.5 -136.5t-149.5 -50.5h-183zM134 627v-262h106q57 0 91 28q44 36 44 102q0 67 -45 104q-36 28 -111 28h-85zM134 325v-285h112q31 0 49 1.5t46.5 10.5t49.5 28q43 38 43 102 q0 91 -71 124q-43 19 -125 19h-104z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10020",
    unicode: "\u0413",
    horizAdvX: 400,
    d: "M90 0v667h296v-40h-252v-627h-44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10021",
    unicode: "\u0414",
    horizAdvX: 610,
    d: "M144 667h376v-627h76v-174h-42v134h-498v-134h-42v174q34 0 62 25t44 65q24 61 24 175v362zM188 627v-322q0 -123 -24 -186q-17 -45 -51 -79h363v587h-288z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10022",
    unicode: "\u0415",
    horizAdvX: 464,
    d: "M410 667v-40h-276v-242h270v-40h-270v-305h276v-40h-320v667h320z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10024",
    unicode: "\u0416",
    horizAdvX: 796,
    d: "M376 667h44v-314l282 314h58l-296 -323l318 -344h-58l-291 314l-13 -13v-301h-44v301l-13 13l-291 -314h-58l318 344l-296 323h58l282 -314v314z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10025",
    unicode: "\u0417",
    horizAdvX: 554,
    d: "M136 554l-32 27q58 95 181 95q76 0 121 -43q48 -44 48 -120q0 -99 -88 -146q64 -16 99 -64t35 -112q0 -105 -76 -160q-58 -42 -145 -42q-83 0 -140 40.5t-85 100.5l42 20q25 -60 78.5 -90.5t107.5 -30.5q68 0 115 35q57 42 57 127q0 70 -47.5 109t-130.5 39h-60v40h60 q53 0 92.5 36.5t39.5 97.5q0 52 -31 86q-34 37 -97 37q-91 0 -144 -82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10026",
    unicode: "\u0418",
    horizAdvX: 700,
    d: "M566 0v556l-476 -573v684h44v-566l476 573v-674h-44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10027",
    unicode: "\u0419",
    horizAdvX: 700,
    d: "M566 0v556l-476 -573v684h44v-566l476 573v-674h-44zM210 803l35 19q29 -64 105 -64t105 64l35 -19q-21 -46 -60.5 -65.5t-79.5 -19.5t-79.5 19.5t-60.5 65.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10028",
    unicode: "\u041A",
    horizAdvX: 540,
    d: "M134 667v-314l315 314h58l-323 -319l342 -348h-60l-314 318l-18 -17v-301h-44v667h44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10029",
    unicode: "\u041B",
    horizAdvX: 620,
    d: "M154 667h376v-667h-44v627h-288v-388q0 -50 -1.5 -77.5t-12.5 -65.5t-33 -62q-36 -40 -97 -40q-16 0 -40 6v40q20 -6 37 -6q39 0 65 26q18 18 26.5 51t10 57.5t1.5 70.5v428z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10030",
    unicode: "\u041C",
    horizAdvX: 896,
    d: "M127 0h-44l76 690l289 -617l289 617l76 -690h-44l-59 536l-262 -560l-262 560z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10031",
    unicode: "\u041D",
    horizAdvX: 672,
    d: "M134 667v-283h404v283h44v-667h-44v344h-404v-344h-44v667h44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10032",
    unicode: "\u041E",
    horizAdvX: 800,
    d: "M400 676q146 0 246 -100t100 -244t-100 -243.5t-246 -99.5t-246 99.5t-100 243.5t100 244t246 100zM400 29q128 0 214 87.5t86 215.5q0 129 -86 216.5t-214 87.5t-214 -87.5t-86 -216.5q0 -128 86 -215.5t214 -87.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10033",
    unicode: "\u041F",
    horizAdvX: 672,
    d: "M90 667h492v-667h-44v627h-404v-627h-44v667z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10034",
    unicode: "\u0420",
    horizAdvX: 446,
    d: "M220 317h-86v-317h-44v667h129q85 0 140 -45.5t55 -128.5q0 -82 -53 -129t-141 -47zM134 627v-270h88q66 0 106 36.5t40 98.5q0 63 -40.5 99t-112.5 36h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10035",
    unicode: "\u0421",
    horizAdvX: 678,
    d: "M624 589v-58q-43 50 -101.5 77.5t-123.5 27.5q-127 0 -213 -89t-86 -217q0 -71 27.5 -130t72 -95.5t96.5 -56t104 -19.5q56 0 116 24.5t108 76.5v-58q-94 -83 -222 -83q-148 0 -248 101t-100 242q0 144 101 244t245 100q132 0 224 -87z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10036",
    unicode: "\u0422",
    horizAdvX: 418,
    d: "M404 627h-173v-627h-44v627h-173v40h390v-40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10037",
    unicode: "\u0423",
    horizAdvX: 550,
    d: "M14 667h50l231 -432l195 432h46l-305 -667h-46l85 186z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10038",
    unicode: "\u0424",
    horizAdvX: 820,
    d: "M388 0v94h-28q-71 0 -126.5 17t-88.5 43t-54.5 62t-29 69.5t-7.5 68.5t7.5 68.5t29 69.5t54.5 62t88.5 43t126.5 17h28v80h44v-80h28q71 0 126.5 -17t88.5 -43t54.5 -62t29 -69.5t7.5 -68.5t-7.5 -68.5t-29 -69.5t-54.5 -62t-88.5 -43t-126.5 -17h-28v-94h-44zM388 134 v440h-30q-73 0 -126.5 -20.5t-80.5 -54.5t-39 -69.5t-12 -75.5t12 -75.5t39 -69.5t80.5 -54.5t126.5 -20.5h30zM432 574v-440h30q73 0 126.5 20.5t80.5 54.5t39 69.5t12 75.5t-12 75.5t-39 69.5t-80.5 54.5t-126.5 20.5h-30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10039",
    unicode: "\u0425",
    horizAdvX: 470,
    d: "M23 0l183 340l-175 327h48l151 -285l152 285h48l-174 -327l183 -340h-48l-161 300l-159 -300h-48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10040",
    unicode: "\u0426",
    horizAdvX: 666,
    d: "M90 0v667h44v-627h398v627h44v-627h76v-174h-42v134h-520z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10041",
    unicode: "\u0427",
    horizAdvX: 580,
    d: "M446 0v300q-112 -7 -170 -7q-91 0 -136 22q-44 21 -57 55t-13 94v203h44v-203q0 -20 1 -31.5t5.5 -29.5t16.5 -32t31 -23q31 -15 122 -15q69 0 156 7v327h44v-667h-44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10042",
    unicode: "\u0428",
    horizAdvX: 920,
    d: "M90 0v667h44v-627h304v627h44v-627h304v627h44v-667h-740z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10043",
    unicode: "\u0429",
    horizAdvX: 920,
    d: "M90 0v667h44v-627h304v627h44v-627h304v627h44v-627h76v-174h-42v134h-774z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10044",
    unicode: "\u042A",
    horizAdvX: 610,
    d: "M174 0v627h-160v40h204v-287h116q230 0 230 -183q0 -83 -53.5 -140t-162.5 -57h-174zM218 340v-300h112q101 0 146 44q42 40 42 113q0 87 -69 123q-39 20 -127 20h-104z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10045",
    unicode: "\u042B",
    horizAdvX: 690,
    d: "M90 0v667h44v-287h116q230 0 230 -183q0 -83 -53.5 -140t-162.5 -57h-174zM134 340v-300h112q101 0 146 44q42 40 42 113q0 87 -69 123q-39 20 -127 20h-104zM556 667h44v-667h-44v667z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10046",
    unicode: "\u042C",
    horizAdvX: 526,
    d: "M90 0v667h44v-287h116q230 0 230 -183q0 -83 -53.5 -140t-162.5 -57h-174zM134 340v-300h112q101 0 146 44q42 40 42 113q0 87 -69 123q-39 20 -127 20h-104z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10047",
    unicode: "\u042D",
    horizAdvX: 678,
    d: "M54 72v58q48 -52 108 -76.5t116 -24.5q114 0 205 81t95 214h-444v40h442q-11 118 -96.5 195t-200.5 77q-65 0 -123.5 -27.5t-101.5 -77.5v58q92 87 224 87q144 0 245 -100t101 -244q0 -141 -100 -242t-248 -101q-128 0 -222 83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10048",
    unicode: "\u042E",
    horizAdvX: 960,
    d: "M134 372h102q15 132 110 218t224 86q142 0 239 -100t97 -244t-97 -243.5t-239 -99.5t-238 100t-98 243h-100v-332h-44v667h44v-295zM570 29q125 0 207.5 87.5t82.5 215.5t-83 216t-207 88t-207 -88t-83 -216t82.5 -215.5t207.5 -87.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10049",
    unicode: "\u042F",
    horizAdvX: 470,
    d: "M34 0l202 299q-38 1 -75 15q-13 5 -26.5 13.5t-34 27t-33.5 52t-13 76.5q0 59 26 98.5t61 59.5q44 26 125 26h114v-667h-44v299h-50l-200 -299h-52zM336 627h-70q-58 0 -91 -16q-35 -16 -55 -50t-20 -78q0 -70 44 -109q39 -35 116 -35h76v288z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10065",
    unicode: "\u0430",
    horizAdvX: 516,
    d: "M404 337v71h40v-408h-40v73q-55 -84 -159 -84q-83 0 -141 59t-58 156q0 95 55 154t144 59q102 0 159 -80zM247 379q-65 0 -112 -46.5t-47 -125.5q0 -73 43 -126.5t117 -53.5q73 0 115.5 52.5t42.5 127.5q0 83 -49 127.5t-110 44.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10066",
    unicode: "\u0431",
    horizAdvX: 520,
    d: "M87 311h2q23 53 72.5 79.5t106.5 26.5q93 0 149.5 -59t56.5 -154q0 -98 -61 -156.5t-154 -58.5q-88 0 -143 51q-70 66 -70 218q0 246 128 329q12 8 26 14.5t24.5 10.5t28.5 8.5t26 6t28.5 5.5t24.5 5q74 16 90 53h50q-11 -25 -27.5 -42.5t-40 -28t-39 -15t-41.5 -10.5 q-99 -20 -143 -55q-46 -37 -68.5 -100t-25.5 -128zM259 27q86 0 129.5 53.5t43.5 123.5t-44 122.5t-120 52.5q-82 0 -129 -53t-47 -122q0 -67 39 -118q45 -59 128 -59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10067",
    unicode: "\u0432",
    horizAdvX: 414,
    d: "M72 408h133q57 0 87 -24q36 -29 36 -78q0 -56 -45 -85q28 -4 50 -23q35 -31 35 -82q0 -57 -41 -88q-36 -28 -100 -28h-155v408zM112 230h93q37 0 58 17q25 20 25 54q0 33 -25 53q-20 16 -58 16h-93v-140zM112 38h115q46 0 70 18q29 22 29 61q0 36 -27 57q-24 18 -72 18 h-115v-154z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10068",
    unicode: "\u0433",
    horizAdvX: 300,
    d: "M72 0v408h220v-38h-180v-370h-40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10069",
    unicode: "\u0434",
    horizAdvX: 440,
    d: "M100 408h268v-370h60v-148h-38v110h-344v-110h-38v148q50 3 75 54q17 35 17 110v206zM328 38v332h-188v-180q0 -108 -52 -152h240z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10070",
    unicode: "\u0435",
    horizAdvX: 483,
    d: "M437 199h-349q0 -76 47.5 -124t114.5 -48q48 0 85 25.5t57 67.5l34 -20q-23 -44 -67 -77.5t-112 -33.5q-93 0 -147 60.5t-54 152.5q0 101 58.5 158t139.5 57q83 0 138 -61t55 -157zM91 237h304q-8 62 -49.5 102t-101.5 40q-61 0 -103 -40.5t-50 -101.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10072",
    unicode: "\u0436",
    horizAdvX: 560,
    d: "M260 408h40v-194l184 194h52l-190 -196l206 -212h-54l-178 186l-20 -20v-166h-40v166l-20 20l-178 -186h-54l206 212l-190 196h52l184 -194v194z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10073",
    unicode: "\u0437",
    horizAdvX: 400,
    d: "M105 322l-33 23q42 72 129 72q59 0 90 -29q33 -29 33 -79q0 -60 -47 -85q27 -6 48 -27q29 -29 29 -78q0 -63 -48 -100q-40 -30 -104 -30q-66 0 -107 31q-33 27 -49 59l36 23q15 -33 43 -52q31 -23 77 -23q51 0 78 23q32 26 32 70q0 39 -28 60q-24 18 -75 18h-42v38h31 q39 0 61 17q25 20 25 52t-21 53q-23 21 -63 21q-64 0 -95 -57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10074",
    unicode: "\u0438",
    horizAdvX: 474,
    d: "M72 408h40v-327l290 350v-431h-40v325l-290 -350v433z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10075",
    unicode: "\u0439",
    horizAdvX: 474,
    d: "M72 408h40v-327l290 350v-431h-40v325l-290 -350v433zM118 573l34 17q8 -31 33.5 -52t62.5 -21t62.5 21t33.5 52l34 -17q-30 -94 -130 -94t-130 94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10076",
    unicode: "\u043A",
    horizAdvX: 396,
    d: "M72 408h40v-194l206 194h54l-208 -194l224 -214h-58l-196 187l-22 -21v-166h-40v408z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10077",
    unicode: "\u043B",
    horizAdvX: 430,
    d: "M358 408v-408h-40v370h-188v-236q0 -67 -24 -99q-27 -37 -78 -37q-6 0 -20 2v38q10 -2 15 -2q34 0 53 27q14 22 14 71v274h268z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10078",
    unicode: "\u043C",
    horizAdvX: 566,
    d: "M24 0l96 433l163 -368l163 368l96 -433h-42l-66 319l-151 -344l-151 344l-66 -319h-42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10079",
    unicode: "\u043D",
    horizAdvX: 454,
    d: "M72 0v408h40v-180h230v180h40v-408h-40v190h-230v-190h-40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10080",
    unicode: "\u043E",
    horizAdvX: 520,
    d: "M260 417q91 0 152.5 -61.5t61.5 -152.5t-61.5 -152.5t-152.5 -61.5t-152.5 61.5t-61.5 152.5t61.5 152.5t152.5 61.5zM260 27q73 0 122.5 51t49.5 125t-49.5 125t-122.5 51t-122.5 -51t-49.5 -125t49.5 -125t122.5 -51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10081",
    unicode: "\u043F",
    horizAdvX: 448,
    d: "M72 0v408h304v-408h-40v370h-224v-370h-40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10082",
    unicode: "\u0440",
    horizAdvX: 516,
    d: "M112 73v-303h-40v638h40v-71q59 80 160 80q90 0 144 -59.5t54 -150.5q0 -93 -54.5 -155.5t-145.5 -62.5q-46 0 -83 18.5t-51 34t-24 31.5zM269 27q75 0 117 51t42 129q0 81 -46 126.5t-112 45.5q-65 0 -112.5 -45t-47.5 -125q0 -79 42 -130.5t117 -51.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10083",
    unicode: "\u0441",
    horizAdvX: 442,
    d: "M399 365v-53q-58 67 -141 67q-74 0 -122 -50.5t-48 -126.5q0 -82 51 -128.5t117 -46.5q81 0 148 73v-54q-64 -57 -149 -57q-92 0 -150.5 60.5t-58.5 151.5q0 93 58 154.5t154 61.5q79 0 141 -52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10084",
    unicode: "\u0442",
    horizAdvX: 340,
    d: "M150 0v370h-142v38h324v-38h-142v-370h-40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10085",
    unicode: "\u0443",
    horizAdvX: 428,
    d: "M106 -230l96 223l-194 415h46l171 -363l149 363h46l-268 -638h-46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10086",
    unicode: "\u0444",
    horizAdvX: 600,
    d: "M280 -230v223q-102 0 -165 53q-69 58 -69 158q0 101 69 159q62 51 165 51v253h40v-253q103 0 165 -51q69 -58 69 -159q0 -100 -69 -158q-63 -53 -165 -53v-223h-40zM280 31v345q-86 0 -137 -42q-55 -46 -55 -130q0 -85 55 -130q53 -43 137 -43zM320 376v-345q84 0 137 43 q55 45 55 130q0 84 -55 130q-51 42 -137 42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10087",
    unicode: "\u0445",
    horizAdvX: 400,
    d: "M8 0l165 214l-151 194h49l129 -168l127 168h49l-148 -194l164 -214h-49l-143 188l-143 -188h-49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10088",
    unicode: "\u0446",
    horizAdvX: 444,
    d: "M72 0v408h40v-370h220v370h40v-370h60v-148h-38v110h-322z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10089",
    unicode: "\u0447",
    horizAdvX: 412,
    d: "M300 0v169q-66 -10 -107 -10q-65 0 -96 22q-37 27 -37 104v123h40v-123q0 -56 27 -75q19 -13 61 -13q47 0 112 10v201h40v-408h-40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10090",
    unicode: "\u0448",
    horizAdvX: 644,
    d: "M72 0v408h40v-370h190v370h40v-370h190v370h40v-408h-500z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10091",
    unicode: "\u0449",
    horizAdvX: 644,
    d: "M72 0v408h40v-370h190v370h40v-370h190v370h40v-370h60v-148h-38v110h-522z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10092",
    unicode: "\u044A",
    horizAdvX: 416,
    d: "M8 408h140v-170h97q70 0 104 -38q29 -32 29 -81q0 -55 -36 -88q-33 -31 -98 -31h-136v370h-100v38zM148 38h96q42 0 64 19q28 23 28 62q0 41 -29 63q-24 18 -65 18h-94v-162z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10093",
    unicode: "\u044B",
    d: "M72 408h40v-170h97q70 0 104 -38q29 -32 29 -81q0 -55 -36 -88q-33 -31 -98 -31h-136v408zM112 38h96q42 0 64 19q28 23 28 62q0 41 -29 63q-24 18 -65 18h-94v-162zM388 408h40v-408h-40v408z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10094",
    unicode: "\u044C",
    horizAdvX: 380,
    d: "M72 408h40v-170h97q70 0 104 -38q29 -32 29 -81q0 -55 -36 -88q-33 -31 -98 -31h-136v408zM112 38h96q42 0 64 19q28 23 28 62q0 41 -29 63q-24 18 -65 18h-94v-162z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10095",
    unicode: "\u044D",
    horizAdvX: 412,
    d: "M38 10v42q45 -25 110 -25q83 0 132 53q41 43 44 110h-239v38h239q-8 74 -67 118q-46 33 -112 33q-63 0 -103 -21v40q50 19 103 19q95 0 153 -51q68 -59 68 -161q0 -99 -61 -158q-60 -58 -157 -58q-67 0 -110 21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10096",
    unicode: "\u044E",
    horizAdvX: 640,
    d: "M112 228h70q9 82 66.5 135.5t139.5 53.5q88 0 147 -61.5t59 -152.5t-59 -152.5t-147 -61.5q-82 0 -142 55.5t-64 145.5h-70v-190h-40v408h40v-180zM388 27q70 0 117 50.5t47 125.5t-47 125.5t-117 50.5t-117 -50.5t-47 -125.5t47 -125.5t117 -50.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10097",
    unicode: "\u044F",
    horizAdvX: 386,
    d: "M28 0l130 178q-47 2 -80 30q-34 30 -34 81q0 59 37 90q33 29 97 29h136v-408h-40v176h-70l-128 -176h-48zM274 214v156h-96q-42 0 -65 -18q-27 -23 -27 -62q0 -38 26 -58q24 -18 66 -18h96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10071",
    unicode: "\u0451",
    horizAdvX: 483,
    d: "M437 199h-349q0 -76 47.5 -124t114.5 -48q48 0 85 25.5t57 67.5l34 -20q-23 -44 -67 -77.5t-112 -33.5q-93 0 -147 60.5t-54 152.5q0 101 58.5 158t139.5 57q83 0 138 -61t55 -157zM91 237h304q-8 62 -49.5 102t-101.5 40q-61 0 -103 -40.5t-50 -101.5zM127 526 q0 15 10.5 25.5t25.5 10.5t25.5 -10.5t10.5 -25.5t-10.5 -25.5t-25.5 -10.5t-25.5 10.5t-10.5 25.5zM293 526q0 15 10.5 25.5t25.5 10.5t25.5 -10.5t10.5 -25.5t-10.5 -25.5t-25.5 -10.5t-25.5 10.5t-10.5 25.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10099",
    unicode: "\u0452",
    horizAdvX: 442,
    d: "M72 0v522h-72v38h72v169h40v-169h180v-38h-180v-218q41 73 125 73q76 0 113 -57q20 -32 20 -103v-312q0 -75 -35 -109q-27 -26 -72 -26q-17 0 -35 6v37q12 -5 28 -5q32 0 50 17q24 23 24 87v305q0 57 -16 82q-24 40 -80 40q-68 0 -100 -57q-22 -39 -22 -110v-172h-40z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10100",
    unicode: "\u0453",
    horizAdvX: 300,
    d: "M72 0v408h220v-38h-180v-370h-40zM235 620l43 -25l-105 -128l-30 16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10101",
    unicode: "\u0454",
    horizAdvX: 441,
    d: "M398 365v-53q-58 67 -141 67q-68 0 -115.5 -43.5t-53.5 -107.5h238v-38h-238q2 -72 51.5 -117.5t115.5 -45.5q81 0 148 73v-54q-64 -57 -149 -57q-91 0 -149.5 60.5t-58.5 151.5q0 93 57.5 154.5t153.5 61.5q79 0 141 -52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10102",
    unicode: "\u0455",
    horizAdvX: 334,
    d: "M280 351l-34 -18q-20 46 -71 46q-32 0 -50.5 -20t-18.5 -45q0 -19 11 -32.5t23 -20t38 -16.5q4 -1 19.5 -7.5t20.5 -8.5t17.5 -7.5t18.5 -10t14.5 -11.5t14.5 -15q21 -26 21 -66q0 -65 -39.5 -97.5t-93.5 -32.5q-52 0 -90 29t-51 79l39 12q10 -39 38.5 -60.5t63.5 -21.5 q39 0 65 25.5t26 64.5q0 32 -20 49.5t-71 38.5q-70 29 -89 54q-18 24 -18 53q0 46 31 75.5t78 29.5q79 0 107 -66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10103",
    unicode: "\u0456",
    horizAdvX: 184,
    d: "M72 408h40v-408h-40v408zM92 507q-15 0 -25.5 10.5t-10.5 26.5t10.5 26.5t25.5 10.5t25.5 -10.5t10.5 -26.5t-10.5 -26.5t-25.5 -10.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10104",
    unicode: "\u0457",
    horizAdvX: 184,
    d: "M71 408h40v-408h-40v408zM8 545q0 15 10.5 25.5t25.5 10.5t25.5 -10.5t10.5 -25.5t-10.5 -25.5t-25.5 -10.5t-25.5 10.5t-10.5 25.5zM104 545q0 15 10.5 25.5t25.5 10.5t25.5 -10.5t10.5 -25.5t-10.5 -25.5t-25.5 -10.5t-25.5 10.5t-10.5 25.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10105",
    unicode: "\u0458",
    horizAdvX: 184,
    d: "M72 408h40v-638h-40v638zM92 507q-15 0 -25.5 10.5t-10.5 26.5t10.5 26.5t25.5 10.5t25.5 -10.5t10.5 -26.5t-10.5 -26.5t-25.5 -10.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10106",
    unicode: "\u0459",
    horizAdvX: 626,
    d: "M358 408v-170h97q70 0 104 -38q29 -32 29 -81q0 -55 -36 -88q-33 -31 -98 -31h-136v370h-188v-236q0 -67 -24 -99q-27 -37 -78 -37q-6 0 -20 2v38q10 -2 15 -2q34 0 53 27q14 22 14 71v274h268zM358 38h96q42 0 64 19q28 23 28 62q0 41 -29 63q-24 18 -65 18h-94v-162z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10107",
    unicode: "\u045A",
    horizAdvX: 650,
    d: "M72 0v408h40v-170h230v170h40v-170h97q70 0 104 -38q29 -32 29 -81q0 -55 -36 -88q-33 -31 -98 -31h-136v200h-230v-200h-40zM382 38h96q42 0 64 19q28 23 28 62q0 41 -29 63q-24 18 -65 18h-94v-162z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10108",
    unicode: "\u045B",
    horizAdvX: 442,
    d: "M72 0v522h-72v38h72v169h40v-169h180v-38h-180v-218q41 73 125 73q76 0 113 -57q20 -32 20 -103v-217h-40v217q0 57 -16 82q-24 40 -80 40q-68 0 -100 -57q-22 -39 -22 -110v-172h-40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10109",
    unicode: "\u045C",
    horizAdvX: 396,
    d: "M72 408h40v-194l206 194h54l-208 -194l224 -214h-58l-196 187l-22 -21v-166h-40v408zM253 620l43 -25l-105 -128l-30 16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10110",
    unicode: "\u045E",
    horizAdvX: 428,
    d: "M106 -230l96 223l-194 415h46l171 -363l149 363h46l-268 -638h-46zM90 573l34 17q8 -31 33.5 -52t62.5 -21t62.5 21t33.5 52l34 -17q-30 -94 -130 -94t-130 94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10193",
    unicode: "\u045F",
    horizAdvX: 444,
    d: "M72 0v408h40v-370h220v370h40v-408h-130v-120h-40v120h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10146",
    unicode: "\u0462",
    horizAdvX: 610,
    d: "M174 0v527h-160v40h160v127h44v-127h200v-40h-200v-147h116q230 0 230 -183q0 -83 -53.5 -140t-162.5 -57h-174zM218 340v-300h112q101 0 146 44q42 40 42 113q0 87 -69 123q-39 20 -127 20h-104z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10194",
    unicode: "\u0463",
    horizAdvX: 416,
    d: "M8 408h100v259h40v-259h120v-38h-120v-132h97q70 0 104 -38q29 -32 29 -81q0 -55 -36 -88q-33 -31 -98 -31h-136v370h-100v38zM148 38h96q42 0 64 19q28 23 28 62q0 41 -29 63q-24 18 -65 18h-94v-162z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10147",
    unicode: "\u0472",
    horizAdvX: 800,
    d: "M400 676q146 0 246 -100t100 -244t-100 -243.5t-246 -99.5t-246 99.5t-100 243.5t100 244t246 100zM400 29q130 0 212.5 85.5t87.5 205.5h-600q5 -120 87.5 -205.5t212.5 -85.5zM101 360h598q-11 123 -97 199.5t-202 76.5t-202 -76.5t-97 -199.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10195",
    unicode: "\u0473",
    horizAdvX: 520,
    d: "M260 417q91 0 152.5 -61.5t61.5 -152.5t-61.5 -152.5t-152.5 -61.5t-152.5 61.5t-61.5 152.5t61.5 152.5t152.5 61.5zM431 189h-342q4 -71 54 -116.5t117 -45.5t117 45.5t54 116.5zM89 227h342q-9 71 -59.5 111.5t-111.5 40.5t-111.5 -40.5t-59.5 -111.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10148",
    unicode: "\u0474",
    horizAdvX: 510,
    d: "M14 667h48l196 -568l190 568h48l-238 -694z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10196",
    unicode: "\u0475",
    horizAdvX: 390,
    d: "M8 408h44l144 -339l142 339h44l-186 -433z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10050",
    unicode: "\u0490",
    horizAdvX: 400,
    d: "M90 0v667h254v133h42v-173h-252v-627h-44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10098",
    unicode: "\u0491",
    horizAdvX: 300,
    d: "M72 0v408h182v110h38v-148h-180v-370h-40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0492",
    unicode: "\u0492",
    horizAdvX: 400,
    d: "M90 0v345h-90v40h90v282h296v-40h-252v-242h136v-40h-136v-345h-44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0493",
    unicode: "\u0493",
    horizAdvX: 300,
    d: "M72 0v200h-72v38h72v170h220v-38h-180v-132h100v-38h-100v-200h-40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0494",
    unicode: "\u0494",
    horizAdvX: 526,
    d: "M386 627h-252v-262q69 23 137 23q115 0 167 -61q42 -49 42 -133q0 -110 -67 -163q-47 -37 -127 -37q-30 0 -68 6v40q28 -6 63 -6q70 0 107 33q46 41 46 125q0 65 -33 107q-41 49 -127 49q-71 0 -140 -23v-325h-44v667h296v-40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0495",
    unicode: "\u0495",
    horizAdvX: 380,
    d: "M72 0v408h220v-38h-180v-134h30q71 0 120 -35q72 -52 72 -166q0 -108 -70 -178q-52 -52 -129 -65v40q60 13 101 56q56 59 56 149q0 43 -16 79.5t-45 56.5q-37 25 -89 25h-30v-198h-40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0496",
    unicode: "\u0496",
    horizAdvX: 796,
    d: "M376 667h44v-314l282 314h58l-296 -323l281 -304h37v-174h-42v134h-16l-291 314l-13 -13v-301h-44v301l-13 13l-291 -314h-58l318 344l-296 323h58l282 -314v314z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0497",
    unicode: "\u0497",
    horizAdvX: 560,
    d: "M260 408h40v-194l184 194h52l-190 -196l169 -174h37v-148h-38v110h-16l-178 186l-20 -20v-166h-40v166l-20 20l-178 -186h-54l206 212l-190 196h52l184 -194v194z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0498",
    unicode: "\u0498",
    horizAdvX: 554,
    d: "M136 554l-32 27q29 47 74 71q44 24 104 24q78 0 124 -43q48 -44 48 -120q0 -50 -26 -91q-25 -39 -62 -55q50 -12 85 -47q49 -51 49 -127q0 -92 -57 -147q-54 -52 -144 -56v-140h-44v141q-72 2 -128 47q-45 36 -73 92l42 20q21 -43 58 -75q55 -46 128 -46q35 0 71.5 13 t59.5 36q41 41 41 113q0 68 -48 109q-46 39 -130 39h-60v40h50q67 0 107 41q35 35 35 93q0 52 -31 86q-34 37 -98 37q-54 0 -94 -29q-29 -21 -49 -53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0499",
    unicode: "\u0499",
    horizAdvX: 400,
    d: "M105 322l-33 23q42 72 129 72q59 0 90 -29q33 -29 33 -79q0 -60 -47 -85q27 -6 48 -27q29 -29 29 -79q0 -63 -48 -99q-38 -29 -86 -30v-109h-40v110q-46 3 -83 29q-31 20 -51 60l36 23q15 -33 43 -52q31 -23 77 -23q51 0 78 23q32 26 32 70q0 39 -28 60q-24 18 -75 18 h-42v38h31q39 0 61 17q25 20 25 52t-21 53q-23 21 -63 21q-64 0 -95 -57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni049A",
    unicode: "\u049A",
    horizAdvX: 540,
    d: "M90 667h44v-314l315 314h58l-323 -319l303 -308h39v-174h-42v134h-18l-314 318l-18 -17v-301h-44v667z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni049B",
    unicode: "\u049B",
    horizAdvX: 396,
    d: "M72 408h40v-194l206 194h54l-208 -194l184 -176h40v-148h-38v110h-20l-196 187l-22 -21v-166h-40v408z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni049C",
    unicode: "\u049C",
    horizAdvX: 600,
    d: "M90 667h44v-303h72v140h40v-140l269 303h52l-287 -319l306 -348h-54l-286 324v-160h-40v160h-72v-324h-44v667z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni049D",
    unicode: "\u049D",
    horizAdvX: 400,
    d: "M72 408h40v-178h43v100h38v-100l149 178h46l-162 -194l166 -214h-50l-149 192v-120h-38v120h-43v-192h-40v408z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04A0",
    unicode: "\u04A0",
    horizAdvX: 624,
    d: "M174 0v627h-160v40h204v-314l315 314h58l-323 -319l342 -348h-60l-314 318l-18 -17v-301h-44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04A1",
    unicode: "\u04A1",
    horizAdvX: 432,
    d: "M108 0v370h-100v38h140v-194l206 194h54l-208 -194l224 -214h-58l-196 187l-22 -21v-166h-40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04A2",
    unicode: "\u04A2",
    horizAdvX: 672,
    d: "M90 0v667h44v-283h404v283h44v-627h76v-174h-42v134h-78v344h-404v-344h-44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04A3",
    unicode: "\u04A3",
    horizAdvX: 454,
    d: "M72 0v408h40v-180h230v180h40v-370h60v-148h-38v110h-62v190h-230v-190h-40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04A4",
    unicode: "\u04A4",
    horizAdvX: 848,
    d: "M90 0v667h44v-283h404v283h296v-40h-252v-627h-44v344h-404v-344h-44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04A5",
    unicode: "\u04A5",
    horizAdvX: 570,
    d: "M72 0v408h40v-180h230v180h220v-38h-180v-370h-40v190h-230v-190h-40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04AA",
    unicode: "\u04AA",
    horizAdvX: 678,
    d: "M624 589v-58q-45 53 -105.5 79t-119.5 26q-125 0 -213 -90q-86 -88 -86 -216q0 -125 84 -210q89 -91 218 -91q124 0 222 101v-58q-89 -77 -193 -82v-140h-44v141q-133 2 -232 99q-101 99 -101 242q0 146 102 246q98 98 244 98q132 0 224 -87z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04AB",
    unicode: "\u04AB",
    horizAdvX: 442,
    d: "M399 365v-53q-58 67 -139 67q-76 0 -124 -50q-48 -51 -48 -127t47 -125q48 -50 121 -50q84 0 148 73v-54q-54 -48 -123 -56v-110h-40v110q-81 3 -137 60q-58 60 -58 151q0 97 60 157q57 59 150 59q80 0 143 -52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04AE",
    unicode: "\u04AE",
    horizAdvX: 516,
    d: "M233 0v285l-219 382h50l192 -337l196 337h50l-225 -382v-285h-44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04AF",
    unicode: "\u04AF",
    horizAdvX: 390,
    d: "M8 408h44l143 -339l143 339h44l-167 -387v-251h-40v251z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04B0",
    unicode: "\u04B0",
    horizAdvX: 516,
    d: "M233 0v245h-200v40h200l-219 382h50l192 -337l196 337h50l-225 -382h200v-40h-200v-245h-44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04B1",
    unicode: "\u04B1",
    horizAdvX: 390,
    d: "M8 408h44l143 -339l143 339h44l-167 -387v-21h120v-38h-120v-192h-40v192h-120v38h120v21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04B2",
    unicode: "\u04B2",
    horizAdvX: 470,
    d: "M23 0l183 340l-175 327h48l151 -285l152 285h48l-174 -327l161 -300h22v-174h-42v134h-6l-161 300l-159 -300h-48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04B3",
    unicode: "\u04B3",
    horizAdvX: 400,
    d: "M8 0l165 214l-151 194h49l129 -168l127 168h49l-148 -194l135 -176h29v-148h-38v110h-11l-143 188l-143 -188h-49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04B6",
    unicode: "\u04B6",
    horizAdvX: 580,
    d: "M446 0v300q-112 -7 -170 -7q-91 0 -136 22q-44 21 -57 55t-13 94v203h44v-203q0 -20 1 -31.5t5.5 -29.5t16.5 -32t31 -23q31 -15 122 -15q69 0 156 7v327h44v-627h76v-174h-42v134h-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04B7",
    unicode: "\u04B7",
    horizAdvX: 412,
    d: "M300 0v169q-66 -10 -107 -10q-65 0 -96 22q-37 27 -37 104v123h40v-123q0 -56 27 -75q19 -13 61 -13q47 0 112 10v201h40v-370h60v-148h-38v110h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04B8",
    unicode: "\u04B8",
    horizAdvX: 580,
    d: "M446 0v300q-11 -1 -140 -7v-129h-40v129q-82 0 -126 22q-44 21 -57 55t-13 94v203h44v-203q0 -20 1 -31.5t5.5 -29.5t16.5 -32t31 -23q32 -15 98 -15v171h40v-171q50 0 140 7v327h44v-667h-44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04B9",
    unicode: "\u04B9",
    horizAdvX: 420,
    d: "M308 0v169q-39 -8 -84 -10v-80h-38v80q-58 0 -89 22q-37 27 -37 104v123h40v-123q0 -57 27 -75q20 -13 59 -13v120h38v-120q45 2 84 10v201h40v-408h-40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04BA",
    unicode: "\u04BA",
    horizAdvX: 580,
    d: "M134 667v-283h170q91 0 136 -22q44 -21 57 -55.5t13 -93.5v-213h-44v213q0 19 -1 31t-5.5 30t-16.5 32t-31 23q-31 15 -122 15h-156v-344h-44v667h44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04BB",
    unicode: "\u04BB",
    horizAdvX: 442,
    d: "M72 0v729h40v-385q41 73 125 73q76 0 113 -57q20 -32 20 -103v-257h-40v257q0 57 -16 82q-24 40 -80 40q-68 0 -100 -57q-22 -39 -22 -110v-212h-40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04C0",
    unicode: "\u04C0",
    horizAdvX: 184,
    d: "M72 667h40v-667h-40v667z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04C1",
    unicode: "\u04C1",
    horizAdvX: 796,
    d: "M376 667h44v-314l282 314h58l-296 -323l318 -344h-58l-291 314l-13 -13v-301h-44v301l-13 13l-291 -314h-58l318 344l-296 323h58l282 -314v314zM258 803l35 19q29 -64 105 -64t105 64l35 -19q-21 -46 -60.5 -65.5t-79.5 -19.5t-79.5 19.5t-60.5 65.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04C2",
    unicode: "\u04C2",
    horizAdvX: 560,
    d: "M260 408h40v-194l184 194h52l-190 -196l206 -212h-54l-178 186l-20 -20v-166h-40v166l-20 20l-178 -186h-54l206 212l-190 196h52l184 -194v194zM150 573l34 17q8 -31 33.5 -52t62.5 -21t62.5 21t33.5 52l34 -17q-30 -94 -130 -94t-130 94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04C3",
    unicode: "\u04C3",
    horizAdvX: 537,
    d: "M90 667h44v-314l315 314h58l-296 -298q76 0 116 -7t76 -32q91 -62 91 -226q0 -151 -66 -213q-54 -51 -145 -51q-29 0 -60 6v40q28 -6 58 -6q74 0 116 42q51 52 51 178q0 130 -66 187q-50 43 -139 43q-47 0 -109 -11v-319h-44v667z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04C4",
    unicode: "\u04C4",
    horizAdvX: 397,
    d: "M72 408h40v-194l206 194h54l-208 -193q64 0 108 -26q80 -47 80 -161q0 -102 -70 -171q-55 -53 -129 -65v40q61 14 101 56q56 59 56 141q0 99 -69 135q-37 19 -94 19h-35v-183h-40v408z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04C7",
    unicode: "\u04C7",
    horizAdvX: 672,
    d: "M90 0v667h44v-283h404v283h44v-758q0 -80 -38 -115q-26 -24 -70 -24q-25 0 -46 7v41q16 -6 37 -6q32 0 50 18q23 23 23 91v423h-404v-344h-44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04C8",
    unicode: "\u04C8",
    horizAdvX: 454,
    d: "M72 0v408h40v-180h230v180h40v-499q0 -79 -38 -115q-26 -24 -66 -24q-22 0 -38 6v37q20 -5 30 -5q30 0 47 17q25 24 25 92v273h-230v-190h-40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04D0",
    unicode: "\u04D0",
    horizAdvX: 586,
    d: "M524 0l-89 219h-284l-89 -219h-48l281 687l277 -687h-48zM167 259h252l-125 316zM153 803l35 19q29 -64 105 -64t105 64l35 -19q-21 -46 -60.5 -65.5t-79.5 -19.5t-79.5 19.5t-60.5 65.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04D1",
    unicode: "\u04D1",
    horizAdvX: 516,
    d: "M404 337v71h40v-408h-40v73q-55 -84 -159 -84q-83 0 -141 59t-58 156q0 95 55 154t144 59q102 0 159 -80zM247 379q-65 0 -112 -46.5t-47 -125.5q0 -73 43 -126.5t117 -53.5q73 0 115.5 52.5t42.5 127.5q0 83 -49 127.5t-110 44.5zM128 573l34 17q8 -31 33.5 -52 t62.5 -21t62.5 21t33.5 52l34 -17q-30 -94 -130 -94t-130 94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04D2",
    unicode: "\u04D2",
    horizAdvX: 586,
    d: "M524 0l-89 219h-284l-89 -219h-48l281 687l277 -687h-48zM167 259h252l-125 316zM162 780q0 16 11 27t27 11t27 -11t11 -27t-11 -27t-27 -11t-27 11t-11 27zM348 780q0 16 11 27t27 11t27 -11t11 -27t-11 -27t-27 -11t-27 11t-11 27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04D3",
    unicode: "\u04D3",
    horizAdvX: 516,
    d: "M404 337v71h40v-408h-40v73q-55 -84 -159 -84q-83 0 -141 59t-58 156q0 95 55 154t144 59q102 0 159 -80zM247 379q-65 0 -112 -46.5t-47 -125.5q0 -73 43 -126.5t117 -53.5q73 0 115.5 52.5t42.5 127.5q0 83 -49 127.5t-110 44.5zM135 526q0 15 10.5 25.5t25.5 10.5 t25.5 -10.5t10.5 -25.5t-10.5 -25.5t-25.5 -10.5t-25.5 10.5t-10.5 25.5zM301 526q0 15 10.5 25.5t25.5 10.5t25.5 -10.5t10.5 -25.5t-10.5 -25.5t-25.5 -10.5t-25.5 10.5t-10.5 25.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04D4",
    unicode: "\u04D4",
    horizAdvX: 852,
    d: "M523 0l-89 219h-285l-87 -219h-48l269 667h289l17 -40h-275l99 -242h268l17 -40h-268l124 -305h273l18 -40h-322zM165 259h252l-127 314z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04D5",
    unicode: "\u04D5",
    horizAdvX: 792,
    d: "M747 198h-350q1 -76 46 -123.5t112 -47.5q94 0 147 92l34 -24q-68 -106 -182 -106q-116 0 -168 102q-17 -50 -61.5 -76t-107.5 -26q-82 0 -127 37.5t-45 89.5q0 49 42 89t137 40q83 0 131 -42q0 176 -142 176q-67 0 -139 -37v41q68 34 141 34q58 0 101 -29t62 -85 q26 53 72 83.5t103 30.5q79 0 135.5 -57t58.5 -162zM402 236h303q-9 62 -51.5 102.5t-101.5 40.5t-100.5 -41t-49.5 -102zM223 207q-66 0 -101 -26t-35 -65q0 -38 33.5 -63.5t96.5 -25.5q70 0 102.5 28.5t32.5 64.5q0 34 -31 60.5t-98 26.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04D6",
    unicode: "\u04D6",
    horizAdvX: 464,
    d: "M410 667v-40h-276v-242h270v-40h-270v-305h276v-40h-320v667h320zM110 803l35 19q29 -64 105 -64t105 64l35 -19q-21 -46 -60.5 -65.5t-79.5 -19.5t-79.5 19.5t-60.5 65.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04D7",
    unicode: "\u04D7",
    horizAdvX: 483,
    d: "M437 199h-349q0 -76 47.5 -124t114.5 -48q48 0 85 25.5t57 67.5l34 -20q-23 -44 -67 -77.5t-112 -33.5q-93 0 -147 60.5t-54 152.5q0 101 58.5 158t139.5 57q83 0 138 -61t55 -157zM91 237h304q-8 62 -49.5 102t-101.5 40q-61 0 -103 -40.5t-50 -101.5zM112 573l34 17 q8 -31 33.5 -52t62.5 -21t62.5 21t33.5 52l34 -17q-30 -94 -130 -94t-130 94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04D8",
    unicode: "\u04D8",
    horizAdvX: 773,
    d: "M54 320h619v10q0 129 -86 217.5t-215 88.5q-109 0 -191 -70q-40 -33 -64 -74l-35 28q34 48 80 84q94 72 209 72q147 0 247.5 -98.5t100.5 -245.5q0 -149 -98.5 -246t-246.5 -97q-162 0 -251 112q-69 87 -69 219zM669 280h-569q4 -78 43 -138q30 -46 91.5 -79.5 t140.5 -33.5q116 0 197 72.5t97 178.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii10846",
    unicode: "\u04D9",
    horizAdvX: 483,
    d: "M46 207h349q0 80 -47 126t-115 46q-48 0 -85 -25.5t-57 -67.5l-34 20q23 44 67 77.5t112 33.5q93 0 147 -60.5t54 -152.5q0 -101 -58.5 -158t-139.5 -57q-84 0 -138.5 59.5t-54.5 158.5zM392 169h-304q8 -62 49.5 -102t101.5 -40q61 0 103 40.5t50 101.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04DA",
    unicode: "\u04DA",
    horizAdvX: 773,
    d: "M54 320h619v10q0 129 -86 217.5t-215 88.5q-109 0 -191 -70q-40 -33 -64 -74l-35 28q34 48 80 84q94 72 209 72q147 0 247.5 -98.5t100.5 -245.5q0 -149 -98.5 -246t-246.5 -97q-162 0 -251 112q-69 87 -69 219zM669 280h-569q4 -78 43 -138q30 -46 91.5 -79.5 t140.5 -33.5q116 0 197 72.5t97 178.5zM245 780q0 16 11 27t27 11t27 -11t11 -27t-11 -27t-27 -11t-27 11t-11 27zM431 780q0 16 11 27t27 11t27 -11t11 -27t-11 -27t-27 -11t-27 11t-11 27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04DB",
    unicode: "\u04DB",
    horizAdvX: 483,
    d: "M46 207h349q0 80 -47 126t-115 46q-48 0 -85 -25.5t-57 -67.5l-34 20q23 44 67 77.5t112 33.5q93 0 147 -60.5t54 -152.5q0 -101 -58.5 -158t-139.5 -57q-84 0 -138.5 59.5t-54.5 158.5zM392 169h-304q8 -62 49.5 -102t101.5 -40q61 0 103 40.5t50 101.5zM121 526 q0 15 10.5 25.5t25.5 10.5t25.5 -10.5t10.5 -25.5t-10.5 -25.5t-25.5 -10.5t-25.5 10.5t-10.5 25.5zM287 526q0 15 10.5 25.5t25.5 10.5t25.5 -10.5t10.5 -25.5t-10.5 -25.5t-25.5 -10.5t-25.5 10.5t-10.5 25.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04DC",
    unicode: "\u04DC",
    horizAdvX: 796,
    d: "M376 667h44v-314l282 314h58l-296 -323l318 -344h-58l-291 314l-13 -13v-301h-44v301l-13 13l-291 -314h-58l318 344l-296 323h58l282 -314v314zM267 780q0 16 11 27t27 11t27 -11t11 -27t-11 -27t-27 -11t-27 11t-11 27zM453 780q0 16 11 27t27 11t27 -11t11 -27 t-11 -27t-27 -11t-27 11t-11 27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04DD",
    unicode: "\u04DD",
    horizAdvX: 560,
    d: "M260 408h40v-194l184 194h52l-190 -196l206 -212h-54l-178 186l-20 -20v-166h-40v166l-20 20l-178 -186h-54l206 212l-190 196h52l184 -194v194zM161 526q0 15 10.5 25.5t25.5 10.5t25.5 -10.5t10.5 -25.5t-10.5 -25.5t-25.5 -10.5t-25.5 10.5t-10.5 25.5zM327 526 q0 15 10.5 25.5t25.5 10.5t25.5 -10.5t10.5 -25.5t-10.5 -25.5t-25.5 -10.5t-25.5 10.5t-10.5 25.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04DE",
    unicode: "\u04DE",
    horizAdvX: 554,
    d: "M136 554l-32 27q58 95 181 95q76 0 121 -43q48 -44 48 -120q0 -99 -88 -146q64 -16 99 -64t35 -112q0 -105 -76 -160q-58 -42 -145 -42q-83 0 -140 40.5t-85 100.5l42 20q25 -60 78.5 -90.5t107.5 -30.5q68 0 115 35q57 42 57 127q0 70 -47.5 109t-130.5 39h-60v40h60 q53 0 92.5 36.5t39.5 97.5q0 52 -31 86q-34 37 -97 37q-91 0 -144 -82zM154 780q0 16 11 27t27 11t27 -11t11 -27t-11 -27t-27 -11t-27 11t-11 27zM340 780q0 16 11 27t27 11t27 -11t11 -27t-11 -27t-27 -11t-27 11t-11 27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04DF",
    unicode: "\u04DF",
    horizAdvX: 400,
    d: "M105 322l-33 23q42 72 129 72q59 0 90 -29q33 -29 33 -79q0 -60 -47 -85q27 -6 48 -27q29 -29 29 -78q0 -63 -48 -100q-40 -30 -104 -30q-66 0 -107 31q-33 27 -49 59l36 23q15 -33 43 -52q31 -23 77 -23q51 0 78 23q32 26 32 70q0 39 -28 60q-24 18 -75 18h-42v38h31 q39 0 61 17q25 20 25 52t-21 53q-23 21 -63 21q-64 0 -95 -57zM81 526q0 15 10.5 25.5t25.5 10.5t25.5 -10.5t10.5 -25.5t-10.5 -25.5t-25.5 -10.5t-25.5 10.5t-10.5 25.5zM247 526q0 15 10.5 25.5t25.5 10.5t25.5 -10.5t10.5 -25.5t-10.5 -25.5t-25.5 -10.5t-25.5 10.5 t-10.5 25.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04E2",
    unicode: "\u04E2",
    horizAdvX: 700,
    d: "M566 0v556l-476 -573v684h44v-566l476 573v-674h-44zM215 750v44h270v-44h-270z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04E3",
    unicode: "\u04E3",
    horizAdvX: 474,
    d: "M72 408h40v-327l290 350v-431h-40v325l-290 -350v433zM102 493v39h270v-39h-270z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04E4",
    unicode: "\u04E4",
    horizAdvX: 700,
    d: "M566 0v556l-476 -573v684h44v-566l476 573v-674h-44zM219 780q0 16 11 27t27 11t27 -11t11 -27t-11 -27t-27 -11t-27 11t-11 27zM405 780q0 16 11 27t27 11t27 -11t11 -27t-11 -27t-27 -11t-27 11t-11 27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04E5",
    unicode: "\u04E5",
    horizAdvX: 474,
    d: "M72 408h40v-327l290 350v-431h-40v325l-290 -350v433zM118 526q0 15 10.5 25.5t25.5 10.5t25.5 -10.5t10.5 -25.5t-10.5 -25.5t-25.5 -10.5t-25.5 10.5t-10.5 25.5zM284 526q0 15 10.5 25.5t25.5 10.5t25.5 -10.5t10.5 -25.5t-10.5 -25.5t-25.5 -10.5t-25.5 10.5 t-10.5 25.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04E6",
    unicode: "\u04E6",
    horizAdvX: 800,
    d: "M400 676q146 0 246 -100t100 -244t-100 -243.5t-246 -99.5t-246 99.5t-100 243.5t100 244t246 100zM400 29q128 0 214 87.5t86 215.5q0 129 -86 216.5t-214 87.5t-214 -87.5t-86 -216.5q0 -128 86 -215.5t214 -87.5zM269 780q0 16 11 27t27 11t27 -11t11 -27t-11 -27 t-27 -11t-27 11t-11 27zM455 780q0 16 11 27t27 11t27 -11t11 -27t-11 -27t-27 -11t-27 11t-11 27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04E7",
    unicode: "\u04E7",
    horizAdvX: 520,
    d: "M260 417q91 0 152.5 -61.5t61.5 -152.5t-61.5 -152.5t-152.5 -61.5t-152.5 61.5t-61.5 152.5t61.5 152.5t152.5 61.5zM260 27q73 0 122.5 51t49.5 125t-49.5 125t-122.5 51t-122.5 -51t-49.5 -125t49.5 -125t122.5 -51zM141 526q0 15 10.5 25.5t25.5 10.5t25.5 -10.5 t10.5 -25.5t-10.5 -25.5t-25.5 -10.5t-25.5 10.5t-10.5 25.5zM307 526q0 15 10.5 25.5t25.5 10.5t25.5 -10.5t10.5 -25.5t-10.5 -25.5t-25.5 -10.5t-25.5 10.5t-10.5 25.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04E8",
    unicode: "\u04E8",
    horizAdvX: 800,
    d: "M400 676q146 0 246 -100t100 -244t-100 -243.5t-246 -99.5t-246 99.5t-100 243.5t100 244t246 100zM400 29q130 0 212.5 85.5t87.5 205.5h-600q5 -120 87.5 -205.5t212.5 -85.5zM101 360h598q-11 123 -97 199.5t-202 76.5t-202 -76.5t-97 -199.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04E9",
    unicode: "\u04E9",
    horizAdvX: 520,
    d: "M260 417q91 0 152.5 -61.5t61.5 -152.5t-61.5 -152.5t-152.5 -61.5t-152.5 61.5t-61.5 152.5t61.5 152.5t152.5 61.5zM431 189h-342q4 -71 54 -116.5t117 -45.5t117 45.5t54 116.5zM89 227h342q-9 71 -59.5 111.5t-111.5 40.5t-111.5 -40.5t-59.5 -111.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04EA",
    unicode: "\u04EA",
    horizAdvX: 800,
    d: "M400 676q146 0 246 -100t100 -244t-100 -243.5t-246 -99.5t-246 99.5t-100 243.5t100 244t246 100zM400 29q130 0 212.5 85.5t87.5 205.5h-600q5 -120 87.5 -205.5t212.5 -85.5zM101 360h598q-11 123 -97 199.5t-202 76.5t-202 -76.5t-97 -199.5zM269 780q0 16 11 27 t27 11t27 -11t11 -27t-11 -27t-27 -11t-27 11t-11 27zM455 780q0 16 11 27t27 11t27 -11t11 -27t-11 -27t-27 -11t-27 11t-11 27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04EB",
    unicode: "\u04EB",
    horizAdvX: 520,
    d: "M260 417q91 0 152.5 -61.5t61.5 -152.5t-61.5 -152.5t-152.5 -61.5t-152.5 61.5t-61.5 152.5t61.5 152.5t152.5 61.5zM431 189h-342q4 -71 54 -116.5t117 -45.5t117 45.5t54 116.5zM89 227h342q-9 71 -59.5 111.5t-111.5 40.5t-111.5 -40.5t-59.5 -111.5zM141 526 q0 15 10.5 25.5t25.5 10.5t25.5 -10.5t10.5 -25.5t-10.5 -25.5t-25.5 -10.5t-25.5 10.5t-10.5 25.5zM307 526q0 15 10.5 25.5t25.5 10.5t25.5 -10.5t10.5 -25.5t-10.5 -25.5t-25.5 -10.5t-25.5 10.5t-10.5 25.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04EE",
    unicode: "\u04EE",
    horizAdvX: 550,
    d: "M14 667h50l231 -432l195 432h46l-305 -667h-46l85 186zM150 750v44h270v-44h-270z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04EF",
    unicode: "\u04EF",
    horizAdvX: 428,
    d: "M106 -230l96 223l-194 415h46l171 -363l149 363h46l-268 -638h-46zM79 493v39h270v-39h-270z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04F0",
    unicode: "\u04F0",
    horizAdvX: 550,
    d: "M14 667h50l231 -432l195 432h46l-305 -667h-46l85 186zM153 780q0 16 11 27t27 11t27 -11t11 -27t-11 -27t-27 -11t-27 11t-11 27zM339 780q0 16 11 27t27 11t27 -11t11 -27t-11 -27t-27 -11t-27 11t-11 27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04F1",
    unicode: "\u04F1",
    horizAdvX: 428,
    d: "M106 -230l96 223l-194 415h46l171 -363l149 363h46l-268 -638h-46zM101 526q0 15 10.5 25.5t25.5 10.5t25.5 -10.5t10.5 -25.5t-10.5 -25.5t-25.5 -10.5t-25.5 10.5t-10.5 25.5zM267 526q0 15 10.5 25.5t25.5 10.5t25.5 -10.5t10.5 -25.5t-10.5 -25.5t-25.5 -10.5 t-25.5 10.5t-10.5 25.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04F2",
    unicode: "\u04F2",
    horizAdvX: 550,
    d: "M14 667h50l231 -432l195 432h46l-305 -667h-46l85 186zM265 854l52 -26l-100 -125l-36 15zM386 854l52 -26l-100 -125l-36 15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04F3",
    unicode: "\u04F3",
    horizAdvX: 428,
    d: "M106 -230l96 223l-194 415h46l171 -363l149 363h46l-268 -638h-46zM213 620l42 -25l-99 -128l-27 16zM324 620l42 -25l-99 -128l-27 16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04F4",
    unicode: "\u04F4",
    horizAdvX: 580,
    d: "M446 0v300q-112 -7 -170 -7q-91 0 -136 22q-44 21 -57 55t-13 94v203h44v-203q0 -20 1 -31.5t5.5 -29.5t16.5 -32t31 -23q31 -15 122 -15q69 0 156 7v327h44v-667h-44zM159 780q0 16 11 27t27 11t27 -11t11 -27t-11 -27t-27 -11t-27 11t-11 27zM345 780q0 16 11 27t27 11 t27 -11t11 -27t-11 -27t-27 -11t-27 11t-11 27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04F5",
    unicode: "\u04F5",
    horizAdvX: 412,
    d: "M300 0v169q-66 -10 -107 -10q-65 0 -96 22q-37 27 -37 104v123h40v-123q0 -56 27 -75q19 -13 61 -13q47 0 112 10v201h40v-408h-40zM87 526q0 15 10.5 25.5t25.5 10.5t25.5 -10.5t10.5 -25.5t-10.5 -25.5t-25.5 -10.5t-25.5 10.5t-10.5 25.5zM253 526q0 15 10.5 25.5 t25.5 10.5t25.5 -10.5t10.5 -25.5t-10.5 -25.5t-25.5 -10.5t-25.5 10.5t-10.5 25.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04F8",
    unicode: "\u04F8",
    horizAdvX: 690,
    d: "M90 0v667h44v-287h116q230 0 230 -183q0 -83 -53.5 -140t-162.5 -57h-174zM134 340v-300h112q101 0 146 44q42 40 42 113q0 87 -69 123q-39 20 -127 20h-104zM556 667h44v-667h-44v667zM214 780q0 16 11 27t27 11t27 -11t11 -27t-11 -27t-27 -11t-27 11t-11 27zM400 780 q0 16 11 27t27 11t27 -11t11 -27t-11 -27t-27 -11t-27 11t-11 27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04F9",
    unicode: "\u04F9",
    d: "M72 408h40v-170h97q70 0 104 -38q29 -32 29 -81q0 -55 -36 -88q-33 -31 -98 -31h-136v408zM112 38h96q42 0 64 19q28 23 28 62q0 41 -29 63q-24 18 -65 18h-94v-162zM388 408h40v-408h-40v408zM131 526q0 15 10.5 25.5t25.5 10.5t25.5 -10.5t10.5 -25.5t-10.5 -25.5 t-25.5 -10.5t-25.5 10.5t-10.5 25.5zM297 526q0 15 10.5 25.5t25.5 10.5t25.5 -10.5t10.5 -25.5t-10.5 -25.5t-25.5 -10.5t-25.5 10.5t-10.5 25.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2010",
    unicode: "\u2010",
    horizAdvX: 300,
    d: "M50 184v46h200v-46h-200z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2011",
    unicode: "\u2011",
    horizAdvX: 300,
    d: "M50 184v46h200v-46h-200z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "figuredash",
    unicode: "\u2012",
    horizAdvX: 540,
    d: "M70 319v38h400v-38h-400z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "endash",
    unicode: "\u2013",
    horizAdvX: 540,
    d: "M70 188v38h400v-38h-400z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emdash",
    unicode: "\u2014",
    horizAdvX: 740,
    d: "M70 188v38h600v-38h-600z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii00208",
    unicode: "\u2015",
    horizAdvX: 740,
    d: "M70 188v38h600v-38h-600z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteleft",
    unicode: "\u2018",
    horizAdvX: 228,
    d: "M164 667l-60 -202l-40 12l74 200z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteright",
    unicode: "\u2019",
    horizAdvX: 228,
    d: "M64 477l60 202l40 -12l-74 -200z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesinglbase",
    unicode: "\u201A",
    horizAdvX: 254,
    d: "M64 -137l60 202l40 -12l-74 -200z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblleft",
    unicode: "\u201C",
    horizAdvX: 344,
    d: "M164 667l-60 -202l-40 12l74 200zM280 667l-60 -202l-40 12l74 200z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblright",
    unicode: "\u201D",
    horizAdvX: 344,
    d: "M64 477l60 202l40 -12l-74 -200zM180 477l60 202l40 -12l-74 -200z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblbase",
    unicode: "\u201E",
    horizAdvX: 370,
    d: "M64 -137l60 202l40 -12l-74 -200zM180 -137l60 202l40 -12l-74 -200z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dagger",
    unicode: "\u2020",
    horizAdvX: 548,
    d: "M252 489v240h44v-240h160v-40h-160v-609h-44v609h-160v40h160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "daggerdbl",
    unicode: "\u2021",
    horizAdvX: 548,
    d: "M296 -160h-44v264h-160v40h160v305h-160v40h160v240h44v-240h160v-40h-160v-305h160v-40h-160v-264z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bullet",
    unicode: "\u2022",
    horizAdvX: 1000,
    d: "M360 340q0 58 41 99t99 41t99 -41t41 -99t-41 -99t-99 -41t-99 41t-41 99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ellipsis",
    unicode: "\u2026",
    horizAdvX: 606,
    d: "M64 30q0 16 10.5 26.5t26.5 10.5t26.5 -10.5t10.5 -26.5t-10.5 -26.5t-26.5 -10.5t-26.5 10.5t-10.5 26.5zM266 30q0 16 10.5 26.5t26.5 10.5t26.5 -10.5t10.5 -26.5t-10.5 -26.5t-26.5 -10.5t-26.5 10.5t-10.5 26.5zM468 30q0 16 10.5 26.5t26.5 10.5t26.5 -10.5 t10.5 -26.5t-10.5 -26.5t-26.5 -10.5t-26.5 10.5t-10.5 26.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "perthousand",
    unicode: "\u2030",
    horizAdvX: 930,
    d: "M169 673q61 0 98 -37t37 -94t-37 -94t-98 -37t-98 37t-37 94t37 94t98 37zM169 447q45 0 70 29t25 66t-25 66t-70 29t-70 -29t-25 -66t25 -66t70 -29zM92 1l394 681l30 -16l-394 -681zM439 256q61 0 98 -37t37 -94t-37 -94t-98 -37t-98 37t-37 94t37 94t98 37zM439 30 q45 0 70 29t25 66t-25 66t-70 29t-70 -29t-25 -66t25 -66t70 -29zM761 256q61 0 98 -37t37 -94t-37 -94t-98 -37t-98 37t-37 94t37 94t98 37zM761 30q45 0 70 29t25 66t-25 66t-70 29t-70 -29t-25 -66t25 -66t70 -29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglleft",
    unicode: "\u2039",
    horizAdvX: 242,
    d: "M188 333l-108 -126l108 -126l-26 -24l-130 150l130 150z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglright",
    unicode: "\u203A",
    horizAdvX: 242,
    d: "M54 81l108 126l-108 126l26 24l130 -150l-130 -150z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fraction",
    unicode: "\u2044",
    horizAdvX: 124,
    d: "M-150 1l394 681l30 -16l-394 -681z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2080",
    unicode: "\u2080",
    horizAdvX: 330,
    d: "M165 405q53 0 94 -48q51 -61 51 -157q0 -94 -51 -157q-40 -48 -94 -48t-94 48q-51 63 -51 157q0 96 51 157q41 48 94 48zM165 31q39 0 67 36q38 49 38 133q0 82 -38 132q-29 37 -67 37t-67 -37q-38 -50 -38 -132q0 -84 38 -133q28 -36 67 -36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2081",
    unicode: "\u2081",
    horizAdvX: 330,
    d: "M152 0v364h-62l12 36h88v-400h-38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2082",
    unicode: "\u2082",
    horizAdvX: 330,
    d: "M283 0h-246l146 169q33 38 41 53q21 33 21 70q0 34 -21.5 55.5t-58.5 21.5q-39 0 -62 -25q-21 -23 -21 -57h-36q0 50 32 84t88 34q52 0 85.5 -32t33.5 -81q0 -42 -26 -83q-2 -2 -9 -12t-13 -18.5t-10 -12.5l-110 -130h166v-36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2083",
    unicode: "\u2083",
    horizAdvX: 330,
    d: "M48 98h36q2 -22 12 -37q22 -30 62 -30q33 0 55.5 24t22.5 60q0 46 -40 65q-21 10 -56 10v36q34 0 58 17q33 24 33 61q0 28 -17 46.5t-48 18.5t-49 -19q-18 -18 -18 -45h-36q2 43 29 72q25 28 74 28q48 0 76.5 -29t28.5 -71q0 -71 -63 -96q32 -10 50 -36t18 -61 q0 -51 -34 -84t-84 -33q-63 0 -96 52q-14 23 -14 51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2084",
    unicode: "\u2084",
    horizAdvX: 330,
    d: "M250 413v-301h56v-36h-56v-76h-38v76h-204zM78 112h134v190z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2085",
    unicode: "\u2085",
    horizAdvX: 330,
    d: "M282 400v-36h-134l-30 -96q18 4 26 4q54 0 95 -35.5t41 -102.5q0 -64 -41 -101.5t-101 -37.5q-83 0 -120 66l38 10q26 -40 82 -40q45 0 73.5 28.5t28.5 74.5t-27.5 74t-72.5 28q-41 0 -75 -18l58 182h159z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2086",
    unicode: "\u2086",
    horizAdvX: 330,
    d: "M181 405l28 -21l-83 -119q20 10 46 10q56 0 95.5 -39.5t39.5 -100.5t-40 -100.5t-103 -39.5q-68 0 -104.5 42.5t-36.5 96.5q0 49 32 93zM165 31q43 0 72.5 29t29.5 74q0 46 -29 75.5t-73 29.5t-73 -29.5t-29 -75.5q0 -45 28.5 -74t73.5 -29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2087",
    unicode: "\u2087",
    horizAdvX: 329,
    d: "M13 19l234 345h-218v36h290l-272 -404z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2088",
    unicode: "\u2088",
    horizAdvX: 330,
    d: "M115 208q-56 29 -56 92q0 45 30 75t76 30t76 -30t30 -75q0 -63 -56 -92q68 -24 68 -102q0 -50 -34 -80.5t-84 -30.5t-84 30.5t-34 80.5q0 78 68 102zM165 226q30 0 49 23t19 51q0 26 -18.5 47.5t-49.5 21.5t-49.5 -21.5t-18.5 -47.5q0 -28 19 -51t49 -23zM165 31 q36 0 57 22t21 56q0 36 -21.5 58.5t-56.5 22.5t-56.5 -22.5t-21.5 -58.5q0 -34 21 -56t57 -22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2089",
    unicode: "\u2089",
    horizAdvX: 330,
    d: "M149 -5l-28 21l83 119q-20 -10 -46 -10q-56 0 -95.5 39.5t-39.5 100.5t40 100.5t103 39.5q68 0 104.5 -42.5t36.5 -96.5q0 -49 -32 -93zM165 369q-43 0 -72.5 -29t-29.5 -74q0 -46 29 -75.5t73 -29.5t73 29.5t29 75.5q0 45 -28.5 74t-73.5 29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Euro",
    unicode: "\u20AC",
    horizAdvX: 548,
    d: "M504 629l-20 -37q-64 44 -145 44q-49 0 -89.5 -19t-67.5 -50.5t-44.5 -65t-26.5 -70.5h325l-16 -40h-316q-4 -27 -4 -60q0 -15 2 -43h278l-16 -40h-256q3 -19 8.5 -38.5t16 -46t27.5 -49t39.5 -42.5t55.5 -31.5t73 -11.5q103 0 176 71v-58q-75 -53 -175 -53 q-58 0 -104.5 19t-74.5 47t-48 65.5t-28 67.5t-12 60h-68l16 40h46q-2 28 -2 43q0 33 4 60h-64l16 40h55q23 109 98.5 177t180.5 68q89 0 160 -47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B4",
    unicode: "\u20B4",
    horizAdvX: 548,
    d: "M140 554l-32 27q33 41 75 66q51 29 112 29q70 0 108 -38t38 -92q0 -66 -49 -115h90v-40h-127l-117 -103h244v-40h-281q-41 -47 -41 -109q0 -52 31 -81q29 -29 84 -29q56 0 103 42q38 34 54 79l38 -18q-21 -47 -61 -86q-60 -57 -138 -57q-69 0 -109 35q-48 41 -48 117 q0 57 37 107h-85v40h114l117 103h-231v40h267q62 50 62 112q0 38 -22 63q-26 30 -78 30q-51 0 -93 -26q-33 -20 -62 -56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20B6",
    horizAdvX: 548,
    d: "M142 357v310h129q97 0 149 -54q46 -48 46 -120q0 -76 -47 -123q-51 -53 -147 -53h-86v-90h167v-40h-167v-187h-44v187h-75v40h75v90h-75v40h75zM186 627v-270h88q68 0 109 39q37 36 37 96q0 62 -39 98q-40 37 -114 37h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20CF",
    horizAdvX: 548,
    d: "M142 357v310h129q97 0 149 -54q46 -48 46 -120q0 -76 -47 -123q-51 -53 -147 -53h-86v-90h167v-40h-167v-187h-44v187h-75v40h75v90h-75v40h75zM186 627v-270h88q68 0 109 39q37 36 37 96q0 62 -39 98q-40 37 -114 37h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20CE",
    horizAdvX: 548,
    d: "M142 357v310h129q97 0 149 -54q46 -48 46 -120q0 -76 -47 -123q-51 -53 -147 -53h-86v-90h167v-40h-167v-187h-44v187h-75v40h75v90h-75v40h75zM186 627v-270h88q68 0 109 39q37 36 37 96q0 62 -39 98q-40 37 -114 37h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20CD",
    horizAdvX: 548,
    d: "M142 357v310h129q97 0 149 -54q46 -48 46 -120q0 -76 -47 -123q-51 -53 -147 -53h-86v-90h167v-40h-167v-187h-44v187h-75v40h75v90h-75v40h75zM186 627v-270h88q68 0 109 39q37 36 37 96q0 62 -39 98q-40 37 -114 37h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20CC",
    horizAdvX: 548,
    d: "M142 357v310h129q97 0 149 -54q46 -48 46 -120q0 -76 -47 -123q-51 -53 -147 -53h-86v-90h167v-40h-167v-187h-44v187h-75v40h75v90h-75v40h75zM186 627v-270h88q68 0 109 39q37 36 37 96q0 62 -39 98q-40 37 -114 37h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20CB",
    horizAdvX: 548,
    d: "M142 357v310h129q97 0 149 -54q46 -48 46 -120q0 -76 -47 -123q-51 -53 -147 -53h-86v-90h167v-40h-167v-187h-44v187h-75v40h75v90h-75v40h75zM186 627v-270h88q68 0 109 39q37 36 37 96q0 62 -39 98q-40 37 -114 37h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20CA",
    horizAdvX: 548,
    d: "M142 357v310h129q97 0 149 -54q46 -48 46 -120q0 -76 -47 -123q-51 -53 -147 -53h-86v-90h167v-40h-167v-187h-44v187h-75v40h75v90h-75v40h75zM186 627v-270h88q68 0 109 39q37 36 37 96q0 62 -39 98q-40 37 -114 37h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20C9",
    horizAdvX: 548,
    d: "M142 357v310h129q97 0 149 -54q46 -48 46 -120q0 -76 -47 -123q-51 -53 -147 -53h-86v-90h167v-40h-167v-187h-44v187h-75v40h75v90h-75v40h75zM186 627v-270h88q68 0 109 39q37 36 37 96q0 62 -39 98q-40 37 -114 37h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20C8",
    horizAdvX: 548,
    d: "M142 357v310h129q97 0 149 -54q46 -48 46 -120q0 -76 -47 -123q-51 -53 -147 -53h-86v-90h167v-40h-167v-187h-44v187h-75v40h75v90h-75v40h75zM186 627v-270h88q68 0 109 39q37 36 37 96q0 62 -39 98q-40 37 -114 37h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20C7",
    horizAdvX: 548,
    d: "M142 357v310h129q97 0 149 -54q46 -48 46 -120q0 -76 -47 -123q-51 -53 -147 -53h-86v-90h167v-40h-167v-187h-44v187h-75v40h75v90h-75v40h75zM186 627v-270h88q68 0 109 39q37 36 37 96q0 62 -39 98q-40 37 -114 37h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20C6",
    horizAdvX: 548,
    d: "M142 357v310h129q97 0 149 -54q46 -48 46 -120q0 -76 -47 -123q-51 -53 -147 -53h-86v-90h167v-40h-167v-187h-44v187h-75v40h75v90h-75v40h75zM186 627v-270h88q68 0 109 39q37 36 37 96q0 62 -39 98q-40 37 -114 37h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20C5",
    horizAdvX: 548,
    d: "M142 357v310h129q97 0 149 -54q46 -48 46 -120q0 -76 -47 -123q-51 -53 -147 -53h-86v-90h167v-40h-167v-187h-44v187h-75v40h75v90h-75v40h75zM186 627v-270h88q68 0 109 39q37 36 37 96q0 62 -39 98q-40 37 -114 37h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20C4",
    horizAdvX: 548,
    d: "M142 357v310h129q97 0 149 -54q46 -48 46 -120q0 -76 -47 -123q-51 -53 -147 -53h-86v-90h167v-40h-167v-187h-44v187h-75v40h75v90h-75v40h75zM186 627v-270h88q68 0 109 39q37 36 37 96q0 62 -39 98q-40 37 -114 37h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20C3",
    horizAdvX: 548,
    d: "M142 357v310h129q97 0 149 -54q46 -48 46 -120q0 -76 -47 -123q-51 -53 -147 -53h-86v-90h167v-40h-167v-187h-44v187h-75v40h75v90h-75v40h75zM186 627v-270h88q68 0 109 39q37 36 37 96q0 62 -39 98q-40 37 -114 37h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20C2",
    horizAdvX: 548,
    d: "M142 357v310h129q97 0 149 -54q46 -48 46 -120q0 -76 -47 -123q-51 -53 -147 -53h-86v-90h167v-40h-167v-187h-44v187h-75v40h75v90h-75v40h75zM186 627v-270h88q68 0 109 39q37 36 37 96q0 62 -39 98q-40 37 -114 37h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20C1",
    horizAdvX: 548,
    d: "M142 357v310h129q97 0 149 -54q46 -48 46 -120q0 -76 -47 -123q-51 -53 -147 -53h-86v-90h167v-40h-167v-187h-44v187h-75v40h75v90h-75v40h75zM186 627v-270h88q68 0 109 39q37 36 37 96q0 62 -39 98q-40 37 -114 37h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20C0",
    horizAdvX: 548,
    d: "M142 357v310h129q97 0 149 -54q46 -48 46 -120q0 -76 -47 -123q-51 -53 -147 -53h-86v-90h167v-40h-167v-187h-44v187h-75v40h75v90h-75v40h75zM186 627v-270h88q68 0 109 39q37 36 37 96q0 62 -39 98q-40 37 -114 37h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20BF",
    horizAdvX: 548,
    d: "M142 357v310h129q97 0 149 -54q46 -48 46 -120q0 -76 -47 -123q-51 -53 -147 -53h-86v-90h167v-40h-167v-187h-44v187h-75v40h75v90h-75v40h75zM186 627v-270h88q68 0 109 39q37 36 37 96q0 62 -39 98q-40 37 -114 37h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20BE",
    horizAdvX: 548,
    d: "M142 357v310h129q97 0 149 -54q46 -48 46 -120q0 -76 -47 -123q-51 -53 -147 -53h-86v-90h167v-40h-167v-187h-44v187h-75v40h75v90h-75v40h75zM186 627v-270h88q68 0 109 39q37 36 37 96q0 62 -39 98q-40 37 -114 37h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20BD",
    horizAdvX: 548,
    d: "M142 357v310h129q97 0 149 -54q46 -48 46 -120q0 -76 -47 -123q-51 -53 -147 -53h-86v-90h167v-40h-167v-187h-44v187h-75v40h75v90h-75v40h75zM186 627v-270h88q68 0 109 39q37 36 37 96q0 62 -39 98q-40 37 -114 37h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20BC",
    horizAdvX: 548,
    d: "M142 357v310h129q97 0 149 -54q46 -48 46 -120q0 -76 -47 -123q-51 -53 -147 -53h-86v-90h167v-40h-167v-187h-44v187h-75v40h75v90h-75v40h75zM186 627v-270h88q68 0 109 39q37 36 37 96q0 62 -39 98q-40 37 -114 37h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20BB",
    horizAdvX: 548,
    d: "M142 357v310h129q97 0 149 -54q46 -48 46 -120q0 -76 -47 -123q-51 -53 -147 -53h-86v-90h167v-40h-167v-187h-44v187h-75v40h75v90h-75v40h75zM186 627v-270h88q68 0 109 39q37 36 37 96q0 62 -39 98q-40 37 -114 37h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20BA",
    horizAdvX: 548,
    d: "M142 357v310h129q97 0 149 -54q46 -48 46 -120q0 -76 -47 -123q-51 -53 -147 -53h-86v-90h167v-40h-167v-187h-44v187h-75v40h75v90h-75v40h75zM186 627v-270h88q68 0 109 39q37 36 37 96q0 62 -39 98q-40 37 -114 37h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20B9",
    horizAdvX: 548,
    d: "M142 357v310h129q97 0 149 -54q46 -48 46 -120q0 -76 -47 -123q-51 -53 -147 -53h-86v-90h167v-40h-167v-187h-44v187h-75v40h75v90h-75v40h75zM186 627v-270h88q68 0 109 39q37 36 37 96q0 62 -39 98q-40 37 -114 37h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6",
    unicode: "\u20B7",
    horizAdvX: 548,
    d: "M142 357v310h129q97 0 149 -54q46 -48 46 -120q0 -76 -47 -123q-51 -53 -147 -53h-86v-90h167v-40h-167v-187h-44v187h-75v40h75v90h-75v40h75zM186 627v-270h88q68 0 109 39q37 36 37 96q0 62 -39 98q-40 37 -114 37h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B8",
    unicode: "\u20B8",
    horizAdvX: 548,
    d: "M469 537h-173v-537h-44v537h-173v40h390v-40zM469 627h-390v40h390v-40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii61352",
    unicode: "\u2116",
    horizAdvX: 940,
    d: "M134 0h-44v674l448 -564v557h44v-684l-448 564v-547zM773 667q61 0 98 -37t37 -94t-37 -94t-98 -37t-98 37t-37 94t37 94t98 37zM773 441q45 0 70 29t25 66t-25 66t-70 29t-70 -29t-25 -66t25 -66t70 -29zM658 279v46h230v-46h-230z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2117",
    unicode: "\u2117",
    horizAdvX: 740,
    d: "M297 505h71q54 0 82 -26q27 -25 27 -71t-27 -73q-29 -29 -92 -29h-27v-171h-34v370zM331 474v-137h32q44 0 62 19q17 17 17 50q0 34 -17 51t-56 17h-38zM713 334q0 -65 -27 -132t-77 -116q-98 -96 -239 -96t-239 96q-50 49 -77 116t-27 132t27 131.5t77 115.5 q98 96 239 96t239 -96q50 -49 77 -115.5t27 -131.5zM370 647q-122 0 -210 -84q-45 -43 -72 -104.5t-27 -124.5q0 -64 27 -125.5t72 -104.5q88 -84 210 -84t210 84q45 43 72 104.5t27 125.5q0 63 -27 124.5t-72 104.5q-88 84 -210 84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "trademark",
    unicode: "\u2122",
    horizAdvX: 720,
    d: "M226 631h-93v-344h-40v344h-93v36h226v-36zM303 287h-38l45 410l163 -348l164 348l45 -410h-38l-31 277l-140 -299l-140 299z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "partialdiff",
    unicode: "\u2202",
    horizAdvX: 516,
    d: "M105 636l5 37q65 -7 124 -33q119 -53 183 -178q53 -103 53 -229q0 -89 -37 -149q-29 -47 -76.5 -71t-97.5 -24q-93 0 -153 65.5t-60 157.5q0 94 61 159.5t155 65.5t147 -78h2q-16 66 -61 132q-54 77 -138 115q-50 23 -107 30zM428 218q0 78 -45.5 129.5t-120.5 51.5 t-124.5 -53.5t-49.5 -135.5q0 -85 52 -134t119 -49q68 0 118.5 51.5t50.5 139.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "product",
    unicode: "\u220F",
    horizAdvX: 678,
    d: "M34 710v40h610v-40h-77v-920h77v-40h-202v40h81v920h-369v-920h80v-40h-200v40h76v920h-76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "summation",
    unicode: "\u2211",
    horizAdvX: 666,
    d: "M32 750h554v-215h-40v175h-465l253 -439l-256 -481h476v173h40v-213h-562v46l252 476l-252 432v46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "minus",
    unicode: "\u2212",
    d: "M33 310v38h434v-38h-434z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2215",
    unicode: "\u2215",
    horizAdvX: 468,
    d: "M-34 -158l504 901l32 -16l-504 -901z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2219",
    unicode: "\u2219",
    horizAdvX: 200,
    d: "M52 340q0 20 14 34t34 14t34 -14t14 -34t-14 -34t-34 -14t-34 14t-14 34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "radical",
    unicode: "\u221A",
    horizAdvX: 668,
    d: "M427 827h241v-38h-208l-244 -789h-43l-96 315h-77v38h109l84 -286h3z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "infinity",
    unicode: "\u221E",
    horizAdvX: 667,
    d: "M334 312q-27 -50 -72.5 -85t-97.5 -35q-63 0 -103.5 42t-40.5 108q0 64 41 105t104 41q50 0 95 -34t73 -85q27 49 71 84t100 35q64 0 103.5 -41.5t39.5 -106.5q0 -66 -39.5 -107t-103.5 -41q-56 0 -100 35.5t-70 84.5zM354 341q24 -49 64.5 -81t83.5 -32q47 0 76 32.5 t29 79.5q0 49 -29.5 80.5t-76.5 31.5q-79 0 -147 -111zM313 340q-23 42 -61.5 77t-86.5 35q-46 0 -75.5 -31t-29.5 -80q0 -50 29.5 -81.5t76.5 -31.5q77 0 147 112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "integral",
    unicode: "\u222B",
    d: "M378 739l-12 -36q-19 11 -42 11q-25 0 -38 -13q-16 -16 -16 -68v-766q0 -72 -27 -96q-23 -21 -67 -21q-26 0 -54 11l12 36q19 -11 42 -11q25 0 38 13q16 16 16 68v766q0 72 27 96q23 21 67 21q26 0 54 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "approxequal",
    unicode: "\u2248",
    d: "M39 342l-27 16q18 38 47 67q37 35 85 35q37 0 113 -40q72 -37 103 -37q38 0 65 27q19 19 36 51l27 -16q-18 -36 -39 -58q-40 -42 -95 -42q-44 0 -138 52q-46 25 -75 25q-37 0 -64 -26q-22 -21 -38 -54zM39 195l-27 16q18 38 47 67q37 35 85 35q37 0 113 -40 q72 -37 103 -37q38 0 65 27q19 19 36 51l27 -16q-18 -36 -39 -58q-40 -42 -95 -42q-44 0 -138 52q-46 25 -75 25q-37 0 -64 -26q-22 -21 -38 -54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "notequal",
    unicode: "\u2260",
    d: "M33 381v38h243l55 117h36l-55 -117h155v-38h-173l-49 -104h222v-38h-240l-58 -123h-36l58 123h-158v38h176l49 104h-225z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lessequal",
    unicode: "\u2264",
    d: "M33 378l434 192v-41l-390 -170l390 -170v-41l-434 192v38zM33 118h434v-38h-434v38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greaterequal",
    unicode: "\u2265",
    d: "M467 340l-434 -192v41l390 170l-390 170v41l434 -192v-38zM33 118h434v-38h-434v38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotmath",
    unicode: "\u22C5",
    horizAdvX: 200,
    d: "M52 340q0 20 14 34t34 14t34 -14t14 -34t-14 -34t-34 -14t-34 14t-14 34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lozenge",
    unicode: "\u25CA",
    horizAdvX: 700,
    d: "M90 334l260 360l260 -360l-260 -360zM564 334l-214 294l-214 -294l214 -294z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "openbullet",
    unicode: "\u25E6",
    d: "M250 667q60 0 97.5 -37t37.5 -94t-37.5 -94t-97.5 -37t-97.5 37t-37.5 94t37.5 94t97.5 37zM250 639q-46 0 -74.5 -29.5t-28.5 -73.5t28.5 -73.5t74.5 -29.5t74.5 29.5t28.5 73.5t-28.5 73.5t-74.5 29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF400",
    unicode: "\uF400",
    horizAdvX: 2,
    d: "M-173 620l43 -25l-105 -128l-30 16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF401",
    unicode: "\uF401",
    horizAdvX: 2,
    d: "M-182 854l50 -25l-134 -126l-32 18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF406",
    unicode: "\uF406",
    d: "M123 826h40q6 -20 24 -34q24 -18 63 -18t63 18q18 14 24 34h40q-4 -33 -29 -58q-36 -36 -98 -36t-98 36q-25 25 -29 58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF407",
    unicode: "\uF407",
    d: "M270 -50l46 -26l-108 -126l-30 18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF408",
    unicode: "\uF408",
    d: "M250 786l-96 -64l-34 27l130 90l130 -90l-34 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF409",
    unicode: "\uF409",
    d: "M193 -190l46 140l44 -14l-62 -136z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF40A",
    unicode: "\uF40A",
    d: "M193 520l46 160l44 -14l-62 -156z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF40B",
    unicode: "\uF40B",
    d: "M209 781q0 18 11.5 29.5t29.5 11.5t29.5 -11.5t11.5 -29.5t-11.5 -29.5t-29.5 -11.5t-29.5 11.5t-11.5 29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF40C",
    unicode: "\uF40C",
    d: "M170 787q0 33 23.5 56.5t56.5 23.5t56.5 -23.5t23.5 -56.5t-23.5 -56.5t-56.5 -23.5t-56.5 23.5t-23.5 56.5zM209 787q0 -18 11.5 -29.5t29.5 -11.5t29.5 11.5t11.5 29.5t-11.5 29.5t-29.5 11.5t-29.5 -11.5t-11.5 -29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF40D",
    unicode: "\uF40D",
    d: "M149 717l-29 22q11 25 23 38q20 22 45 22q22 0 64 -17q47 -18 59 -18q13 0 25 12q11 13 15 26l29 -22q-9 -27 -28 -43q-19 -17 -46 -17q-18 0 -58 17q-43 18 -58 18q-17 0 -28 -14q-6 -7 -13 -24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF40E",
    unicode: "\uF40E",
    d: "M360 -137l-9 -37q-22 -8 -45 -8q-45 0 -72.5 23.5t-27.5 59.5q0 33 23 62q16 20 43 37h44q-27 -18 -46 -42q-22 -29 -22 -55q0 -22 15 -35.5t45 -13.5q23 0 52 9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF4C6",
    unicode: "\uF4C6",
    horizAdvX: 580,
    d: "M490 667v-758q0 -80 -38 -115q-26 -24 -69 -24q-27 0 -47 7v41q16 -6 37 -6q32 0 50 18q23 23 23 91v379q-112 -7 -170 -7q-91 0 -136 22q-44 21 -57 55t-13 94v203h44v-203q0 -20 1 -31.5t5.5 -29.5t16.5 -32t31 -23q31 -15 122 -15q69 0 156 7v327h44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF4C7",
    unicode: "\uF4C7",
    horizAdvX: 412,
    d: "M300 408h40v-499q0 -79 -38 -115q-27 -24 -68 -24q-20 0 -36 6v37q17 -5 31 -5q29 0 46 17q25 24 25 92v252q-60 -10 -106 -10q-66 0 -97 22q-37 27 -37 104v123h40v-123q0 -56 27 -75q22 -13 62 -13q39 0 111 10v201z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF4CC",
    unicode: "\uF4CC",
    horizAdvX: 550,
    d: "M14 667h50l231 -432l195 432h46l-305 -667h-46l85 186zM341 854l50 -25l-134 -126l-32 18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF4CD",
    unicode: "\uF4CD",
    horizAdvX: 428,
    d: "M106 -230l96 223l-194 415h46l171 -363l149 363h46l-268 -638h-46zM269 620l43 -25l-105 -128l-30 16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dollar.fitted",
    unicode: "\uF5F5",
    horizAdvX: 429,
    d: "M382 581l-32 -27q-5 12 -13.5 25t-34 32.5t-56.5 24.5v-270q70 -32 99 -53q71 -49 71 -129q0 -68 -47 -124t-123 -68v-99h-40v96q-93 0 -153 70q-29 34 -43 73l38 18q12 -36 36 -64q44 -55 122 -57v310l-25 12q-48 23 -72 40.5t-39 42.5q-21 35 -21 76q0 68 44 115.5 t113 50.5v89h40v-89q93 -11 136 -95zM246 319v-287q56 12 90 55t34 96q0 65 -65 105q-2 1 -8 4.5t-19 10.5t-32 16zM206 386v250q-51 -3 -81 -40t-30 -84q0 -44 27 -73.5t84 -52.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Euro.fitted",
    unicode: "\uF5F6",
    horizAdvX: 552,
    d: "M526 629l-20 -37q-64 44 -145 44q-49 0 -89.5 -19t-67.5 -50.5t-44.5 -65t-26.5 -70.5h325l-16 -40h-316q-4 -27 -4 -60q0 -15 2 -43h278l-16 -40h-256q3 -19 8.5 -38.5t16 -46t27.5 -49t39.5 -42.5t55.5 -31.5t73 -11.5q103 0 176 71v-58q-75 -53 -175 -53 q-58 0 -104.5 19t-74.5 47t-48 65.5t-28 67.5t-12 60h-68l16 40h46q-2 28 -2 43q0 33 4 60h-64l16 40h55q23 109 98.5 177t180.5 68q89 0 160 -47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cent.fitted",
    unicode: "\uF5F7",
    horizAdvX: 379,
    d: "M235 655v-102q68 0 129 -51v-53q-58 62 -129 66v-350q76 3 134 72v-54q-61 -53 -134 -56v-114h-38v114q-83 11 -134.5 69.5t-51.5 141.5q0 86 51.5 144.5t134.5 69.5v103h38zM197 165v349q-71 -13 -107.5 -63.5t-36.5 -111.5q0 -60 37.5 -111.5t106.5 -62.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sterling.fitted",
    unicode: "\uF5F8",
    horizAdvX: 477,
    d: "M49 273v40h98l-21 35q-26 44 -40 70q-23 46 -23 84q0 72 51 122q52 50 128 50q70 0 116 -45q53 -53 53 -140h-44q0 75 -42 113q-35 32 -84 32q-58 0 -96 -39q-36 -37 -36 -88q0 -39 27 -89q10 -19 46 -77l17 -28h121v-40h-108q22 -44 22 -88q0 -55 -46 -115l65 -22 q51 -17 72 -17q33 0 57 21t37 48l36 -22q-19 -37 -52 -64t-73 -27q-12 0 -28 3.5t-27 7t-34 11t-31 10.5q-51 17 -74 17q-41 0 -91 -46l-24 32q53 57 119 57q50 52 50 106q0 44 -27 88h-114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yen.fitted",
    unicode: "\uF5F9",
    horizAdvX: 512,
    d: "M482 391h-145l-61 -103h206v-40h-207v-248h-44v248h-200v40h198l-59 103h-139v40h116l-134 236h51l190 -335l194 335h51l-139 -236h122v-40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "florin.fitted",
    unicode: "\uF5FA",
    horizAdvX: 430,
    d: "M153 370l7 38h62l45 235q10 49 33 72q25 25 69 25q30 0 58 -14l-8 -36q-23 12 -46 12q-30 0 -46 -15t-21 -44l-44 -235h101l-7 -38h-101l-72 -385q-16 -89 -45 -118q-27 -27 -74 -27q-38 0 -68 14l8 37q29 -13 56 -13q32 0 49 17q18 18 31 84l75 391h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B4.fitted",
    unicode: "\uF5FB",
    horizAdvX: 452,
    d: "M91 554l-32 27q33 41 75 66q51 29 112 29q70 0 108 -38t38 -92q0 -66 -49 -115h90v-40h-127l-117 -103h244v-40h-281q-41 -47 -41 -109q0 -52 31 -81q29 -29 84 -29q56 0 103 42q38 34 54 79l38 -18q-21 -47 -61 -86q-60 -57 -138 -57q-69 0 -109 35q-48 41 -48 117 q0 57 37 107h-85v40h114l117 103h-231v40h267q62 50 62 112q0 38 -22 63q-26 30 -78 30q-51 0 -93 -26q-33 -20 -62 -56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B6.fitted",
    unicode: "\uF5FC",
    horizAdvX: 422,
    d: "M91 357v310h129q97 0 149 -54q46 -48 46 -120q0 -76 -47 -123q-51 -53 -147 -53h-86v-90h167v-40h-167v-187h-44v187h-75v40h75v90h-75v40h75zM135 627v-270h88q68 0 109 39q37 36 37 96q0 62 -39 98q-40 37 -114 37h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B8.fitted",
    unicode: "\uF5FD",
    horizAdvX: 396,
    d: "M393 537h-173v-537h-44v537h-173v40h390v-40zM393 627h-390v40h390v-40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "currency.fitted",
    unicode: "\uF5FE",
    horizAdvX: 578,
    d: "M55 90l-24 25l90 89q-56 62 -56 146q0 83 53 143l-90 90l24 24l90 -89q61 56 147 56t147 -56l90 89l24 -24l-90 -90q54 -59 54 -144q0 -78 -55 -143l91 -91l-24 -24l-91 91q-61 -55 -144 -55q-84 0 -146 53zM476 350q0 77 -55 132.5t-132 55.5t-131.5 -55.5t-54.5 -132.5 t54.5 -132t131.5 -55t132 55t55 132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF639",
    unicode: "\uF639",
    horizAdvX: 536,
    d: "M268 676q90 0 157 -81q85 -101 85 -262t-85 -262q-69 -82 -157 -82t-157 82q-85 101 -85 262t85 262q67 81 157 81zM268 29q69 0 124 68q72 89 72 236t-72 236q-54 67 -124 67t-124 -67q-72 -89 -72 -236t72 -236q55 -68 124 -68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF63A",
    unicode: "\uF63A",
    horizAdvX: 454,
    d: "M434 0h-411l256 282q53 60 73 90q39 60 39 114q0 64 -43.5 107t-111.5 43q-72 0 -115 -49q-39 -43 -39 -109h-44q0 85 53 140q56 58 148 58q86 0 142 -54.5t56 -135.5q0 -71 -48 -137q-23 -32 -59 -72l-214 -237h318v-40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF63B",
    unicode: "\uF63B",
    horizAdvX: 429,
    d: "M21 162h44q2 -39 22 -71q19 -27 52 -44.5t66 -17.5q61 0 105.5 46t44.5 109q0 82 -63 122q-31 20 -85 20v40q54 0 90 31q49 41 49 109q0 56 -34 93t-94 37q-62 0 -96 -39q-32 -35 -34 -89h-42q1 71 49 120q47 48 123 48q80 0 127 -48t47 -119q0 -50 -25 -94.5t-80 -66.5 q53 -17 83.5 -61t30.5 -102q0 -83 -57 -139.5t-139 -56.5q-47 0 -91 23t-69 64q-24 39 -24 86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF63C",
    unicode: "\uF63C",
    horizAdvX: 514,
    d: "M404 689v-522h93v-40h-93v-127h-44v127h-359zM79 167h281v392z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF63D",
    unicode: "\uF63D",
    horizAdvX: 473,
    d: "M453 667v-40h-224l-56 -180q24 6 45 6q105 0 168.5 -65t63.5 -166q0 -105 -68.5 -169t-168.5 -64q-136 0 -200 110l39 16q58 -86 162 -86q83 0 136.5 54t53.5 138q0 85 -52.5 138.5t-135.5 53.5q-57 0 -104 -29l86 283h255z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF63E",
    unicode: "\uF63E",
    horizAdvX: 509,
    d: "M283 676l34 -26l-148 -210q43 18 91 18q100 0 166 -66t66 -167t-67 -168.5t-171 -67.5q-102 0 -169 66.5t-67 170.5q0 73 43 136zM255 29q82 0 136.5 56t54.5 139q0 85 -54 139.5t-137 54.5t-137 -55t-54 -139t54.5 -139.5t136.5 -55.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF63F",
    unicode: "\uF63F",
    horizAdvX: 522,
    d: "M11 14l432 613h-405v40h483l-477 -678z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF640",
    unicode: "\uF640",
    horizAdvX: 440,
    d: "M304 346q52 -20 80.5 -66t28.5 -103q0 -85 -56 -136.5t-137 -51.5t-137 51.5t-56 136.5q0 57 28.5 103t80.5 66q-93 49 -93 154q0 75 51 125.5t126 50.5t126 -50.5t51 -125.5q0 -105 -93 -154zM220 365q54 0 92.5 38.5t38.5 96.5q0 59 -38 97.5t-93 38.5t-93 -38.5 t-38 -97.5q0 -58 38.5 -96.5t92.5 -38.5zM220 29q66 0 106.5 42.5t40.5 105.5q0 66 -41 108t-106 42t-106 -42t-41 -108q0 -63 40.5 -105.5t106.5 -42.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF641",
    unicode: "\uF641",
    horizAdvX: 508,
    d: "M226 -11l-34 26l148 211q-43 -18 -91 -18q-100 0 -166 66t-66 167t67 168t171 67q102 0 169 -67t67 -169q0 -73 -43 -136zM254 636q-82 0 -136.5 -56t-54.5 -138q0 -85 54.5 -139.5t136.5 -54.5q83 0 137 55t54 139q0 83 -54.5 138.5t-136.5 55.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF6BA",
    unicode: "\uF6BA",
    horizAdvX: 300,
    d: "M50 315v46h200v-46h-200z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF6BB",
    unicode: "\uF6BB",
    horizAdvX: 540,
    d: "M70 319v38h400v-38h-400z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF6BC",
    unicode: "\uF6BC",
    horizAdvX: 740,
    d: "M70 319v38h600v-38h-600z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF6C3",
    unicode: "\uF6C3",
    d: "M192 -190l46 140l44 -14l-62 -136z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF6C9",
    unicode: "\uF6C9",
    d: "M316 854l50 -25l-134 -126l-32 18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF6CA",
    unicode: "\uF6CA",
    d: "M250 775l96 64l34 -27l-130 -90l-130 90l34 27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF6CB",
    unicode: "\uF6CB",
    d: "M119 780q0 16 11 27t27 11t27 -11t11 -27t-11 -27t-27 -11t-27 11t-11 27zM305 780q0 16 11 27t27 11t27 -11t11 -27t-11 -27t-27 -11t-27 11t-11 27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF6CE",
    unicode: "\uF6CE",
    d: "M268 703l-134 126l50 25l116 -133z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF6CF",
    unicode: "\uF6CF",
    d: "M240 854l52 -26l-100 -125l-36 15zM361 854l52 -26l-100 -125l-36 15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF6D0",
    unicode: "\uF6D0",
    d: "M115 750v44h270v-44h-270z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF6D1",
    unicode: "\uF6D1",
    d: "M110 803l35 19q29 -64 105 -64t105 64l35 -19q-21 -46 -60.5 -65.5t-79.5 -19.5t-79.5 19.5t-60.5 65.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF6D4",
    unicode: "\uF6D4",
    d: "M120 573l34 17q8 -31 33.5 -52t62.5 -21t62.5 21t33.5 52l34 -17q-30 -94 -130 -94t-130 94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF6DC",
    unicode: "\uF6DC",
    horizAdvX: 188,
    d: "M104 0v627h-104l20 40h128v-667h-44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF6DE",
    unicode: "\uF6DE",
    horizAdvX: 555,
    d: "M52 188v38h450v-38h-450z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nbspace",
    horizAdvX: 233
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hyphenminus",
    horizAdvX: 300,
    d: "M50 184v46h200v-46h-200z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotlessi1",
    horizAdvX: 184,
    d: "M72 408h40v-408h-40v408z"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "Q",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u0459",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u0442",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u0434",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u0414",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "7",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "6",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "2",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "1",
    k: 138
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: ",",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "9",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "8",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "7",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "6",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "5",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "4",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "3",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "2",
    k: 167
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "1",
    k: 213
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "0",
    k: 112
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: ".",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "7",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "5",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "4",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "3",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "2",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "1",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "7",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "5",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "4",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "3",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "2",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "1",
    k: 138
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "3",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "1",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "4",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "3",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "2",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "1",
    k: 112
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "2",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "1",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: ",",
    k: 175
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: ":",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "9",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "8",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "7",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "6",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "5",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "4",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "3",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "2",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "1",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "0",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: ".",
    k: 162
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "7",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "5",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "3",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "2",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "1",
    k: 138
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "7",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "2",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "1",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u201D",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u201C",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u2018",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "v",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "q",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "j",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "f",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "Q",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "J",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: ".",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "*",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "Y",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "W",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "V",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "T",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "C",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "\u201D",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "x",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "v",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "q",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "Q",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u2122",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "X",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "v",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "q",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "J",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "z",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "y",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "w",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "u",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "t",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "s",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "r",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "o",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "n",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "i",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "h",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "g",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "e",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "d",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "c",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "a",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "S",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "O",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "G",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "C",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: ",",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u2122",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u2026",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "x",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "v",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "q",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "p",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "m",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "j",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "Q",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "J",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: ".",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "H",
    u2: "\u2122",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "\u2122",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\u2122",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "x",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "v",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "v",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "q",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "p",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "Q",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "J",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u201D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "v",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "q",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "Q",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "*",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "Y",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "T",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "S",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "N",
    u2: "\u2122",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "X",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    g2: "hyphenminus",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\uF6BC",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\uF6BB",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\uF6BA",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u2014",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u2013",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u2012",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u2011",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u2010",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "z",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "u",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "s",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "r",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "o",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "n",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "h",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "g",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "e",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "d",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "c",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "a",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "Z",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "Y",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "S",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "A",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "-",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: ",",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u2122",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u2026",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "x",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "q",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "p",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "m",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "j",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "X",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "M",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "J",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: ".",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u201D",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u2019",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "z",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "Y",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "T",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u2122",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u2122",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "x",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "v",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "q",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "p",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "m",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "j",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "x",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "v",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "X",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "M",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u2122",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u2026",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "x",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "v",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "q",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "p",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "m",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "k",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "j",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "b",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "Q",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "M",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: ".",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\u2122",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u2122",
    k: -94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u2026",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "x",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "v",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "q",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "p",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "m",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "M",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: ".",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u2122",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u2026",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "x",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "v",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "q",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "p",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "m",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "M",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: ".",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "z",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "y",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "w",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "u",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "t",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "s",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "a",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "S",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "O",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "G",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "C",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "x",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "v",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "q",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "Q",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u2122",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u2039",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u2026",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "x",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "v",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "q",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "p",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "m",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "Q",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "M",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "J",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: ".",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "v",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "q",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "p",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "f",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "Q",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "M",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "a",
    u2: "\u201D",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "a",
    u2: "\u2018",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "x",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "v",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "x",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "v",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "f",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "g",
    u2: "J",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "y",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "Y",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "W",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "V",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "T",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "v",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "q",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "p",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "m",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "k",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "j",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "h",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "f",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "Q",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "v",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "q",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "p",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "m",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "k",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "j",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "h",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "f",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "Q",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "Y",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "V",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "T",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "z",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "Y",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "V",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "T",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "Y",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "V",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "T",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "J",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\u2026",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "v",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "q",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "J",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: ".",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: "x",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: "v",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: "f",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    g2: "hyphenminus",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\uF6BC",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\uF6BB",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\uF6BA",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u2014",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u2013",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u2012",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u2011",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u2010",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "z",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "Y",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "V",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "T",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: ";",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: ":",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: ".",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "-",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: ",",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u2026",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "J",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: "f",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: "J",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "u",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "s",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "Y",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "W",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "V",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "T",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "\u2026",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "f",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: ".",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "z",
    u2: "q",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0401",
    g2: "afii10085.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0401",
    u2: "\u04F3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0401",
    u2: "\u04F1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0401",
    u2: "\u04EF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0401",
    u2: "\u04AF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0401",
    u2: "\u045E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0401",
    u2: "\u0443",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0401",
    u2: "\u2122",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0401",
    u2: "\u04F5",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0401",
    u2: "\u04B9",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0401",
    u2: "\u04B7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0401",
    u2: "\u04B3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0401",
    u2: "\u0447",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0401",
    u2: "\u0445",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    g2: "afii10037.var.accented",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    g2: "afii10032.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u201D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u2019",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u04F2",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u04F0",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u04EE",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u04EA",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u04E8",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u04E6",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u04D8",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u04AE",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0423",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0422",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u041E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u041B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u040E",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u040B",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0409",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0404",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    g2: "afii10049.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u201C",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u04F4",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u04C1",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u04B8",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u04B6",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u04AA",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0472",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u042F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u042A",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0427",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0424",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0421",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0402",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    g2: "afii10097.var.accented",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    g2: "afii10096.var.accented",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    g2: "afii10095.var.accented",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    g2: "afii10093.var.accented",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    g2: "afii10080.var.accented",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    g2: "afii10049.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    g2: "afii10047.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u2122",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u2026",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u2018",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u04F9",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u04F5",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u04EB",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u04E9",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u04E7",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u04E5",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u04E3",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u04DD",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u04DC",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u04C4",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u04C2",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u04C1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u04B9",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u04B7",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u04B3",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u04AB",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u049D",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u049B",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0497",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0496",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0493",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0473",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0472",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u045E",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u045C",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0458",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0457",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0456",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0455",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0453",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u044F",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u044D",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u044A",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0447",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0445",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0444",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0442",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u043C",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0436",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0434",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0431",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u042F",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u042D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u042A",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0424",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u041C",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0416",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0414",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: "\u0409",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: ":",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0403",
    u2: ".",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u201D",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u2019",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u2122",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u201C",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u2018",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u04F5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u04F4",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u04B9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u04B8",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u04B7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u04B6",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u04AA",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0447",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0427",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0421",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0404",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0406",
    u2: "\u2122",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0407",
    u2: "\u2122",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0407",
    u2: "\u0407",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    g2: "afii10037.var.accented",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    g2: "afii10032.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u04F2",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u04F0",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u04EE",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u04EA",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u04E8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u04E6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u04DE",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u04D8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u04AE",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u04AA",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u0498",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u0423",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u0422",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u0421",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u041E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u0417",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u040E",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u0402",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    g2: "afii10047.var.accented",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u201C",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u2018",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u04F4",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u04DC",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u04C1",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u04B8",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u04B6",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u04B2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u0496",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u0472",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u042D",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u042A",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u0427",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u0425",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u0424",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u041C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u0416",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u0414",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u040B",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u0409",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u0404",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    g2: "afii10037.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u04F2",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u04F0",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u04EE",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u04DE",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u04AE",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u0498",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u0423",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u0422",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u041B",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u0417",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u040E",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    g2: "afii10047.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u201C",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u2018",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u04F4",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u04C1",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u04B8",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u04B6",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u04B2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u0472",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u042D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u042A",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u0427",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u0425",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u0424",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u041C",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u0414",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u040B",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u0409",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u0404",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u0402",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u201C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u2018",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u04F4",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u04B8",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u04B6",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u04AA",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u0472",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u042A",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u0427",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u0424",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u0421",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u040B",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    g2: "afii10071.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    g2: "afii10096.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    g2: "afii10093.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    g2: "afii10085.var.accented",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    g2: "afii10080.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    g2: "afii10074.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    g2: "afii10070.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    g2: "afii10065.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    g2: "afii10037.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    g2: "afii10032.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    g2: "afii10017.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04F9",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04F3",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04F2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04F1",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04F0",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04EF",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04EE",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04EB",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04EA",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04E9",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04E8",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04E7",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04E6",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04DE",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04D9",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04D8",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04D7",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04D3",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04D2",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04D1",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04D0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04C8",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04BB",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04AF",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04AE",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04AB",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04A3",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0498",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0493",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0491",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u045F",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u045E",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u045C",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u045B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u045A",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0458",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0457",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0456",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0454",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0453",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0452",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0451",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u044E",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u044C",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u044B",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0449",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0448",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0446",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0443",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0441",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0440",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u043F",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u043E",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u043D",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u043A",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0439",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0438",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0435",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0433",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0432",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0430",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0423",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0422",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u041E",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0417",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0410",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u040E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    g2: "afii10097.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    g2: "afii10095.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    g2: "afii10049.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    g2: "afii10047.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u2122",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04F5",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04F4",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04E5",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04E3",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04DD",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04DC",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04C4",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04C2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04C1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04B9",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04B8",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04B7",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04B6",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04B3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04B2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u04AA",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u049D",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u049B",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0497",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0496",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0473",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0472",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u044F",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u044D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u044A",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0447",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0445",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0444",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0442",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u043C",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0436",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0431",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u042F",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u042D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u042A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0427",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0425",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0424",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0421",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0420",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0416",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0412",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u040B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0404",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u0402",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    g2: "afii10032.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04EA",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04E8",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04E6",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04D8",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u041E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    g2: "afii10097.var.accented",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    g2: "afii10049.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u2026",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u201C",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u2018",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04F5",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04F4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04E5",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04E3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04DD",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04DC",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04C4",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04C2",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04C1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04B9",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04B8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04B7",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04B6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04B3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u04AA",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u049D",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u049B",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0497",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0496",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0473",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0472",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0458",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0457",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0456",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0455",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0454",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u044F",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u044A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0447",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0445",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0442",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u043C",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0436",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0434",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0431",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u042F",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0427",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0424",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0421",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u041C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0416",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0414",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "\u0404",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: ".",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040F",
    u2: "\u2122",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    g2: "hyphenminus",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    g2: "afii10047.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u2122",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u2039",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u201C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u2018",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u04F5",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u04F4",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u04B9",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u04B8",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u04B7",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u04B6",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u04AF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u04AA",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0459",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u044A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0447",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0442",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u042D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u042A",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0427",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0424",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0414",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u040B",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0402",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: ".",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "*",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    g2: "afii10037.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    g2: "afii10032.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    g2: "afii10017.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04F2",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04F0",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04EE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04EA",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04E8",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04E6",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04DE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04D8",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04D2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04D0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04AE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04AA",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0498",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0423",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0422",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0421",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u041E",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u041B",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0417",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0410",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u040E",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u040B",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0409",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    g2: "afii10049.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    g2: "afii10047.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u2122",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04F4",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04DC",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04C1",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04B8",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04B6",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04B2",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0496",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0472",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u042F",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u042D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u042A",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0427",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0425",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0424",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u041C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0416",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0414",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0404",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0402",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u04B2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u042A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0425",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0424",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    g2: "afii10097.var.accented",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    g2: "afii10096.var.accented",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    g2: "afii10095.var.accented",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    g2: "afii10093.var.accented",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    g2: "afii10080.var.accented",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    g2: "afii10049.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    g2: "afii10047.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u2122",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u2026",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u2018",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u04F9",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u04F5",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u04EB",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u04E9",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u04E7",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u04E5",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u04E3",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u04DD",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u04DC",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u04C4",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u04C2",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u04C1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u04B9",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u04B7",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u04B3",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u04AB",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u049D",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u049B",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0497",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0496",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0493",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0473",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0472",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u045E",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u045C",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0458",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0457",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0456",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0455",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0453",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u044F",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u044D",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u044A",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0447",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0445",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0444",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0442",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u043C",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0436",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0434",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0431",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u042F",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u042D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u042A",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0424",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u041C",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0416",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0414",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: "\u0409",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: ":",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0413",
    u2: ".",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    g2: "hyphenminus",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\uF6BC",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\uF6BB",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\uF6BA",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    g2: "afii10047.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    g2: "afii10017.var.accented",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u201D",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u2019",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u2014",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u2013",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u2012",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u2011",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u2010",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u04DE",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u04D2",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u04D0",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u0498",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u042D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u041B",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u0417",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u0410",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "-",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u201C",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u2018",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u04F5",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u04F4",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u04B9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u04B8",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u04B7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u04B6",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u0447",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u0434",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u0427",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u0414",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u0409",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0415",
    u2: "\u2122",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0415",
    u2: "\u04F5",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0415",
    u2: "\u04B9",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0415",
    u2: "\u04B7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0415",
    u2: "\u0447",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    g2: "afii10097.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    g2: "afii10095.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    g2: "afii10049.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    g2: "afii10047.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u2122",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u04F5",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u04F4",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u04E5",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u04E3",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u04DC",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u04C4",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u04C1",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u04B9",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u04B8",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u04B7",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u04B6",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u04AA",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u049D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u049B",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0496",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0473",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0472",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u044F",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u044D",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u044A",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0447",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0444",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0442",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0431",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u042F",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u042D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u042A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0427",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0424",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0421",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0416",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u040B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0402",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    g2: "afii10047.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    g2: "afii10037.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u04F2",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u04F0",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u04EE",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u04DE",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u04AE",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0498",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u042D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0423",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0417",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u040E",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u04C1",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u04B2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u042A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0425",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0424",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u040B",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0402",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0418",
    u2: "\u2122",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0419",
    u2: "\u2122",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    g2: "afii10071.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    g2: "afii10096.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    g2: "afii10093.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    g2: "afii10085.var.accented",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    g2: "afii10080.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    g2: "afii10074.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    g2: "afii10070.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    g2: "afii10065.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    g2: "afii10037.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    g2: "afii10032.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    g2: "afii10017.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04F9",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04F3",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04F2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04F1",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04F0",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04EF",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04EE",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04EB",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04EA",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04E9",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04E8",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04E7",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04E6",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04DE",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04D9",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04D8",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04D7",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04D3",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04D2",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04D1",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04D0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04C8",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04BB",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04AF",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04AE",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04AB",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04A3",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0498",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0493",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0491",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u045F",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u045E",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u045C",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u045B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u045A",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0458",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0457",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0456",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0454",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0453",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0452",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0451",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u044E",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u044C",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u044B",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0449",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0448",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0446",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0443",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0441",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0440",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u043F",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u043E",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u043D",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u043A",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0439",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0438",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0435",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0433",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0432",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0430",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0423",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0422",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u041E",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0417",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0410",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u040E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    g2: "afii10097.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    g2: "afii10095.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    g2: "afii10049.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    g2: "afii10047.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u2122",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04F5",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04F4",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04E5",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04E3",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04DD",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04DC",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04C4",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04C2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04C1",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04B9",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04B8",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04B7",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04B6",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04B3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04B2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u04AA",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u049D",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u049B",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0497",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0496",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0473",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0472",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u044F",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u044D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u044A",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0447",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0445",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0444",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0442",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u043C",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0436",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0431",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u042F",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u042D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u042A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0427",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0425",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0424",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0421",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0420",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0416",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0412",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u040B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0404",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041A",
    u2: "\u0402",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    g2: "hyphenminus",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\uF6BC",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\uF6BB",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\uF6BA",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    g2: "afii10047.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u201D",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u2019",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u2014",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u2013",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u2012",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u2011",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u2010",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u04DE",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u0498",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u042D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u0417",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "-",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u2122",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u04F5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u04F4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u04B9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u04B8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u04B7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u04B6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u0447",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041B",
    u2: "\u0427",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    g2: "afii10047.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    g2: "afii10037.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u04F2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u04F0",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u04EE",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u04DE",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u04AE",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u0498",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u042D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u0423",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u0422",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u0417",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u040E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u04F5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u04B9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u04B7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u0447",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u0442",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u042A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u040B",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041C",
    u2: "\u0402",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041D",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041E",
    u2: "\u2122",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041E",
    u2: "\u2018",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041E",
    u2: "\u04DC",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041E",
    u2: "\u04C1",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041E",
    u2: "\u0496",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041E",
    u2: "\u0416",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041E",
    u2: "\u040B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041E",
    u2: "\u0402",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u041F",
    u2: "\u2122",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\uF6BC",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\uF6BB",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\uF6BA",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    g2: "afii10071.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    g2: "afii10095.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    g2: "afii10070.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    g2: "afii10065.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    g2: "afii10047.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    g2: "afii10017.var.accented",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u2014",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u2013",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u2012",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u2011",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u2010",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04DF",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04DE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04D9",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04D7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04D3",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04D2",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04D1",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04D0",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04BB",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04AB",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0499",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0498",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u045B",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0458",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0452",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0451",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u044D",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0441",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0440",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u043B",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0437",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0435",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0430",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u042D",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u041B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0417",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0410",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "-",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: ",",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    g2: "hyphenminus",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    g2: "afii10097.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    g2: "afii10080.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u2122",
    k: -84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u2026",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04F5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04EB",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04E9",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04E7",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04C1",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04B9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u04B7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0473",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0459",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0454",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u044F",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0447",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0444",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u043E",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0434",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0431",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u041C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0414",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0409",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: ".",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u2122",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u201C",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u2018",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u04F5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u04F4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u04B9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u04B8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u04B7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u04B6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u04AA",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0447",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0427",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0421",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0404",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "hyphenminus",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\uF6BC",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\uF6BB",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\uF6BA",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "afii10071.var.accented",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "afii10096.var.accented",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "afii10093.var.accented",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "afii10085.var.accented",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "afii10074.var.accented",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "afii10070.var.accented",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "afii10065.var.accented",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "afii10047.var.accented",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "afii10037.var.accented",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "afii10032.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "afii10017.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u2014",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u2013",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u2012",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u2011",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u2010",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04F9",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04F3",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04F2",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04F1",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04F0",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04EF",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04EE",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04EA",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04E8",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04E6",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04DF",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04DE",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04D9",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04D8",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04D7",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04D3",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04D2",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04D1",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04D0",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04C8",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04BB",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04AF",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04AE",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04AA",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04A3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0499",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0498",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0493",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0491",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u045F",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u045C",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u045B",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u045A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0459",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0453",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0452",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0451",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u044E",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u044C",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u044B",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0449",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0448",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0446",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0443",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0440",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u043F",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u043D",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u043B",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u043A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0439",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0438",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0437",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0435",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0433",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0432",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0430",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u042D",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0423",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0422",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0421",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u041E",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u041B",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0417",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0410",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u040E",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u040B",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0409",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0404",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0402",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "-",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: ",",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "afii10097.var.accented",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "afii10095.var.accented",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    g2: "afii10080.var.accented",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u2122",
    k: -84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u2026",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u201D",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04F5",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04EB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04E9",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04E7",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04E5",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04E3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04DD",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04C4",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04C2",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04B9",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04B7",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04B3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04AB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u049D",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u049B",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0497",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0473",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0472",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u045E",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0458",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0457",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0456",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0455",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0454",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u044F",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u044D",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u044A",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0447",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0445",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0444",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0442",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0441",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u043E",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u043C",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0436",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0434",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0431",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u042A",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0424",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u041C",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0414",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: ".",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    g2: "afii10097.var.accented",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u2026",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u201C",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u2018",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04F5",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04E5",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04E3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04DD",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04DC",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04C4",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04C2",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04C1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04B9",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04B7",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04B3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u04AA",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u049D",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u049B",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0497",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0496",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0473",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0458",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0457",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0456",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0455",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0454",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u044F",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u044A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0447",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0445",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0442",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u043C",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0436",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0434",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0431",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0424",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0421",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u041C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0416",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0414",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "\u0404",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: ".",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    g2: "afii10095.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    g2: "afii10047.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    g2: "afii10017.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u04DF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u04DE",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u04D2",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u04D0",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0499",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0498",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u044D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0437",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u042D",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0422",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0417",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0410",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u040B",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0402",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u04F4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u04DC",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u04C1",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u04B8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u04B6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u04AE",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0496",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u042A",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0427",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0416",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    g2: "afii10085.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    g2: "afii10047.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04F3",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04F1",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04EF",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04DE",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04AF",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0498",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u045E",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0443",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u042D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0417",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    g2: "afii10097.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    g2: "afii10095.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    g2: "afii10080.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u2122",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04F5",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04F4",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04EB",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04E9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04E7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04B9",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04B8",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04B7",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04B6",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04AB",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0473",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u044F",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u044D",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u044A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0447",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0444",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0442",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0441",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u043E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0427",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    g2: "hyphenminus",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\uF6BC",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\uF6BB",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\uF6BA",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u2014",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u2013",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u2012",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u2011",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u2010",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "-",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u2122",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u0434",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u0414",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0427",
    u2: "\u2122",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0428",
    u2: "\u2122",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    g2: "hyphenminus",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\uF6BC",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\uF6BB",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\uF6BA",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u201D",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u2019",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u2014",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u2013",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u2012",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u2011",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u2010",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "-",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u2122",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u201C",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u2018",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u0434",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    g2: "afii10047.var.accented",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u201C",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u2018",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u04F4",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u04DC",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u04C1",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u04B8",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u04B6",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u04B2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u0496",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u0472",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u042D",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u042A",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u0427",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u0425",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u0424",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u041C",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u0416",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u0414",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u040B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u0409",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u0404",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042B",
    u2: "\u2122",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    g2: "afii10037.var.accented",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    g2: "afii10032.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u04F2",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u04F0",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u04EE",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u04EA",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u04E8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u04E6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u04DE",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u04D8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u04AE",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u04AA",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0498",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0423",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0422",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0421",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u041E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0417",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u040E",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0402",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    g2: "afii10047.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u201C",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u2018",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u04F4",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u04DC",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u04C1",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u04B8",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u04B6",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u04B2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0496",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0472",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u042D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u042A",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0427",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0425",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0424",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u041C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0416",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0414",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u040B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0409",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0404",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    g2: "afii10047.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u04DE",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u0498",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u042D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u041B",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u0417",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u2122",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u2018",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u040B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u0409",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u0402",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    g2: "afii10095.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u201D",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u2019",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u04DF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u0499",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u044D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u0437",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u2122",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u201C",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u2018",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u04F5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u04F4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u04DC",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u04C1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u04B9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u04B8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u04B7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u04B6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u0496",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u0447",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u0427",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u0416",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u040B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u0402",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042F",
    u2: "\u2122",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0430",
    u2: "\u201C",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0430",
    u2: "\u2018",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0430",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0430",
    u2: "\u04C1",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0430",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0430",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u04C1",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0442",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u04F5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u04DD",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u04DC",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u04C2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u04C1",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u04B9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u04B7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0497",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0496",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0447",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0442",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0436",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0416",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0414",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    g2: "afii10097.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    g2: "afii10080.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u2026",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u04F5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u04EB",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u04E9",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u04E7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u04DC",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u04C1",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u04B9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u04B7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u04B3",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u04B2",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u04AB",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u0496",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u0473",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u0459",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u0454",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u044F",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u044A",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u0447",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u0445",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u0444",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u0442",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u0441",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u043E",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u043C",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u0434",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u0425",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u0416",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u0414",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: ":",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    g2: "hyphenminus",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\uF6BC",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\uF6BB",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\uF6BA",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    g2: "afii10037.var.accented",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u2014",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u2013",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u2012",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u2011",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u2010",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u04F2",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u04F0",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u04EE",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u04AE",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u0459",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u043B",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u0423",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u0422",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u040E",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u040B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u0402",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "-",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u2122",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u04F5",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u04B9",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u04B7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u0447",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u0434",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u0414",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0435",
    u2: "\u04DC",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0435",
    u2: "\u04C1",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0435",
    u2: "\u0496",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0435",
    u2: "\u0416",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0436",
    u2: "\u04F5",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0436",
    u2: "\u04B9",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0436",
    u2: "\u04B7",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0436",
    u2: "\u0473",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0436",
    u2: "\u0447",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    g2: "afii10095.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    g2: "afii10085.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    g2: "afii10037.var.accented",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u04F3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u04F2",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u04F1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u04F0",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u04EF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u04EE",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u04DF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u04AF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u04AE",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u0499",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u045E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u044D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u0443",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u0437",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u0423",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u0422",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u040E",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u040B",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u0402",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u04F5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u04DD",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u04C2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u04B9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u04B7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u0497",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u0447",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u0442",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u0436",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u0414",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0438",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0438",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0438",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0438",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0439",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0439",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0439",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0439",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    g2: "afii10095.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    g2: "afii10037.var.accented",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u04F2",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u04F0",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u04EE",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u04DF",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u04BB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u04AE",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u0499",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u045B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u0459",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u0458",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u0452",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u044D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u0440",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u043B",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u0437",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u0423",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u040E",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    g2: "afii10080.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u04F5",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u04EB",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u04E9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u04E7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u04B9",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u04B7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u04AB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u0473",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u0454",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u0447",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u0441",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u043E",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043A",
    u2: "\u041C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    g2: "hyphenminus",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\uF6BC",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\uF6BB",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\uF6BA",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    g2: "afii10037.var.accented",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u2014",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u2013",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u2012",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u2011",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u2010",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u04F2",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u04F0",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u04EE",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u04AE",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u0423",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u0422",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u040E",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u040B",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u0402",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "-",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u04F5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u04DC",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u04C1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u04B9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u04B7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u0496",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u0447",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043B",
    u2: "\u0416",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    g2: "afii10085.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    g2: "afii10037.var.accented",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u04F3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u04F2",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u04F1",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u04F0",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u04EF",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u04EE",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u04AF",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u04AE",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u045E",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u0443",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u0423",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u0422",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u040E",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u040B",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u0402",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u04F5",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u04DC",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u04C1",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u04B9",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u04B7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u0496",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u0447",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043C",
    u2: "\u0416",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043D",
    g2: "afii10037.var.accented",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043D",
    u2: "\u04F2",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043D",
    u2: "\u04F0",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043D",
    u2: "\u04EE",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043D",
    u2: "\u04AE",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043D",
    u2: "\u0423",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043D",
    u2: "\u0422",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043D",
    u2: "\u040E",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043D",
    u2: "\u040B",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043D",
    u2: "\u0402",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043D",
    u2: "\u04DC",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043D",
    u2: "\u04C1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043D",
    u2: "\u0496",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043D",
    u2: "\u0416",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    g2: "afii10037.var.accented",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u04F2",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u04F0",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u04EE",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u04AE",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u0423",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u0422",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u040E",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u040B",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u0402",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u04F5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u04B9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u04B7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u0447",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u0442",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043E",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    g2: "hyphenminus",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\uF6BC",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\uF6BB",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\uF6BA",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    g2: "afii10037.var.accented",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\u2014",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\u2013",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\u2012",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\u2011",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\u2010",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\u04F2",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\u04F0",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\u04EE",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\u04AE",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\u0423",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\u0422",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\u040E",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\u040B",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\u0402",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "-",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u043F",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    g2: "afii10095.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    g2: "afii10085.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    g2: "afii10037.var.accented",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u04F3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u04F2",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u04F1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u04F0",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u04EF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u04EE",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u04DF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u04AF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u04AE",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u0499",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u045E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u044D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u0443",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u0437",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u0423",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u0422",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u041B",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u040E",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u040B",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u0409",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u0402",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u04F5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u04DC",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u04C1",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u04B9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u04B7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u0496",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u0447",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u0442",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0440",
    u2: "\u0416",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0441",
    g2: "afii10080.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0441",
    u2: "\u04EB",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0441",
    u2: "\u04E9",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0441",
    u2: "\u04E7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0441",
    u2: "\u04DC",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0441",
    u2: "\u04C1",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0441",
    u2: "\u04AB",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0441",
    u2: "\u0496",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0441",
    u2: "\u0473",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0441",
    u2: "\u0454",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0441",
    u2: "\u0444",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0441",
    u2: "\u0441",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0441",
    u2: "\u043E",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0441",
    u2: "\u0416",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    g2: "hyphenminus",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\uF6BC",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\uF6BB",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\uF6BA",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    g2: "afii10071.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    g2: "afii10095.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    g2: "afii10085.var.accented",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    g2: "afii10080.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    g2: "afii10070.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    g2: "afii10065.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    g2: "afii10037.var.accented",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    g2: "afii10017.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u2014",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u2013",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u2012",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u2011",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u2010",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04F3",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04F2",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04F1",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04F0",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04EF",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04EE",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04EB",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04E9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04E7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04DF",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04D9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04D7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04D3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04D2",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04D1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04D0",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04AF",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04AE",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04AB",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0499",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u045E",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0454",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0451",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0444",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0443",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0441",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u043E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u043B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0437",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0435",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0430",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0423",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0422",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u041B",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0410",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u040E",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u040B",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0409",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0402",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: ";",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: ":",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "-",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: ".",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: ",",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u2026",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04F5",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04B9",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u04B7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0473",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0459",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u044D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u044A",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0447",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0442",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0434",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u041C",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0414",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u2026",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u04C1",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u044A",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u0442",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0443",
    u2: ".",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    g2: "afii10037.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u04F2",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u04F0",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u04EE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u04AE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u0423",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u0422",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u040E",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u040B",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u0402",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u04C1",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u0442",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0444",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    g2: "afii10095.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    g2: "afii10065.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    g2: "afii10037.var.accented",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04F2",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04F0",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04EE",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04DF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04D3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04D1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04AE",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0499",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u044D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u043B",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0437",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0430",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0423",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0422",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u040E",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u040B",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0402",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    g2: "afii10096.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    g2: "afii10093.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04F9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04F5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04C8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04B9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04B7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u04A3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u045F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u045A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0459",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u044E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u044C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u044B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0449",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0448",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0447",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0446",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0442",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u043F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u043D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u041C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    g2: "hyphenminus",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\uF6BC",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\uF6BB",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\uF6BA",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    g2: "afii10037.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u2014",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u2013",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u2012",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u2011",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u2010",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u04F2",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u04F0",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u04EE",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u04AE",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u0459",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u043B",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u0423",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u0422",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u041B",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u040E",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u040B",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u0409",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u0402",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "-",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u2122",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u04F5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u04B9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u04B7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u0447",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u0434",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u0414",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0447",
    g2: "afii10037.var.accented",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0447",
    u2: "\u04F2",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0447",
    u2: "\u04F0",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0447",
    u2: "\u04EE",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0447",
    u2: "\u04AE",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0447",
    u2: "\u0423",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0447",
    u2: "\u0422",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0447",
    u2: "\u040E",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0447",
    u2: "\u040B",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0447",
    u2: "\u0402",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0447",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0447",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0447",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0447",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0448",
    g2: "afii10037.var.accented",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0448",
    u2: "\u04F2",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0448",
    u2: "\u04F0",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0448",
    u2: "\u04EE",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0448",
    u2: "\u04AE",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0448",
    u2: "\u0423",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0448",
    u2: "\u040E",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0448",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0448",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0448",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0448",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    g2: "hyphenminus",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\uF6BC",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\uF6BB",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\uF6BA",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    g2: "afii10037.var.accented",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u2014",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u2013",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u2012",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u2011",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u2010",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u04F2",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u04F0",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u04EE",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u04AE",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u0459",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u043B",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u0423",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u0422",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u041B",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u040E",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u040B",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u0409",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u0402",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "-",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u04F5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u04B9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u04B7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u0447",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u0434",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u0414",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u201C",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u04F5",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u04DD",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u04C2",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u04C1",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u04B9",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u04B7",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u04B3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u0497",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u045B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u044A",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u0447",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u0445",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u0442",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u0436",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u0431",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u041C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044B",
    g2: "afii10037.var.accented",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044B",
    u2: "\u04F2",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044B",
    u2: "\u04F0",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044B",
    u2: "\u04EE",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044B",
    u2: "\u04AE",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044B",
    u2: "\u0423",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044B",
    u2: "\u040E",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044B",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044B",
    u2: "\u04C1",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044B",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044B",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    g2: "afii10085.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    g2: "afii10037.var.accented",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    g2: "afii10017.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u04F3",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u04F2",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u04F1",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u04F0",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u04EF",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u04EE",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u04D2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u04D0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u04BB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u04AF",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u04AE",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u045E",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0459",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0452",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0443",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u043B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0423",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0422",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u041B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0410",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u040E",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u040B",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0409",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0402",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    g2: "afii10097.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u2122",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u201C",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u2018",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u04F5",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u04DD",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u04C2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u04B9",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u04B7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u04B3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0497",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u045B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u044F",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u044A",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0447",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0445",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0444",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0442",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0436",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0431",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u041C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    g2: "afii10037.var.accented",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u04F2",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u04F0",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u04EE",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u04AE",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u0423",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u0422",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u040E",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u040B",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u0402",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u04DC",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u04C1",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u0496",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u0442",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u0416",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    g2: "afii10037.var.accented",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    g2: "afii10017.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u04F2",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u04F0",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u04EE",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u04D2",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u04D0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u04AE",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u0423",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u0422",
    k: 105
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u041B",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u0410",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u040E",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u040B",
    k: 105
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u0409",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u0402",
    k: 105
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u0442",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044F",
    g2: "afii10037.var.accented",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044F",
    u2: "\u04F2",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044F",
    u2: "\u04F0",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044F",
    u2: "\u04EE",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044F",
    u2: "\u04AE",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044F",
    u2: "\u0423",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044F",
    u2: "\u0422",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044F",
    u2: "\u040E",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044F",
    u2: "\u040B",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044F",
    u2: "\u0402",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044F",
    u2: "\u04DD",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044F",
    u2: "\u04DC",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044F",
    u2: "\u04C2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044F",
    u2: "\u04C1",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044F",
    u2: "\u0497",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044F",
    u2: "\u0496",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044F",
    u2: "\u0436",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044F",
    u2: "\u0416",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0451",
    u2: "\u04DC",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0451",
    u2: "\u04C1",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0451",
    u2: "\u0496",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0451",
    u2: "\u0416",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    g2: "afii10037.var.accented",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u04F2",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u04F0",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u04EE",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u04AE",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u0458",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u0440",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u0423",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u040E",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    g2: "afii10097.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    g2: "afii10096.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    g2: "afii10093.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    g2: "afii10080.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u2026",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u04F9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u04F5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u04EB",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u04E9",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u04E7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u04DC",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u04C1",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u04B9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u04B7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u04B3",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u04B2",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u04AB",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u0496",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u0473",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u045F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u0459",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u0454",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u044F",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u044E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u044C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u044B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u044A",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u0449",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u0448",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u0447",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u0446",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u0445",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u0444",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u0442",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u0441",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u043F",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u043E",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u043C",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u0434",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u0425",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u0416",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u0414",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: ":",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    g2: "afii10037.var.accented",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u04F2",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u04F0",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u04EE",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u04AE",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u0423",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u0422",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u040E",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u040B",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u0402",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    g2: "afii10080.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u04EB",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u04E9",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u04E7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u04DC",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u04C1",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u04AB",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u0496",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u0473",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u0454",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u0444",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u0441",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u043E",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u0416",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0455",
    u2: "\u04AF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0457",
    u2: "\u0457",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    g2: "afii10071.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    g2: "afii10096.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    g2: "afii10093.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    g2: "afii10085.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    g2: "afii10080.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    g2: "afii10074.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    g2: "afii10070.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    g2: "afii10017.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04F9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04F3",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04F1",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04EF",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04EB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04E9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04E7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04D9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04D7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04D2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04D0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04C8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04BB",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04AF",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04AB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04A3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0493",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0491",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u045F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u045E",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u045C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u045A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0457",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0456",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0454",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0453",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0452",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0451",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u044E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u044C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u044B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0449",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0448",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0446",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0444",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0443",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0441",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u043F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u043E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u043D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u043A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0439",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0438",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0435",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0433",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0432",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0410",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u201C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u2018",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04F5",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04DD",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04DC",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04C2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04C1",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04B9",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04B7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u04B3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0497",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0496",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0473",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u045B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u044A",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0447",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0445",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0442",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0436",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0431",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0424",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u041C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0416",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0414",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    g2: "afii10071.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    g2: "afii10096.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    g2: "afii10093.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    g2: "afii10085.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    g2: "afii10074.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    g2: "afii10070.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    g2: "afii10065.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    g2: "afii10017.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04F9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04F3",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04F1",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04EF",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04D9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04D7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04D3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04D2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04D1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04D0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04C8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04BB",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04AF",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04AB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04A3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0493",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0491",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u045F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u045E",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u045C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u045A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0457",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0456",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0454",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0453",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0452",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0451",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u044E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u044C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u044B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0449",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0448",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0446",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0444",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0443",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0441",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u043F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u043D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u043A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0439",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0438",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0435",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0433",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0432",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0430",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u041B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0410",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0409",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    g2: "afii10080.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u2122",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u201C",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u2018",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04F5",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04EB",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04E9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04E7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04DD",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04C2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04C1",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04B9",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04B7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u04B3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0497",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0473",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u045B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u044A",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0447",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0445",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0442",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u043E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0436",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0431",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0424",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u041C",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0414",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    g2: "afii10095.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    g2: "afii10037.var.accented",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u04F2",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u04F0",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u04EE",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u04DF",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u04BB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u04AE",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u0499",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u045B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u0459",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u0458",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u0452",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u044D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u0440",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u043B",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u0437",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u0423",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u040E",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    g2: "afii10080.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u04F5",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u04EB",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u04E9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u04E7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u04B9",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u04B7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u04AB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u0473",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u0454",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u0447",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u0444",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u0441",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u043E",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u0431",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "\u041C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    g2: "hyphenminus",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u2026",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u04C1",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u044A",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u0442",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045E",
    u2: ".",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045F",
    g2: "afii10037.var.accented",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045F",
    u2: "\u04F2",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045F",
    u2: "\u04F0",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045F",
    u2: "\u04EE",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045F",
    u2: "\u04AE",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045F",
    u2: "\u0423",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045F",
    u2: "\u040E",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045F",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045F",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045F",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045F",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    g2: "afii10095.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    g2: "afii10047.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    g2: "afii10037.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u04F2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u04F0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u04EE",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u04DF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u04DE",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u04AE",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u0499",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u0498",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u044D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u0437",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u042D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u0423",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u0422",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u0417",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u040E",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u2122",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u2018",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u04DC",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u04C1",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u0496",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u0416",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u040B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0472",
    u2: "\u0402",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    g2: "afii10095.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    g2: "afii10037.var.accented",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u04F2",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u04F0",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u04EE",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u04DF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u04AE",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u0499",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u044D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u0437",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u0423",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u0422",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u040E",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u040B",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u0402",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u04F5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u04B9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u04B7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u0447",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u0442",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0473",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    g2: "afii10071.var.accented",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    g2: "afii10085.var.accented",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    g2: "afii10074.var.accented",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    g2: "afii10070.var.accented",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    g2: "afii10032.var.accented",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    g2: "afii10017.var.accented",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04F3",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04F1",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04EF",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04EA",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04E8",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04E6",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04DF",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04DE",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04D9",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04D8",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04D7",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04D2",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04D0",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04C8",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04AF",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04A3",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0499",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0498",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0491",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u045F",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u045A",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0454",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0451",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0443",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0441",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0440",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u043D",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u043A",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0439",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0438",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0437",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0435",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0433",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0432",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0422",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u041E",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u041B",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0417",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0410",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u040B",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0404",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0402",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: ",",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    g2: "afii10097.var.accented",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    g2: "afii10096.var.accented",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    g2: "afii10095.var.accented",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    g2: "afii10093.var.accented",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    g2: "afii10080.var.accented",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    g2: "afii10049.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    g2: "afii10047.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u2122",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u2026",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u2018",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04F9",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04F5",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04EB",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04E9",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04E7",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04E5",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04E3",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04DD",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04DC",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04C4",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04C2",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04C1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04B9",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04B7",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04B3",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04AB",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u04AA",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u049D",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u049B",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0497",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0496",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0493",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0473",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0472",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u045E",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u045C",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0458",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0457",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0456",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0455",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0453",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u044F",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u044E",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u044D",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u044C",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u044B",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u044A",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0449",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0448",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0447",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0446",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0445",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0444",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0442",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u043F",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u043E",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u043C",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0436",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0434",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0431",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u042F",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u042D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u042A",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0424",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0421",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u041C",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0416",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0414",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: "\u0409",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: ":",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0490",
    u2: ".",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    g2: "afii10096.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    g2: "afii10093.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    g2: "afii10074.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u04F9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u04C8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u04A3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0493",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0491",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u045F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u045C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u045A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0458",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0457",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0456",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0453",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u044E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u044C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u044B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0449",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0448",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0446",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0440",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u043F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u043D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u043A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0439",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0438",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0433",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0432",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    g2: "hyphenminus",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    g2: "afii10097.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    g2: "afii10080.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u2026",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u04F5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u04EB",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u04E9",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u04E7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u04E5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u04E3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u04DC",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u04C4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u04C1",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u04B9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u04B7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u04B3",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u04B2",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u04AB",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u049D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u049B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0496",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0473",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0459",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0454",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u044F",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u044A",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0447",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0445",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0444",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0442",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0441",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u043E",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u043C",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0434",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0425",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0416",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u0414",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: ":",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    g2: "afii10097.var.accented",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    g2: "afii10096.var.accented",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    g2: "afii10095.var.accented",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    g2: "afii10093.var.accented",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    g2: "afii10080.var.accented",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    g2: "afii10049.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    g2: "afii10047.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u2122",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u2026",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u2018",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u04F9",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u04F5",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u04EB",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u04E9",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u04E7",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u04E5",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u04E3",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u04DD",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u04DC",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u04C4",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u04C2",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u04C1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u04B9",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u04B7",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u04B3",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u04AB",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u049D",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u049B",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0497",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0496",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0493",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0473",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0472",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u045E",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u045C",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0458",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0457",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0456",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0455",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0453",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u044F",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u044D",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u044A",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0447",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0445",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0444",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0442",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u043C",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0436",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0434",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0431",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u042F",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u042D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u042A",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0424",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u041C",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0416",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0414",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: "\u0409",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: ":",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0492",
    u2: ".",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    g2: "afii10097.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    g2: "afii10080.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u2026",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u04F5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u04EB",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u04E9",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u04E7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u04DC",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u04C1",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u04B9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u04B7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u04B3",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u04B2",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u04AB",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u0496",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u0473",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u0459",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u0454",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u044F",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u044A",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u0447",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u0445",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u0444",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u0442",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u0441",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u043E",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u043C",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u0434",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u0425",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u0416",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: "\u0414",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0493",
    u2: ":",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    g2: "afii10097.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    g2: "afii10095.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    g2: "afii10049.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    g2: "afii10047.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u2122",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u04F5",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u04F4",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u04E5",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u04E3",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u04DC",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u04C4",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u04C1",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u04B9",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u04B8",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u04B7",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u04B6",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u04AA",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u049D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u049B",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0496",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0473",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0472",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u044F",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u044D",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u044A",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0447",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0444",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0442",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0431",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u042F",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u042D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u042A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0427",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0424",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0421",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0416",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u040B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0402",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0497",
    u2: "\u04F5",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0497",
    u2: "\u04B9",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0497",
    u2: "\u04B7",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0497",
    u2: "\u0473",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0497",
    u2: "\u0447",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    g2: "afii10047.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    g2: "afii10037.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u04F2",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u04F0",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u04EE",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u04DE",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u04AE",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u0498",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u042D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u0423",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u0417",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u040E",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u04C1",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u04B2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u042A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u0425",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u0424",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u040B",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0498",
    u2: "\u0402",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    g2: "afii10095.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    g2: "afii10085.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    g2: "afii10037.var.accented",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u04F3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u04F2",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u04F1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u04F0",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u04EF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u04EE",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u04DF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u04AF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u04AE",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u0499",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u045E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u044D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u0443",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u0437",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u0423",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u0422",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u040E",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u040B",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u0402",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u04F5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u04DD",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u04C2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u04B9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u04B7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u0497",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u0447",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u0442",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u0436",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0499",
    u2: "\u0414",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    g2: "afii10071.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    g2: "afii10096.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    g2: "afii10093.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    g2: "afii10085.var.accented",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    g2: "afii10080.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    g2: "afii10074.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    g2: "afii10070.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    g2: "afii10065.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    g2: "afii10037.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    g2: "afii10032.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    g2: "afii10017.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04F9",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04F3",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04F2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04F1",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04F0",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04EF",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04EE",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04EB",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04EA",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04E9",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04E8",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04E7",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04E6",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04DE",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04D9",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04D8",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04D7",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04D3",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04D2",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04D1",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04D0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04C8",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04BB",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04AF",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04AE",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04AB",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04A3",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0498",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0493",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0491",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u045F",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u045E",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u045C",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u045B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u045A",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0458",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0457",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0456",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0454",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0453",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0452",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0451",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u044E",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u044C",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u044B",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0449",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0448",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0446",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0443",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0441",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0440",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u043F",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u043E",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u043D",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u043A",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0439",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0438",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0435",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0433",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0432",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0430",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0423",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0422",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u041E",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0417",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0410",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u040E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    g2: "afii10097.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    g2: "afii10095.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    g2: "afii10049.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    g2: "afii10047.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u2122",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04F5",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04F4",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04E5",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04E3",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04DD",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04DC",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04C4",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04C2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04C1",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04B9",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04B8",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04B7",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04B6",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04B3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04B2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u04AA",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u049D",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u049B",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0497",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0496",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0473",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0472",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u044F",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u044D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u044A",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0447",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0445",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0444",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0442",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u043C",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0436",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0431",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u042F",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u042D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u042A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0427",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0425",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0424",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0421",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0420",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0416",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0412",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u040B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0404",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0402",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    g2: "afii10095.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    g2: "afii10037.var.accented",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u04F2",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u04F0",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u04EE",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u04DF",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u04BB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u04AE",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u0499",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u045B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u0459",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u0458",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u0452",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u044D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u0440",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u043B",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u0437",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u0423",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u040E",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    g2: "afii10080.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u04F5",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u04EB",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u04E9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u04E7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u04B9",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u04B7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u04AB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u0473",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u0454",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u0447",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u0441",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u043E",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u041C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    g2: "afii10071.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    g2: "afii10096.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    g2: "afii10093.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    g2: "afii10085.var.accented",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    g2: "afii10080.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    g2: "afii10074.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    g2: "afii10070.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    g2: "afii10065.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    g2: "afii10037.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    g2: "afii10032.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    g2: "afii10017.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04F9",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04F3",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04F2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04F1",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04F0",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04EF",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04EE",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04EB",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04EA",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04E9",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04E8",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04E7",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04E6",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04DE",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04D9",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04D8",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04D7",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04D3",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04D2",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04D1",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04D0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04C8",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04BB",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04AF",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04AE",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04AB",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04A3",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0498",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0493",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0491",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u045F",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u045E",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u045C",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u045B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u045A",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0458",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0457",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0456",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0454",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0453",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0452",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0451",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u044E",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u044C",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u044B",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0449",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0448",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0446",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0443",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0441",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0440",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u043F",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u043E",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u043D",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u043A",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0439",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0438",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0435",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0433",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0432",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0430",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0423",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0422",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u041E",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0417",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0410",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u040E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    g2: "afii10097.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    g2: "afii10095.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    g2: "afii10049.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    g2: "afii10047.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u2122",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04F5",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04F4",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04E5",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04E3",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04DD",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04DC",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04C4",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04C2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04C1",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04B9",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04B8",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04B7",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04B6",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04B3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04B2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u04AA",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u049D",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u049B",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0497",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0496",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0473",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0472",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u044F",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u044D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u044A",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0447",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0445",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0444",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0442",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u043C",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0436",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0431",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u042F",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u042D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u042A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0427",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0425",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0424",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0421",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0420",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0416",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0412",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u040B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0404",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049C",
    u2: "\u0402",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    g2: "afii10095.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    g2: "afii10037.var.accented",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u04F2",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u04F0",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u04EE",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u04DF",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u04BB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u04AE",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u0499",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u045B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u0459",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u0458",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u0452",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u044D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u0440",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u043B",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u0437",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u0423",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u040E",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    g2: "afii10080.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u04F5",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u04EB",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u04E9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u04E7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u04B9",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u04B7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u04AB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u0473",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u0454",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u0447",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u0441",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u043E",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049D",
    u2: "\u041C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A2",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A3",
    g2: "afii10037.var.accented",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A3",
    u2: "\u04F2",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A3",
    u2: "\u04F0",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A3",
    u2: "\u04EE",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A3",
    u2: "\u04AE",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A3",
    u2: "\u0423",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A3",
    u2: "\u0422",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A3",
    u2: "\u040E",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A3",
    u2: "\u040B",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A3",
    u2: "\u0402",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A3",
    u2: "\u04DC",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A3",
    u2: "\u04C1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A3",
    u2: "\u0496",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A3",
    u2: "\u0416",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u2122",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u201C",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u2018",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u04F5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u04F4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u04B9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u04B8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u04B7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u04B6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u04AA",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u0447",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u0427",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u0421",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u0404",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AB",
    g2: "afii10080.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AB",
    u2: "\u04EB",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AB",
    u2: "\u04E9",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AB",
    u2: "\u04E7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AB",
    u2: "\u04DC",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AB",
    u2: "\u04C1",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AB",
    u2: "\u04AB",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AB",
    u2: "\u0496",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AB",
    u2: "\u0473",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AB",
    u2: "\u0454",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AB",
    u2: "\u0444",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AB",
    u2: "\u0441",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AB",
    u2: "\u043E",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AB",
    u2: "\u0416",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    g2: "afii10032.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04EA",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04E8",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04E6",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04D8",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u041E",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    g2: "afii10097.var.accented",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u2026",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u201C",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u2018",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04F5",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04E5",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04E3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04DD",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04DC",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04C4",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04C2",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04C1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04B9",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04B7",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04B3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u04AA",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u049D",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u049B",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0497",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0496",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0473",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0458",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0457",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0456",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0455",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0454",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u044F",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u044A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0447",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0445",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0442",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u043C",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0436",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0434",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0431",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u042F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0424",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0421",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u041C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0416",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0414",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: "\u0404",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AE",
    u2: ".",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u2026",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u04C1",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u0455",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u044A",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u0442",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AF",
    u2: ".",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    g2: "afii10085.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    g2: "afii10047.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04F3",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04F1",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04EF",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04DE",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04AF",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0498",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u045E",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0443",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u042D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0417",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    g2: "afii10097.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    g2: "afii10095.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    g2: "afii10080.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u2122",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04F5",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04F4",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04EB",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04E9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04E7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04B9",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04B8",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04B7",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04B6",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u04AB",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0473",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u044F",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u044D",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u044A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0447",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0444",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0442",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0441",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u043E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0427",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    g2: "afii10095.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    g2: "afii10065.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    g2: "afii10037.var.accented",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04F2",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04F0",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04EE",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04DF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04D3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04D1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04AE",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0499",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u044D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u043B",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0437",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0430",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0423",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0422",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u040E",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u040B",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0402",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    g2: "afii10096.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    g2: "afii10093.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04F9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04F5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04C8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04B9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04B7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u04A3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u045F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u045A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0459",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u044E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u044C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u044B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0449",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0448",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0447",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0446",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0442",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u043F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u043D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u041C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B6",
    u2: "\u2122",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B7",
    g2: "afii10037.var.accented",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B7",
    u2: "\u04F2",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B7",
    u2: "\u04F0",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B7",
    u2: "\u04EE",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B7",
    u2: "\u04AE",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B7",
    u2: "\u0423",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B7",
    u2: "\u0422",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B7",
    u2: "\u040E",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B7",
    u2: "\u040B",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B7",
    u2: "\u0402",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B7",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B7",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B7",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B7",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B8",
    u2: "\u2122",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B9",
    g2: "afii10037.var.accented",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B9",
    u2: "\u04F2",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B9",
    u2: "\u04F0",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B9",
    u2: "\u04EE",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B9",
    u2: "\u04AE",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B9",
    u2: "\u0423",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B9",
    u2: "\u0422",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B9",
    u2: "\u040E",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B9",
    u2: "\u040B",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B9",
    u2: "\u0402",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B9",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B9",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B9",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B9",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04BA",
    u2: "\u201C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04BA",
    u2: "\u2018",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04BA",
    u2: "\u04F4",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04BA",
    u2: "\u04B8",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04BA",
    u2: "\u04B6",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04BA",
    u2: "\u04AA",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04BA",
    u2: "\u0472",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04BA",
    u2: "\u042A",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04BA",
    u2: "\u0427",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04BA",
    u2: "\u0424",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04BA",
    u2: "\u0421",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04BA",
    u2: "\u040B",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04BB",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04BB",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04BB",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04BB",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    g2: "afii10097.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    g2: "afii10095.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    g2: "afii10049.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    g2: "afii10047.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u2122",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u04F5",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u04F4",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u04E5",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u04E3",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u04DC",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u04C4",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u04C1",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u04B9",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u04B8",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u04B7",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u04B6",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u04AA",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u049D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u049B",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u0496",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u0473",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u0472",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u044F",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u044D",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u044A",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u0447",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u0444",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u0442",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u0431",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u042F",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u042D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u042A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u0427",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u0424",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u0421",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u0416",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u040B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C1",
    u2: "\u0402",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C2",
    u2: "\u04F5",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C2",
    u2: "\u04B9",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C2",
    u2: "\u04B7",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C2",
    u2: "\u0473",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C2",
    u2: "\u0447",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    g2: "afii10071.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    g2: "afii10096.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    g2: "afii10093.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    g2: "afii10085.var.accented",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    g2: "afii10080.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    g2: "afii10074.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    g2: "afii10070.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    g2: "afii10065.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    g2: "afii10037.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    g2: "afii10032.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    g2: "afii10017.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04F9",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04F3",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04F2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04F1",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04F0",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04EF",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04EE",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04EB",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04EA",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04E9",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04E8",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04E7",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04E6",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04DE",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04D9",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04D8",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04D7",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04D3",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04D2",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04D1",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04D0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04C8",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04BB",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04AF",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04AE",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04AB",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04A3",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0498",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0493",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0491",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u045F",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u045E",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u045C",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u045B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u045A",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0458",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0457",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0456",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0454",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0453",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0452",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0451",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u044E",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u044C",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u044B",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0449",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0448",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0446",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0443",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0441",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0440",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u043F",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u043E",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u043D",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u043A",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0439",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0438",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0435",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0433",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0432",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0430",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0423",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0422",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u041E",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0417",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0410",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u040E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    g2: "afii10097.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    g2: "afii10095.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    g2: "afii10049.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    g2: "afii10047.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u2122",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04F5",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04F4",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04E5",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04E3",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04DD",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04DC",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04C4",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04C2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04C1",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04B9",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04B8",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04B7",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04B6",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04B3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04B2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u04AA",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u049D",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u049B",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0497",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0496",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0473",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0472",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u044F",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u044D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u044A",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0447",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0445",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0444",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0442",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u043C",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0436",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0431",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u042F",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u042D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u042A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0427",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0425",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0424",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0421",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0420",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0416",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0412",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u040B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0404",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C3",
    u2: "\u0402",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    g2: "afii10095.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    g2: "afii10037.var.accented",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u04F2",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u04F0",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u04EE",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u04DF",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u04BB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u04AE",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u0499",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u045B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u0459",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u0458",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u0452",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u044D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u0440",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u043B",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u0437",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u0423",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u040E",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    g2: "afii10080.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u04F5",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u04EB",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u04E9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u04E7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u04B9",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u04B7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u04AB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u0473",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u0454",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u0447",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u0441",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u043E",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C4",
    u2: "\u041C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C7",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C8",
    g2: "afii10037.var.accented",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C8",
    u2: "\u04F2",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C8",
    u2: "\u04F0",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C8",
    u2: "\u04EE",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C8",
    u2: "\u04AE",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C8",
    u2: "\u0423",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C8",
    u2: "\u0422",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C8",
    u2: "\u040E",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C8",
    u2: "\u040B",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C8",
    u2: "\u0402",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C8",
    u2: "\u04DC",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C8",
    u2: "\u04C1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C8",
    u2: "\u0496",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04C8",
    u2: "\u0416",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    g2: "hyphenminus",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    g2: "afii10047.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u2122",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u2039",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u201C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u2018",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u04F5",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u04F4",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u04B9",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u04B8",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u04B7",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u04B6",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u04AF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u04AA",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u0459",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u044A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u0447",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u0442",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u042D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u042A",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u0427",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u0424",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u0414",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u040B",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "\u0402",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: ".",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D0",
    u2: "*",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D1",
    u2: "\u201C",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D1",
    u2: "\u2018",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D1",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D1",
    u2: "\u04C1",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D1",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D1",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    g2: "hyphenminus",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    g2: "afii10047.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u2122",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u2039",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u201C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u2018",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u04F5",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u04F4",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u04B9",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u04B8",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u04B7",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u04B6",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u04AF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u04AA",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u0459",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u044A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u0447",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u0442",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u042D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u042A",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u0427",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u0424",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u0414",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u040B",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "\u0402",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: ".",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D2",
    u2: "*",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D3",
    u2: "\u201C",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D3",
    u2: "\u2018",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D3",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D3",
    u2: "\u04C1",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D3",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D3",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D6",
    u2: "\u2122",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D6",
    u2: "\u04F5",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D6",
    u2: "\u04B9",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D6",
    u2: "\u04B7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D6",
    u2: "\u0447",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D7",
    u2: "\u04DC",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D7",
    u2: "\u04C1",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D7",
    u2: "\u0496",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D7",
    u2: "\u0416",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D8",
    u2: "\u2122",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D8",
    u2: "\u2018",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D8",
    u2: "\u04DC",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D8",
    u2: "\u04C1",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D8",
    u2: "\u0496",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D8",
    u2: "\u0416",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D8",
    u2: "\u040B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D8",
    u2: "\u0402",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D9",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D9",
    u2: "\u04C1",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D9",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D9",
    u2: "\u0442",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04D9",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    g2: "afii10097.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    g2: "afii10095.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    g2: "afii10049.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    g2: "afii10047.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u2122",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u04F5",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u04F4",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u04E5",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u04E3",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u04DC",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u04C4",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u04C1",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u04B9",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u04B8",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u04B7",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u04B6",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u04AA",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u049D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u049B",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u0496",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u0473",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u0472",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u044F",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u044D",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u044A",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u0447",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u0444",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u0442",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u0431",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u042F",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u042D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u042A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u0427",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u0424",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u0421",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u0416",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u040B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DC",
    u2: "\u0402",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DD",
    u2: "\u04F5",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DD",
    u2: "\u04B9",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DD",
    u2: "\u04B7",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DD",
    u2: "\u0473",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DD",
    u2: "\u0447",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    g2: "afii10047.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    g2: "afii10037.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u04F2",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u04F0",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u04EE",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u04DE",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u04AE",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u0498",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u042D",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u0423",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u0417",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u040E",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u04C1",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u04B2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u042A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u0425",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u0424",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u040B",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DE",
    u2: "\u0402",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    g2: "afii10095.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    g2: "afii10085.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    g2: "afii10037.var.accented",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u04F3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u04F2",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u04F1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u04F0",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u04EF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u04EE",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u04DF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u04AF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u04AE",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u0499",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u045E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u044D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u0443",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u0437",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u0423",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u0422",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u040E",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u040B",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u0402",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u04F5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u04DD",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u04C2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u04B9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u04B7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u0497",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u0447",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u0442",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u0436",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04DF",
    u2: "\u0414",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E2",
    u2: "\u2122",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E3",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E3",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E3",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E3",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E4",
    u2: "\u2122",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E5",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E5",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E5",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E5",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E6",
    u2: "\u2122",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E6",
    u2: "\u2018",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E6",
    u2: "\u04DC",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E6",
    u2: "\u04C1",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E6",
    u2: "\u0496",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E6",
    u2: "\u0416",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E6",
    u2: "\u040B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E6",
    u2: "\u0402",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    g2: "afii10037.var.accented",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u04F2",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u04F0",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u04EE",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u04AE",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u0423",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u0422",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u040E",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u040B",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u0402",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u04F5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u04B9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u04B7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u0447",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u0442",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E7",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E8",
    u2: "\u2122",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E8",
    u2: "\u2018",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E8",
    u2: "\u04DC",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E8",
    u2: "\u04C1",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E8",
    u2: "\u0496",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E8",
    u2: "\u0416",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E8",
    u2: "\u040B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E8",
    u2: "\u0402",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    g2: "afii10037.var.accented",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u04F2",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u04F0",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u04EE",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u04AE",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u0423",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u0422",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u040E",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u040B",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u0402",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u04F5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u04B9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u04B7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u0447",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u0442",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EA",
    u2: "\u2122",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EA",
    u2: "\u2018",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EA",
    u2: "\u04DC",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EA",
    u2: "\u04C1",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EA",
    u2: "\u0496",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EA",
    u2: "\u0416",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EA",
    u2: "\u040B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EA",
    u2: "\u0402",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    g2: "afii10037.var.accented",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u04F2",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u04F0",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u04EE",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u04AE",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u0423",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u0422",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u040E",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u040B",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u0402",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u04F5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u04B9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u04B7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u0447",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u0442",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EB",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    g2: "afii10097.var.accented",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u2026",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u201C",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u2018",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04F5",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04E5",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04E3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04DD",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04DC",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04C4",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04C2",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04C1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04B9",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04B7",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04B3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u04AA",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u049D",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u049B",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0497",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0496",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0473",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0458",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0457",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0456",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0455",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0454",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u044F",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u044A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0447",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0445",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0442",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u043C",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0436",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0434",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0431",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0424",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0421",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u041C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0416",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0414",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "\u0404",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: ".",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    u2: "\u2026",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    u2: "\u04C1",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    u2: "\u044A",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    u2: "\u0442",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EF",
    u2: ".",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    g2: "afii10097.var.accented",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u2026",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u201C",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u2018",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04F5",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04E5",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04E3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04DD",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04DC",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04C4",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04C2",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04C1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04B9",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04B7",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04B3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u04AA",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u049D",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u049B",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0497",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0496",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0473",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0458",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0457",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0456",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0455",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0454",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u044F",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u044A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0447",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0445",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0442",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u043C",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0436",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0434",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0431",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0424",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0421",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u041C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0416",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0414",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: "\u0404",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F0",
    u2: ".",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    u2: "\u2026",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    u2: "\u04C1",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    u2: "\u044A",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    u2: "\u0442",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F1",
    u2: ".",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    g2: "afii10097.var.accented",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u2026",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u201C",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u2018",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04F5",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04E5",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04E3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04DD",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04DC",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04C4",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04C2",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04C1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04B9",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04B7",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04B3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u04AA",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u049D",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u049B",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0497",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0496",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0473",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0458",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0457",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0456",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0455",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0454",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u044F",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u044A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0447",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0445",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0442",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u043C",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0436",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0434",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0431",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0424",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0421",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u041C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0416",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0414",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: "\u0404",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F2",
    u2: ".",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    u2: "\u2026",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    u2: "\u04C1",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    u2: "\u044A",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    u2: "\u0442",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F3",
    u2: ".",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F4",
    u2: "\u2122",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F5",
    g2: "afii10037.var.accented",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F5",
    u2: "\u04F2",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F5",
    u2: "\u04F0",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F5",
    u2: "\u04EE",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F5",
    u2: "\u04AE",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F5",
    u2: "\u0423",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F5",
    u2: "\u0422",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F5",
    u2: "\u040E",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F5",
    u2: "\u040B",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F5",
    u2: "\u0402",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F5",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F5",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F5",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F5",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F8",
    u2: "\u2122",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F9",
    g2: "afii10037.var.accented",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F9",
    u2: "\u04F2",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F9",
    u2: "\u04F0",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F9",
    u2: "\u04EE",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F9",
    u2: "\u04AE",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F9",
    u2: "\u0423",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F9",
    u2: "\u040E",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F9",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F9",
    u2: "\u04C1",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F9",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04F9",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2010",
    u2: "\u0459",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2010",
    u2: "\u0442",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2010",
    u2: "\u0434",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2010",
    u2: "\u0414",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2011",
    u2: "\u0459",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2011",
    u2: "\u0442",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2011",
    u2: "\u0434",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2011",
    u2: "\u0414",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2012",
    u2: "\u0459",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2012",
    u2: "\u0442",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2012",
    u2: "\u0434",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2012",
    u2: "\u0414",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u0459",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u0442",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u0434",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u0414",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u0459",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u0442",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u0434",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u0414",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    g2: "afii10071.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    g2: "afii10096.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    g2: "afii10093.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    g2: "afii10085.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    g2: "afii10074.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    g2: "afii10070.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    g2: "afii10065.var.accented",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    g2: "afii10047.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    g2: "afii10017.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04F9",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04F3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04F1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04EF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04DE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04D9",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04D7",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04D3",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04D2",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04D1",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04D0",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04C8",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04AF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04A3",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0498",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0493",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0491",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u045F",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u045E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u045C",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u045A",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0457",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0456",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0454",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0453",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0451",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u044E",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u044C",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u044B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0449",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0448",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0446",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0443",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u043F",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u043D",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u043B",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u043A",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0439",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0438",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0435",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0433",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0432",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0430",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u042D",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0422",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u041B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0417",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0410",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u040B",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0402",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "y",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "s",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "r",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "o",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "g",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "e",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "d",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "c",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "a",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "W",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "V",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "T",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "A",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: ",",
    k: 136
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    g2: "afii10080.var.accented",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04EB",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04E9",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04E7",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u04AB",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0473",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0459",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0444",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0441",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u043E",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u043C",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0434",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u041C",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0414",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0409",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "q",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: ".",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    g2: "afii10017.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u04D2",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u04D0",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0422",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0410",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u040B",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0402",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "o",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "g",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "e",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "d",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "c",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "a",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "W",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "V",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "T",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "A",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "q",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "A",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    g2: "afii10085.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    g2: "afii10047.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    g2: "afii10037.var.accented",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04F3",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04F2",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04F1",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04F0",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04EF",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04EE",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04DE",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04AF",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04AE",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0498",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u045E",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0443",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u042D",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0423",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0422",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0417",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u040E",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u040B",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0402",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "Y",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "W",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "V",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "T",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04F5",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04F4",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04B9",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04B8",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04B7",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u04B6",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0447",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0442",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0427",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    g2: "afii10017.var.accented",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "\u04D2",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "\u04D0",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "\u0410",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "T",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "\u040E",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    g2: "hyphenminus",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    g2: "afii10047.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u2122",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u2039",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u201C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u2018",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u04F5",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u04F4",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u04B9",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u04B8",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u04B7",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u04B6",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u04AF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u04AA",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u0459",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u044A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u0447",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u0442",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u042D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u042A",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u0427",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u0424",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u0414",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u040B",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "\u0402",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: ".",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017.var.accented",
    u2: "*",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10022.var.accented",
    u2: "\u2122",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10022.var.accented",
    u2: "\u04F5",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10022.var.accented",
    u2: "\u04B9",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10022.var.accented",
    u2: "\u04B7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10022.var.accented",
    u2: "\u0447",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10026.var.accented",
    u2: "\u2122",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10032.var.accented",
    u2: "\u2122",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10032.var.accented",
    u2: "\u2018",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10032.var.accented",
    u2: "\u04DC",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10032.var.accented",
    u2: "\u04C1",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10032.var.accented",
    u2: "\u0496",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10032.var.accented",
    u2: "\u0416",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10032.var.accented",
    u2: "\u040B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10032.var.accented",
    u2: "\u0402",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    g2: "afii10097.var.accented",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u2122",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u2026",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u201C",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u2018",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04F5",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04E5",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04E3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04DD",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04DC",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04C4",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04C2",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04C1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04B9",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04B7",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04B3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u04AA",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u049D",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u049B",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0497",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0496",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0473",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0458",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0457",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0456",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0455",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0454",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u044F",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u044A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0447",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0445",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0442",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u043C",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0436",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0434",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0431",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0424",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0421",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u041C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0416",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0414",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: "\u0404",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10037.var.accented",
    u2: ".",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10045.var.accented",
    u2: "\u2122",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    g2: "afii10047.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u04DE",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u0498",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u042D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u041B",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u0417",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u2122",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u2018",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u040B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u0409",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10047.var.accented",
    u2: "\u0402",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    g2: "afii10095.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u201D",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u2019",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u04DF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u0499",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u044D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u0437",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u2122",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u201C",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u2018",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u04F5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u04F4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u04DC",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u04C1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u04B9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u04B8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u04B7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u04B6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u0496",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u0447",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u0427",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u0416",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u040B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10048.var.accented",
    u2: "\u0402",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10049.var.accented",
    u2: "\u2122",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10023.var.accented",
    u2: "\u2122",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10023.var.accented",
    u2: "\u04F5",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10023.var.accented",
    u2: "\u04B9",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10023.var.accented",
    u2: "\u04B7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10023.var.accented",
    u2: "\u0447",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10065.var.accented",
    u2: "\u201C",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10065.var.accented",
    u2: "\u2018",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10065.var.accented",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10065.var.accented",
    u2: "\u04C1",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10065.var.accented",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10065.var.accented",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10070.var.accented",
    u2: "\u04DC",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10070.var.accented",
    u2: "\u04C1",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10070.var.accented",
    u2: "\u0496",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10070.var.accented",
    u2: "\u0416",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10074.var.accented",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10074.var.accented",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10074.var.accented",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10074.var.accented",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    g2: "afii10037.var.accented",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u04F2",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u04F0",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u04EE",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u04AE",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u0423",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u0422",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u040E",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u040B",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u0402",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u04F5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u04B9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u04B7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u0447",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u0442",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10080.var.accented",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    u2: "\u2026",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    u2: "\u04C1",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    u2: "\u044A",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    u2: "\u0442",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085.var.accented",
    u2: ".",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10093.var.accented",
    g2: "afii10037.var.accented",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10093.var.accented",
    u2: "\u04F2",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10093.var.accented",
    u2: "\u04F0",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10093.var.accented",
    u2: "\u04EE",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10093.var.accented",
    u2: "\u04AE",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10093.var.accented",
    u2: "\u0423",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10093.var.accented",
    u2: "\u040E",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10093.var.accented",
    u2: "\u04DC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10093.var.accented",
    u2: "\u04C1",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10093.var.accented",
    u2: "\u0496",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10093.var.accented",
    u2: "\u0416",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    g2: "afii10037.var.accented",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u04F2",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u04F0",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u04EE",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u04AE",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u0423",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u0422",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u040E",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u040B",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u0402",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u04DC",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u04C1",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u0496",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u0442",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10095.var.accented",
    u2: "\u0416",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    g2: "afii10037.var.accented",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    g2: "afii10017.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u04F2",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u04F0",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u04EE",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u04D2",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u04D0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u04AE",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u0423",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u0422",
    k: 105
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u041B",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u0410",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u040E",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u040B",
    k: 105
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u0409",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u0402",
    k: 105
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u04DC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u04C1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u0496",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u0442",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10096.var.accented",
    u2: "\u0416",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10097.var.accented",
    g2: "afii10037.var.accented",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10097.var.accented",
    u2: "\u04F2",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10097.var.accented",
    u2: "\u04F0",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10097.var.accented",
    u2: "\u04EE",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10097.var.accented",
    u2: "\u04AE",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10097.var.accented",
    u2: "\u0423",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10097.var.accented",
    u2: "\u0422",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10097.var.accented",
    u2: "\u040E",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10097.var.accented",
    u2: "\u040B",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10097.var.accented",
    u2: "\u0402",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10097.var.accented",
    u2: "\u04DD",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10097.var.accented",
    u2: "\u04DC",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10097.var.accented",
    u2: "\u04C2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10097.var.accented",
    u2: "\u04C1",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10097.var.accented",
    u2: "\u0497",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10097.var.accented",
    u2: "\u0496",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10097.var.accented",
    u2: "\u0436",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10097.var.accented",
    u2: "\u0416",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10071.var.accented",
    u2: "\u04DC",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10071.var.accented",
    u2: "\u04C1",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10071.var.accented",
    u2: "\u0496",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10071.var.accented",
    u2: "\u0416",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    g2: "afii10071.var.accented",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    g2: "afii10096.var.accented",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    g2: "afii10095.var.accented",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    g2: "afii10093.var.accented",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    g2: "afii10085.var.accented",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    g2: "afii10080.var.accented",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    g2: "afii10074.var.accented",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    g2: "afii10070.var.accented",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    g2: "afii10065.var.accented",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    g2: "afii10047.var.accented",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    g2: "afii10017.var.accented",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04F9",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04F3",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04F1",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04EF",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04EB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04E9",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04E7",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04DF",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04DE",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04D9",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04D7",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04D3",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04D2",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04D1",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04D0",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04C8",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04AF",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04AB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04A3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0499",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0498",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0493",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0491",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u045F",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u045E",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u045C",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u045A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0459",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0458",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0457",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0456",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0454",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0453",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0451",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u044E",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u044D",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u044C",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u044B",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0449",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0448",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0446",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0444",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0443",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0441",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0440",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u043F",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u043E",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u043D",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u043B",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u043A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0439",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0438",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0437",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0435",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0433",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0432",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0430",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u042D",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u041B",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0417",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0410",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0409",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: ",",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    g2: "afii10097.var.accented",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u2026",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04F5",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04E5",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04E3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04DD",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04C4",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04C2",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04B9",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04B7",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u04B3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u049D",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u049B",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0497",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0473",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u044F",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0447",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0445",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0442",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u043C",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0436",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0434",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0431",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: "\u0414",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF4CC",
    u2: ".",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BA",
    u2: "\u0459",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BA",
    u2: "\u0442",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BA",
    u2: "\u0434",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BA",
    u2: "\u0414",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BB",
    u2: "\u0459",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BB",
    u2: "\u0442",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BB",
    u2: "\u0434",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BB",
    u2: "\u0414",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BC",
    u2: "\u0459",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BC",
    u2: "\u0442",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BC",
    u2: "\u0434",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uF6BC",
    u2: "\u0414",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    g2: "afii10017.var.accented",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u04D2",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u04D0",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u0422",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u0410",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u040B",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u0402",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "T",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u0459",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u0442",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u0434",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphenminus",
    u2: "\u0414",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A",
    g2: "comma,period",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A",
    g2: "C",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A",
    g2: "G",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A",
    g2: "O",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A",
    g2: "S",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A",
    g2: "T",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A",
    g2: "U",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A",
    g2: "V",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A",
    g2: "W",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A",
    g2: "Y",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A",
    g2: "Z",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A",
    g2: "a",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A",
    g2: "c",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A",
    g2: "d",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A",
    g2: "e",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A",
    g2: "o",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A",
    g2: "s",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A",
    g2: "t",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A",
    g2: "u",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A",
    g2: "w",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A",
    g2: "y",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A",
    g2: "quoteright,quotedblright",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C",
    g2: "C",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C",
    g2: "G",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C",
    g2: "O",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C",
    g2: "Y",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C",
    g2: "Z",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C",
    g2: "a",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C",
    g2: "c",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C",
    g2: "d",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C",
    g2: "e",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C",
    g2: "o",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C",
    g2: "s",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C",
    g2: "u",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C",
    g2: "w",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C",
    g2: "y",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C",
    g2: "quoteright,quotedblright",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C",
    g2: "A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C",
    g2: "g",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C",
    g2: "z",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D",
    g2: "T",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D",
    g2: "V",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D",
    g2: "Y",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D",
    g2: "Z",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D",
    g2: "A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D",
    g2: "z",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E",
    g2: "a",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E",
    g2: "c",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E",
    g2: "d",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E",
    g2: "e",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E",
    g2: "o",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E",
    g2: "s",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E",
    g2: "u",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E",
    g2: "w",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E",
    g2: "g",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E",
    g2: "z",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G",
    g2: "T",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G",
    g2: "Y",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G",
    g2: "Z",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G",
    g2: "quoteright,quotedblright",
    k: -53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G",
    g2: "A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J",
    g2: "s",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J",
    g2: "w",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J",
    g2: "y",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J",
    g2: "z",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "C",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "G",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "O",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "S",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "U",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "V",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "W",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "Y",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "a",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "c",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "d",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "e",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "o",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "s",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "t",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "u",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "w",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "y",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "g",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "G",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "O",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "S",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "T",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "V",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "W",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "Y",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "a",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "c",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "d",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "e",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "o",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "t",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "u",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "w",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "y",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "A",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "g",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "N",
    g2: "z",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O",
    g2: "T",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O",
    g2: "Y",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O",
    g2: "Z",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O",
    g2: "quoteright,quotedblright",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O",
    g2: "A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O",
    g2: "z",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R",
    g2: "O",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R",
    g2: "T",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R",
    g2: "V",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R",
    g2: "W",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R",
    g2: "Y",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R",
    g2: "a",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R",
    g2: "c",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R",
    g2: "d",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R",
    g2: "e",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R",
    g2: "o",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R",
    g2: "s",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R",
    g2: "t",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R",
    g2: "u",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R",
    g2: "w",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R",
    g2: "y",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R",
    g2: "A",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R",
    g2: "g",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R",
    g2: "z",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R",
    g2: "h,n",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R",
    g2: "r",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S",
    g2: "O",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S",
    g2: "S",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S",
    g2: "T",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S",
    g2: "V",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S",
    g2: "W",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S",
    g2: "Y",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S",
    g2: "w",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S",
    g2: "y",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S",
    g2: "z",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "comma,period",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "G",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "O",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "S",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "T",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "Y",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "a",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "c",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "d",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "e",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "o",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "s",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "t",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "u",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "w",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "y",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "A",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "g",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "z",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "h,n",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "r",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "i",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U",
    g2: "Z",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U",
    g2: "z",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "comma,period",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "S",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "a",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "c",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "d",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "e",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "o",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "s",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "t",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "u",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "w",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "y",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "g",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "z",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "h,n",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "r",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "comma,period",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "G",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "S",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "a",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "c",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "d",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "e",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "o",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "s",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "t",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "u",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "w",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "y",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "A",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "g",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "z",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "h,n",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "r",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "i",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "comma,period",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "C",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "G",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "O",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "S",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "T",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "a",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "c",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "d",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "e",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "o",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "s",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "t",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "u",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "w",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "y",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "A",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "g",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "z",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "h,n",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "r",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "i",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y",
    g2: "colon,semicolon",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "C",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "G",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "O",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "S",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "a",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "c",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "d",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "e",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "o",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "s",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "t",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "u",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "w",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "y",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "g",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a",
    g2: "T",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a",
    g2: "V",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a",
    g2: "Y",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a",
    g2: "quoteright,quotedblright",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a",
    g2: "z",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b",
    g2: "T",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b",
    g2: "V",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b",
    g2: "W",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b",
    g2: "Y",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b",
    g2: "y",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b",
    g2: "A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b",
    g2: "z",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c",
    g2: "T",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c",
    g2: "V",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c",
    g2: "W",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c",
    g2: "Y",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c",
    g2: "z",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e",
    g2: "T",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e",
    g2: "V",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e",
    g2: "W",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e",
    g2: "Y",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e",
    g2: "y",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e",
    g2: "z",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e",
    g2: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "t",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "w",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "y",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "quoteright,quotedblright",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "z",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g",
    g2: "T",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g",
    g2: "V",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g",
    g2: "Y",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "i",
    g2: "z",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,k",
    g2: "C",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,k",
    g2: "G",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,k",
    g2: "T",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,k",
    g2: "U",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,k",
    g2: "V",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,k",
    g2: "W",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,k",
    g2: "Y",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,k",
    g2: "a",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,k",
    g2: "c",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,k",
    g2: "d",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,k",
    g2: "e",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,k",
    g2: "o",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,k",
    g2: "s",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,k",
    g2: "t",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,k",
    g2: "u",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,k",
    g2: "w",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,k",
    g2: "y",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,k",
    g2: "g",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,k",
    g2: "z",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,k",
    g2: "h,n",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,k",
    g2: "r",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,k",
    g2: "i",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,k",
    g2: "l",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l",
    g2: "z",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "n",
    g2: "T",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "n",
    g2: "V",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "n",
    g2: "W",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "n",
    g2: "Y",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o",
    g2: "T",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o",
    g2: "V",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o",
    g2: "Y",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o",
    g2: "z",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "comma,period",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "T",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "V",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "W",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "Y",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "a",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "o",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "s",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "u",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "w",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "y",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "g",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "z",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s",
    g2: "T",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s",
    g2: "V",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s",
    g2: "Y",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t",
    g2: "T",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t",
    g2: "Y",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t",
    g2: "t",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t",
    g2: "w",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t",
    g2: "y",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t",
    g2: "z",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u",
    g2: "T",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u",
    g2: "V",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u",
    g2: "Y",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u",
    g2: "z",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "comma,period",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "T",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "V",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "Y",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "z",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "colon,semicolon",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y",
    g2: "comma,period",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y",
    g2: "T",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y",
    g2: "V",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y",
    g2: "W",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y",
    g2: "Y",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y",
    g2: "s",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y",
    g2: "t",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y",
    g2: "y",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y",
    g2: "z",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y",
    g2: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z",
    g2: "T",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z",
    g2: "V",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z",
    g2: "W",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z",
    g2: "Y",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z",
    g2: "a",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z",
    g2: "c",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z",
    g2: "d",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z",
    g2: "e",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z",
    g2: "o",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z",
    g2: "s",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z",
    g2: "u",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z",
    g2: "g",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z",
    g2: "z",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "T",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "V",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "W",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "a",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "c",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "d",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "e",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "o",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "afii10051,afii10060,afii10036",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    g2: "T",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    g2: "V",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    g2: "W",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    g2: "Y",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    g2: "y",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    g2: "afii10051,afii10060,afii10036",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    g2: "afii10058,afii10029",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    g2: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    g2: "comma,period",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    g2: "quoteright,quotedblright",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    g2: "afii10051,afii10060,afii10036",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    g2: "afii10058,afii10029",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    g2: "afii10025,afii10047,uni0498,uni04DE,afii10047.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    g2: "afii10053,afii10032,afii10035,uni04AA,uni04D8,uni04E6,uni04E8,uni04EA,afii10032.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    g2: "afii10073,afii10095,uni0499,uni04DF,afii10095.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    g2: "afii10077,afii10106",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10019,afii10025,uni0498,uni04DE",
    g2: "afii10051,afii10060,afii10036",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10019,afii10025,uni0498,uni04DE",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10019,afii10025,uni0498,uni04DE",
    g2: "afii10025,afii10047,uni0498,uni04DE,afii10047.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "comma,period",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "quoteright,quotedblright",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "colon,semicolon",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "afii10051,afii10060,afii10036",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "afii10058,afii10029",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "afii10025,afii10047,uni0498,uni04DE,afii10047.var.accented",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "afii10053,afii10032,afii10035,uni04AA,uni04D8,uni04E6,uni04E8,uni04EA,afii10032.var.accented",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "afii10073,afii10095,uni0499,uni04DF,afii10095.var.accented",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "afii10077,afii10106",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "afii10065,uni04D1,uni04D3,afii10065.var.accented",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "afii10067,afii10068,afii10074,afii10075,afii10076,afii10079,afii10081,afii10088,afii10090,afii10091,afii10093,afii10094,afii10096,afii10100,afii10103,afii10104,afii10107,afii10109,afii10193,afii10098,uni0493,uni04A3,uni04C8,uni04F9,afii10074.var.accented,afii10093.var.accented,afii10096.var.accented",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "afii10070,afii10080,afii10083,afii10086,afii10071,afii10101,uni04AB,uni04D7,afii10846,uni04E7,uni04E9,uni04EB,afii10070.var.accented,afii10080.var.accented,afii10071.var.accented",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "afii10082,afii10105",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10052,afii10020,afii10050,uni0492",
    g2: "afii10099,afii10108,uni04BB",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10061,afii10024,afii10028,uni0496,uni049A,uni049C,uni04C1,uni04C3,uni04DC",
    g2: "afii10051,afii10060,afii10036",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10061,afii10024,afii10028,uni0496,uni049A,uni049C,uni04C1,uni04C3,uni04DC",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10061,afii10024,afii10028,uni0496,uni049A,uni049C,uni04C1,uni04C3,uni04DC",
    g2: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10061,afii10024,afii10028,uni0496,uni049A,uni049C,uni04C1,uni04C3,uni04DC",
    g2: "afii10025,afii10047,uni0498,uni04DE,afii10047.var.accented",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10061,afii10024,afii10028,uni0496,uni049A,uni049C,uni04C1,uni04C3,uni04DC",
    g2: "afii10053,afii10032,afii10035,uni04AA,uni04D8,uni04E6,uni04E8,uni04EA,afii10032.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10061,afii10024,afii10028,uni0496,uni049A,uni049C,uni04C1,uni04C3,uni04DC",
    g2: "afii10073,afii10095,uni0499,uni04DF,afii10095.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10061,afii10024,afii10028,uni0496,uni049A,uni049C,uni04C1,uni04C3,uni04DC",
    g2: "afii10065,uni04D1,uni04D3,afii10065.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10061,afii10024,afii10028,uni0496,uni049A,uni049C,uni04C1,uni04C3,uni04DC",
    g2: "afii10067,afii10068,afii10074,afii10075,afii10076,afii10079,afii10081,afii10088,afii10090,afii10091,afii10093,afii10094,afii10096,afii10100,afii10103,afii10104,afii10107,afii10109,afii10193,afii10098,uni0493,uni04A3,uni04C8,uni04F9,afii10074.var.accented,afii10093.var.accented,afii10096.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10061,afii10024,afii10028,uni0496,uni049A,uni049C,uni04C1,uni04C3,uni04DC",
    g2: "afii10070,afii10080,afii10083,afii10086,afii10071,afii10101,uni04AB,uni04D7,afii10846,uni04E7,uni04E9,uni04EB,afii10070.var.accented,afii10080.var.accented,afii10071.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10061,afii10024,afii10028,uni0496,uni049A,uni049C,uni04C1,uni04C3,uni04DC",
    g2: "afii10082,afii10105",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10032,afii10047,afii10048,uni04D8,uni04E6,uni04E8,uni04EA,afii10032.var.accented,afii10047.var.accented,afii10048.var.accented",
    g2: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10032,afii10047,afii10048,uni04D8,uni04E6,uni04E8,uni04EA,afii10032.var.accented,afii10047.var.accented,afii10048.var.accented",
    g2: "afii10051,afii10060,afii10036",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10032,afii10047,afii10048,uni04D8,uni04E6,uni04E8,uni04EA,afii10032.var.accented,afii10047.var.accented,afii10048.var.accented",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10032,afii10047,afii10048,uni04D8,uni04E6,uni04E8,uni04EA,afii10032.var.accented,afii10047.var.accented,afii10048.var.accented",
    g2: "afii10025,afii10047,uni0498,uni04DE,afii10047.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10032,afii10047,afii10048,uni04D8,uni04E6,uni04E8,uni04EA,afii10032.var.accented,afii10047.var.accented,afii10048.var.accented",
    g2: "afii10073,afii10095,uni0499,uni04DF,afii10095.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10053,afii10035,uni04AA",
    g2: "quoteright,quotedblright",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10053,afii10035,uni04AA",
    g2: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10053,afii10035,uni04AA",
    g2: "afii10058,afii10029",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10053,afii10035,uni04AA",
    g2: "afii10025,afii10047,uni0498,uni04DE,afii10047.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "comma,period",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "quoteright,quotedblright",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "afii10051,afii10060,afii10036",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "afii10058,afii10029",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "afii10025,afii10047,uni0498,uni04DE,afii10047.var.accented",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "afii10073,afii10095,uni0499,uni04DF,afii10095.var.accented",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "afii10077,afii10106",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "afii10065,uni04D1,uni04D3,afii10065.var.accented",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "afii10067,afii10068,afii10074,afii10075,afii10076,afii10079,afii10081,afii10088,afii10090,afii10091,afii10093,afii10094,afii10096,afii10100,afii10103,afii10104,afii10107,afii10109,afii10193,afii10098,uni0493,uni04A3,uni04C8,uni04F9,afii10074.var.accented,afii10093.var.accented,afii10096.var.accented",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "afii10070,afii10080,afii10083,afii10086,afii10071,afii10101,uni04AB,uni04D7,afii10846,uni04E7,uni04E9,uni04EB,afii10070.var.accented,afii10080.var.accented,afii10071.var.accented",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "afii10082,afii10105",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    g2: "afii10099,afii10108,uni04BB",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10058,afii10059,afii10044,afii10046",
    g2: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10058,afii10059,afii10044,afii10046",
    g2: "afii10051,afii10060,afii10036",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10058,afii10059,afii10044,afii10046",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10058,afii10059,afii10044,afii10046",
    g2: "afii10058,afii10029",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10058,afii10059,afii10044,afii10046",
    g2: "afii10025,afii10047,uni0498,uni04DE,afii10047.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10058,afii10059,afii10044,afii10046",
    g2: "afii10053,afii10032,afii10035,uni04AA,uni04D8,uni04E6,uni04E8,uni04EA,afii10032.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10065,uni04D1,uni04D3,afii10065.var.accented",
    g2: "quoteright,quotedblright",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10065,uni04D1,uni04D3,afii10065.var.accented",
    g2: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10065,uni04D1,uni04D3,afii10065.var.accented",
    g2: "afii10051,afii10060,afii10036",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10065,uni04D1,uni04D3,afii10065.var.accented",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10066,afii10080,afii10082,afii10086,afii10095,afii10096,afii10846,uni04E7,uni04E9,uni04EB,afii10080.var.accented,afii10095.var.accented,afii10096.var.accented",
    g2: "afii10051,afii10060,afii10036",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10066,afii10080,afii10082,afii10086,afii10095,afii10096,afii10846,uni04E7,uni04E9,uni04EB,afii10080.var.accented,afii10095.var.accented,afii10096.var.accented",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10066,afii10080,afii10082,afii10086,afii10095,afii10096,afii10846,uni04E7,uni04E9,uni04EB,afii10080.var.accented,afii10095.var.accented,afii10096.var.accented",
    g2: "afii10073,afii10095,uni0499,uni04DF,afii10095.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10067,afii10073,uni0499,uni04DF",
    g2: "afii10051,afii10060,afii10036",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10067,afii10073,uni0499,uni04DF",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10067,afii10073,uni0499,uni04DF",
    g2: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10067,afii10073,uni0499,uni04DF",
    g2: "afii10073,afii10095,uni0499,uni04DF,afii10095.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10068,afii10100,afii10098,uni0493",
    g2: "comma,period",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10068,afii10100,afii10098,uni0493",
    g2: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10068,afii10100,afii10098,uni0493",
    g2: "colon,semicolon",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10068,afii10100,afii10098,uni0493",
    g2: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10068,afii10100,afii10098,uni0493",
    g2: "afii10051,afii10060,afii10036",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10068,afii10100,afii10098,uni0493",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10068,afii10100,afii10098,uni0493",
    g2: "afii10058,afii10029",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10068,afii10100,afii10098,uni0493",
    g2: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10068,afii10100,afii10098,uni0493",
    g2: "afii10073,afii10095,uni0499,uni04DF,afii10095.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10068,afii10100,afii10098,uni0493",
    g2: "afii10077,afii10106",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10068,afii10100,afii10098,uni0493",
    g2: "afii10065,uni04D1,uni04D3,afii10065.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10068,afii10100,afii10098,uni0493",
    g2: "afii10070,afii10080,afii10083,afii10086,afii10071,afii10101,uni04AB,uni04D7,afii10846,uni04E7,uni04E9,uni04EB,afii10070.var.accented,afii10080.var.accented,afii10071.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10070,afii10071,uni04D7,afii10070.var.accented,afii10071.var.accented",
    g2: "afii10051,afii10060,afii10036",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10070,afii10071,uni04D7,afii10070.var.accented,afii10071.var.accented",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10070,afii10071,uni04D7,afii10070.var.accented,afii10071.var.accented",
    g2: "afii10073,afii10095,uni0499,uni04DF,afii10095.var.accented",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10072,afii10076,afii10109,uni0497,uni049B,uni049D,uni04C2,uni04C4,uni04DD",
    g2: "afii10051,afii10060,afii10036",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10072,afii10076,afii10109,uni0497,uni049B,uni049D,uni04C2,uni04C4,uni04DD",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10072,afii10076,afii10109,uni0497,uni049B,uni049D,uni04C2,uni04C4,uni04DD",
    g2: "afii10073,afii10095,uni0499,uni04DF,afii10095.var.accented",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10072,afii10076,afii10109,uni0497,uni049B,uni049D,uni04C2,uni04C4,uni04DD",
    g2: "afii10065,uni04D1,uni04D3,afii10065.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10072,afii10076,afii10109,uni0497,uni049B,uni049D,uni04C2,uni04C4,uni04DD",
    g2: "afii10070,afii10080,afii10083,afii10086,afii10071,afii10101,uni04AB,uni04D7,afii10846,uni04E7,uni04E9,uni04EB,afii10070.var.accented,afii10080.var.accented,afii10071.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10074,afii10075,afii10079,afii10081,afii10089,afii10090,afii10093,afii10097,afii10193,uni04A3,uni04B7,uni04B9,uni04BB,uni04C8,uni04E3,uni04E5,uni04F5,uni04F9,afii10074.var.accented,afii10093.var.accented,afii10097.var.accented",
    g2: "afii10051,afii10060,afii10036",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10074,afii10075,afii10079,afii10081,afii10089,afii10090,afii10093,afii10097,afii10193,uni04A3,uni04B7,uni04B9,uni04BB,uni04C8,uni04E3,uni04E5,uni04F5,uni04F9,afii10074.var.accented,afii10093.var.accented,afii10097.var.accented",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10083,afii10101,uni04AB",
    g2: "afii10051,afii10060,afii10036",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10083,afii10101,uni04AB",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10083,afii10101,uni04AB",
    g2: "afii10073,afii10095,uni0499,uni04DF,afii10095.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    g2: "comma,period",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    g2: "hyphen,uni2010,uni2011,figuredash,endash,emdash,uniF6BA,uniF6BB,uniF6BC,hyphenminus",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    g2: "afii10051,afii10060,afii10036",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    g2: "afii10073,afii10095,uni0499,uni04DF,afii10095.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10092,afii10094,afii10106,afii10107",
    g2: "quoteright,quotedblright",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10092,afii10094,afii10106,afii10107",
    g2: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10092,afii10094,afii10106,afii10107",
    g2: "afii10051,afii10060,afii10036",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10092,afii10094,afii10106,afii10107",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 136
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10092,afii10094,afii10106,afii10107",
    g2: "afii10058,afii10029",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10092,afii10094,afii10106,afii10107",
    g2: "afii10085,afii10110,uni04AF,uni04EF,uni04F1,uni04F3,afii10085.var.accented",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10092,afii10094,afii10106,afii10107",
    g2: "afii10073,afii10095,uni0499,uni04DF,afii10095.var.accented",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10092,afii10094,afii10106,afii10107",
    g2: "afii10067,afii10068,afii10074,afii10075,afii10076,afii10079,afii10081,afii10088,afii10090,afii10091,afii10093,afii10094,afii10096,afii10100,afii10103,afii10104,afii10107,afii10109,afii10193,afii10098,uni0493,uni04A3,uni04C8,uni04F9,afii10074.var.accented,afii10093.var.accented,afii10096.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10092,afii10094,afii10106,afii10107",
    g2: "afii10099,afii10108,uni04BB",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10060,uni04BA",
    g2: "quoteright,quotedblright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10060,uni04BA",
    g2: "afii10017,uni04D0,uni04D2,afii10017.var.accented",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10060,uni04BA",
    g2: "afii10051,afii10060,afii10036",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10060,uni04BA",
    g2: "afii10062,afii10037,uni04AE,uni04EE,uni04F0,uni04F2,afii10037.var.accented",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "afii10060,uni04BA",
    g2: "afii10053,afii10032,afii10035,uni04AA,uni04D8,uni04E6,uni04E8,uni04EA,afii10032.var.accented",
    k: 11
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuturaCyrillicLight);
export default __webpack_public_path__ + "static/media/FuturaCyrillicLight.6fbe3e0eddda121fa3ae4fd559b728e7.svg";
export { ForwardRef as ReactComponent };